var _objectWithoutProperties = require("/data/var/lib/jenkins/workspace/TMI-Portal-CustomerEngage_AccountManagement_warfilebuild_UAT/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _slicedToArray = require("/data/var/lib/jenkins/workspace/TMI-Portal-CustomerEngage_AccountManagement_warfilebuild_UAT/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _regeneratorRuntime = require("/data/var/lib/jenkins/workspace/TMI-Portal-CustomerEngage_AccountManagement_warfilebuild_UAT/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _defineProperty = require("/data/var/lib/jenkins/workspace/TMI-Portal-CustomerEngage_AccountManagement_warfilebuild_UAT/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _toConsumableArray = require("/data/var/lib/jenkins/workspace/TMI-Portal-CustomerEngage_AccountManagement_warfilebuild_UAT/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

module.exports = function (modules) {
  var installedModules = {};

  function __webpack_require__(moduleId) {
    if (installedModules[moduleId]) return installedModules[moduleId].exports;
    var module = installedModules[moduleId] = {
      i: moduleId,
      l: !1,
      exports: {}
    };
    return modules[moduleId].call(module.exports, module, module.exports, __webpack_require__), module.l = !0, module.exports;
  }

  return __webpack_require__.m = modules, __webpack_require__.c = installedModules, __webpack_require__.d = function (exports, name, getter) {
    __webpack_require__.o(exports, name) || Object.defineProperty(exports, name, {
      enumerable: !0,
      get: getter
    });
  }, __webpack_require__.r = function (exports) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(exports, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(exports, "__esModule", {
      value: !0
    });
  }, __webpack_require__.t = function (value, mode) {
    if (1 & mode && (value = __webpack_require__(value)), 8 & mode) return value;
    if (4 & mode && "object" == typeof value && value && value.__esModule) return value;
    var ns = Object.create(null);
    if (__webpack_require__.r(ns), Object.defineProperty(ns, "default", {
      enumerable: !0,
      value: value
    }), 2 & mode && "string" != typeof value) for (var key in value) {
      __webpack_require__.d(ns, key, function (key) {
        return value[key];
      }.bind(null, key));
    }
    return ns;
  }, __webpack_require__.n = function (module) {
    var getter = module && module.__esModule ? function () {
      return module.default;
    } : function () {
      return module;
    };
    return __webpack_require__.d(getter, "a", getter), getter;
  }, __webpack_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  }, __webpack_require__.p = "", __webpack_require__(__webpack_require__.s = "./index.js");
}({
  "../../node_modules/@babel/runtime-corejs3/core-js/array/from.js": function node_modulesBabelRuntimeCorejs3CoreJsArrayFromJs(module, exports, __webpack_require__) {
    module.exports = __webpack_require__("core-js-pure/features/array/from");
  },
  "../../node_modules/@babel/runtime-corejs3/core-js/array/is-array.js": function node_modulesBabelRuntimeCorejs3CoreJsArrayIsArrayJs(module, exports, __webpack_require__) {
    module.exports = __webpack_require__("core-js-pure/features/array/is-array");
  },
  "../../node_modules/@babel/runtime-corejs3/core-js/get-iterator.js": function node_modulesBabelRuntimeCorejs3CoreJsGetIteratorJs(module, exports, __webpack_require__) {
    module.exports = __webpack_require__("core-js-pure/features/get-iterator");
  },
  "../../node_modules/@babel/runtime-corejs3/core-js/instance/index-of.js": function node_modulesBabelRuntimeCorejs3CoreJsInstanceIndexOfJs(module, exports, __webpack_require__) {
    module.exports = __webpack_require__("core-js-pure/features/instance/index-of");
  },
  "../../node_modules/@babel/runtime-corejs3/core-js/instance/slice.js": function node_modulesBabelRuntimeCorejs3CoreJsInstanceSliceJs(module, exports, __webpack_require__) {
    module.exports = __webpack_require__("core-js-pure/features/instance/slice");
  },
  "../../node_modules/@babel/runtime-corejs3/core-js/is-iterable.js": function node_modulesBabelRuntimeCorejs3CoreJsIsIterableJs(module, exports, __webpack_require__) {
    module.exports = __webpack_require__("core-js-pure/features/is-iterable");
  },
  "../../node_modules/@babel/runtime-corejs3/core-js/object/define-property.js": function node_modulesBabelRuntimeCorejs3CoreJsObjectDefinePropertyJs(module, exports, __webpack_require__) {
    module.exports = __webpack_require__("core-js-pure/features/object/define-property");
  },
  "../../node_modules/@babel/runtime-corejs3/core-js/object/get-own-property-symbols.js": function node_modulesBabelRuntimeCorejs3CoreJsObjectGetOwnPropertySymbolsJs(module, exports, __webpack_require__) {
    module.exports = __webpack_require__("core-js-pure/features/object/get-own-property-symbols");
  },
  "../../node_modules/@babel/runtime-corejs3/core-js/object/get-prototype-of.js": function node_modulesBabelRuntimeCorejs3CoreJsObjectGetPrototypeOfJs(module, exports, __webpack_require__) {
    module.exports = __webpack_require__("core-js-pure/features/object/get-prototype-of");
  },
  "../../node_modules/@babel/runtime-corejs3/core-js/object/keys.js": function node_modulesBabelRuntimeCorejs3CoreJsObjectKeysJs(module, exports, __webpack_require__) {
    module.exports = __webpack_require__("core-js-pure/features/object/keys");
  },
  "../../node_modules/@babel/runtime-corejs3/core-js/object/set-prototype-of.js": function node_modulesBabelRuntimeCorejs3CoreJsObjectSetPrototypeOfJs(module, exports, __webpack_require__) {
    module.exports = __webpack_require__("core-js-pure/features/object/set-prototype-of");
  },
  "../../node_modules/@babel/runtime-corejs3/core-js/symbol.js": function node_modulesBabelRuntimeCorejs3CoreJsSymbolJs(module, exports, __webpack_require__) {
    module.exports = __webpack_require__("core-js-pure/features/symbol");
  },
  "../../node_modules/@babel/runtime-corejs3/core-js/symbol/iterator.js": function node_modulesBabelRuntimeCorejs3CoreJsSymbolIteratorJs(module, exports, __webpack_require__) {
    module.exports = __webpack_require__("core-js-pure/features/symbol/iterator");
  },
  "../../node_modules/@babel/runtime-corejs3/helpers/arrayLikeToArray.js": function node_modulesBabelRuntimeCorejs3HelpersArrayLikeToArrayJs(module, exports) {
    module.exports = function (arr, len) {
      (null == len || len > arr.length) && (len = arr.length);

      for (var i = 0, arr2 = new Array(len); i < len; i++) {
        arr2[i] = arr[i];
      }

      return arr2;
    };
  },
  "../../node_modules/@babel/runtime-corejs3/helpers/arrayWithHoles.js": function node_modulesBabelRuntimeCorejs3HelpersArrayWithHolesJs(module, exports, __webpack_require__) {
    var _Array$isArray = __webpack_require__("../../node_modules/@babel/runtime-corejs3/core-js/array/is-array.js");

    module.exports = function (arr) {
      if (_Array$isArray(arr)) return arr;
    };
  },
  "../../node_modules/@babel/runtime-corejs3/helpers/assertThisInitialized.js": function node_modulesBabelRuntimeCorejs3HelpersAssertThisInitializedJs(module, exports) {
    module.exports = function (self) {
      if (void 0 === self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return self;
    };
  },
  "../../node_modules/@babel/runtime-corejs3/helpers/classCallCheck.js": function node_modulesBabelRuntimeCorejs3HelpersClassCallCheckJs(module, exports) {
    module.exports = function (instance, Constructor) {
      if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    };
  },
  "../../node_modules/@babel/runtime-corejs3/helpers/createClass.js": function node_modulesBabelRuntimeCorejs3HelpersCreateClassJs(module, exports, __webpack_require__) {
    var _Object$defineProperty = __webpack_require__("../../node_modules/@babel/runtime-corejs3/core-js/object/define-property.js");

    function _defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, "value" in descriptor && (descriptor.writable = !0), _Object$defineProperty(target, descriptor.key, descriptor);
      }
    }

    module.exports = function (Constructor, protoProps, staticProps) {
      return protoProps && _defineProperties(Constructor.prototype, protoProps), staticProps && _defineProperties(Constructor, staticProps), Constructor;
    };
  },
  "../../node_modules/@babel/runtime-corejs3/helpers/defineProperty.js": function node_modulesBabelRuntimeCorejs3HelpersDefinePropertyJs(module, exports, __webpack_require__) {
    var _Object$defineProperty = __webpack_require__("../../node_modules/@babel/runtime-corejs3/core-js/object/define-property.js");

    module.exports = function (obj, key, value) {
      return key in obj ? _Object$defineProperty(obj, key, {
        value: value,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : obj[key] = value, obj;
    };
  },
  "../../node_modules/@babel/runtime-corejs3/helpers/getPrototypeOf.js": function node_modulesBabelRuntimeCorejs3HelpersGetPrototypeOfJs(module, exports, __webpack_require__) {
    var _Object$getPrototypeOf = __webpack_require__("../../node_modules/@babel/runtime-corejs3/core-js/object/get-prototype-of.js"),
        _Object$setPrototypeOf = __webpack_require__("../../node_modules/@babel/runtime-corejs3/core-js/object/set-prototype-of.js");

    function _getPrototypeOf(o) {
      return module.exports = _getPrototypeOf = _Object$setPrototypeOf ? _Object$getPrototypeOf : function (o) {
        return o.__proto__ || _Object$getPrototypeOf(o);
      }, _getPrototypeOf(o);
    }

    module.exports = _getPrototypeOf;
  },
  "../../node_modules/@babel/runtime-corejs3/helpers/iterableToArrayLimit.js": function node_modulesBabelRuntimeCorejs3HelpersIterableToArrayLimitJs(module, exports, __webpack_require__) {
    var _getIterator = __webpack_require__("../../node_modules/@babel/runtime-corejs3/core-js/get-iterator.js"),
        _isIterable = __webpack_require__("../../node_modules/@babel/runtime-corejs3/core-js/is-iterable.js"),
        _Symbol = __webpack_require__("../../node_modules/@babel/runtime-corejs3/core-js/symbol.js");

    module.exports = function (arr, i) {
      if (void 0 !== _Symbol && _isIterable(Object(arr))) {
        var _arr = [],
            _n = !0,
            _d = !1,
            _e = void 0;

        try {
          for (var _s, _i = _getIterator(arr); !(_n = (_s = _i.next()).done) && (_arr.push(_s.value), !i || _arr.length !== i); _n = !0) {
            ;
          }
        } catch (err) {
          _d = !0, _e = err;
        } finally {
          try {
            _n || null == _i.return || _i.return();
          } finally {
            if (_d) throw _e;
          }
        }

        return _arr;
      }
    };
  },
  "../../node_modules/@babel/runtime-corejs3/helpers/nonIterableRest.js": function node_modulesBabelRuntimeCorejs3HelpersNonIterableRestJs(module, exports) {
    module.exports = function () {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    };
  },
  "../../node_modules/@babel/runtime-corejs3/helpers/objectWithoutProperties.js": function node_modulesBabelRuntimeCorejs3HelpersObjectWithoutPropertiesJs(module, exports, __webpack_require__) {
    var _indexOfInstanceProperty = __webpack_require__("../../node_modules/@babel/runtime-corejs3/core-js/instance/index-of.js"),
        _Object$getOwnPropertySymbols = __webpack_require__("../../node_modules/@babel/runtime-corejs3/core-js/object/get-own-property-symbols.js"),
        objectWithoutPropertiesLoose = __webpack_require__("../../node_modules/@babel/runtime-corejs3/helpers/objectWithoutPropertiesLoose.js");

    module.exports = function (source, excluded) {
      if (null == source) return {};
      var key,
          i,
          target = objectWithoutPropertiesLoose(source, excluded);

      if (_Object$getOwnPropertySymbols) {
        var sourceSymbolKeys = _Object$getOwnPropertySymbols(source);

        for (i = 0; i < sourceSymbolKeys.length; i++) {
          key = sourceSymbolKeys[i], _indexOfInstanceProperty(excluded).call(excluded, key) >= 0 || Object.prototype.propertyIsEnumerable.call(source, key) && (target[key] = source[key]);
        }
      }

      return target;
    };
  },
  "../../node_modules/@babel/runtime-corejs3/helpers/objectWithoutPropertiesLoose.js": function node_modulesBabelRuntimeCorejs3HelpersObjectWithoutPropertiesLooseJs(module, exports, __webpack_require__) {
    var _indexOfInstanceProperty = __webpack_require__("../../node_modules/@babel/runtime-corejs3/core-js/instance/index-of.js"),
        _Object$keys = __webpack_require__("../../node_modules/@babel/runtime-corejs3/core-js/object/keys.js");

    module.exports = function (source, excluded) {
      if (null == source) return {};

      var key,
          i,
          target = {},
          sourceKeys = _Object$keys(source);

      for (i = 0; i < sourceKeys.length; i++) {
        key = sourceKeys[i], _indexOfInstanceProperty(excluded).call(excluded, key) >= 0 || (target[key] = source[key]);
      }

      return target;
    };
  },
  "../../node_modules/@babel/runtime-corejs3/helpers/possibleConstructorReturn.js": function node_modulesBabelRuntimeCorejs3HelpersPossibleConstructorReturnJs(module, exports, __webpack_require__) {
    var _typeof = __webpack_require__("../../node_modules/@babel/runtime-corejs3/helpers/typeof.js"),
        assertThisInitialized = __webpack_require__("../../node_modules/@babel/runtime-corejs3/helpers/assertThisInitialized.js");

    module.exports = function (self, call) {
      return !call || "object" !== _typeof(call) && "function" != typeof call ? assertThisInitialized(self) : call;
    };
  },
  "../../node_modules/@babel/runtime-corejs3/helpers/slicedToArray.js": function node_modulesBabelRuntimeCorejs3HelpersSlicedToArrayJs(module, exports, __webpack_require__) {
    var arrayWithHoles = __webpack_require__("../../node_modules/@babel/runtime-corejs3/helpers/arrayWithHoles.js"),
        iterableToArrayLimit = __webpack_require__("../../node_modules/@babel/runtime-corejs3/helpers/iterableToArrayLimit.js"),
        unsupportedIterableToArray = __webpack_require__("../../node_modules/@babel/runtime-corejs3/helpers/unsupportedIterableToArray.js"),
        nonIterableRest = __webpack_require__("../../node_modules/@babel/runtime-corejs3/helpers/nonIterableRest.js");

    module.exports = function (arr, i) {
      return arrayWithHoles(arr) || iterableToArrayLimit(arr, i) || unsupportedIterableToArray(arr, i) || nonIterableRest();
    };
  },
  "../../node_modules/@babel/runtime-corejs3/helpers/typeof.js": function node_modulesBabelRuntimeCorejs3HelpersTypeofJs(module, exports, __webpack_require__) {
    var _Symbol$iterator = __webpack_require__("../../node_modules/@babel/runtime-corejs3/core-js/symbol/iterator.js"),
        _Symbol = __webpack_require__("../../node_modules/@babel/runtime-corejs3/core-js/symbol.js");

    function _typeof(obj) {
      return module.exports = _typeof = "function" == typeof _Symbol && "symbol" == typeof _Symbol$iterator ? function (obj) {
        return typeof obj;
      } : function (obj) {
        return obj && "function" == typeof _Symbol && obj.constructor === _Symbol && obj !== _Symbol.prototype ? "symbol" : typeof obj;
      }, _typeof(obj);
    }

    module.exports = _typeof;
  },
  "../../node_modules/@babel/runtime-corejs3/helpers/unsupportedIterableToArray.js": function node_modulesBabelRuntimeCorejs3HelpersUnsupportedIterableToArrayJs(module, exports, __webpack_require__) {
    var _Array$from = __webpack_require__("../../node_modules/@babel/runtime-corejs3/core-js/array/from.js"),
        _sliceInstanceProperty = __webpack_require__("../../node_modules/@babel/runtime-corejs3/core-js/instance/slice.js"),
        arrayLikeToArray = __webpack_require__("../../node_modules/@babel/runtime-corejs3/helpers/arrayLikeToArray.js");

    module.exports = function (o, minLen) {
      var _context;

      if (o) {
        if ("string" == typeof o) return arrayLikeToArray(o, minLen);

        var n = _sliceInstanceProperty(_context = Object.prototype.toString.call(o)).call(_context, 8, -1);

        return "Object" === n && o.constructor && (n = o.constructor.name), "Map" === n || "Set" === n ? _Array$from(o) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? arrayLikeToArray(o, minLen) : void 0;
      }
    };
  },
  "../../node_modules/lodash/_Symbol.js": function node_modulesLodash_SymbolJs(module, exports, __webpack_require__) {
    var Symbol = __webpack_require__("../../node_modules/lodash/_root.js").Symbol;

    module.exports = Symbol;
  },
  "../../node_modules/lodash/_baseGetTag.js": function node_modulesLodash_baseGetTagJs(module, exports, __webpack_require__) {
    var Symbol = __webpack_require__("../../node_modules/lodash/_Symbol.js"),
        getRawTag = __webpack_require__("../../node_modules/lodash/_getRawTag.js"),
        objectToString = __webpack_require__("../../node_modules/lodash/_objectToString.js"),
        symToStringTag = Symbol ? Symbol.toStringTag : void 0;

    module.exports = function (value) {
      return null == value ? void 0 === value ? "[object Undefined]" : "[object Null]" : symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
    };
  },
  "../../node_modules/lodash/_freeGlobal.js": function node_modulesLodash_freeGlobalJs(module, exports, __webpack_require__) {
    (function (global) {
      var freeGlobal = "object" == typeof global && global && global.Object === Object && global;
      module.exports = freeGlobal;
    }).call(this, __webpack_require__("../../node_modules/webpack/buildin/global.js"));
  },
  "../../node_modules/lodash/_getRawTag.js": function node_modulesLodash_getRawTagJs(module, exports, __webpack_require__) {
    var Symbol = __webpack_require__("../../node_modules/lodash/_Symbol.js"),
        objectProto = Object.prototype,
        hasOwnProperty = objectProto.hasOwnProperty,
        nativeObjectToString = objectProto.toString,
        symToStringTag = Symbol ? Symbol.toStringTag : void 0;

    module.exports = function (value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = void 0;
        var unmasked = !0;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      return unmasked && (isOwn ? value[symToStringTag] = tag : delete value[symToStringTag]), result;
    };
  },
  "../../node_modules/lodash/_objectToString.js": function node_modulesLodash_objectToStringJs(module, exports) {
    var nativeObjectToString = Object.prototype.toString;

    module.exports = function (value) {
      return nativeObjectToString.call(value);
    };
  },
  "../../node_modules/lodash/_root.js": function node_modulesLodash_rootJs(module, exports, __webpack_require__) {
    var freeGlobal = __webpack_require__("../../node_modules/lodash/_freeGlobal.js"),
        freeSelf = "object" == typeof self && self && self.Object === Object && self,
        root = freeGlobal || freeSelf || Function("return this")();

    module.exports = root;
  },
  "../../node_modules/lodash/isArray.js": function node_modulesLodashIsArrayJs(module, exports) {
    var isArray = Array.isArray;
    module.exports = isArray;
  },
  "../../node_modules/lodash/isObject.js": function node_modulesLodashIsObjectJs(module, exports) {
    module.exports = function (value) {
      var type = typeof value;
      return null != value && ("object" == type || "function" == type);
    };
  },
  "../../node_modules/lodash/isObjectLike.js": function node_modulesLodashIsObjectLikeJs(module, exports) {
    module.exports = function (value) {
      return null != value && "object" == typeof value;
    };
  },
  "../../node_modules/lodash/isString.js": function node_modulesLodashIsStringJs(module, exports, __webpack_require__) {
    var baseGetTag = __webpack_require__("../../node_modules/lodash/_baseGetTag.js"),
        isArray = __webpack_require__("../../node_modules/lodash/isArray.js"),
        isObjectLike = __webpack_require__("../../node_modules/lodash/isObjectLike.js");

    module.exports = function (value) {
      return "string" == typeof value || !isArray(value) && isObjectLike(value) && "[object String]" == baseGetTag(value);
    };
  },
  "../../node_modules/lodash/isUndefined.js": function node_modulesLodashIsUndefinedJs(module, exports) {
    module.exports = function (value) {
      return void 0 === value;
    };
  },
  "../../node_modules/webpack/buildin/global.js": function node_modulesWebpackBuildinGlobalJs(module, exports) {
    var g;

    g = function () {
      return this;
    }();

    try {
      g = g || new Function("return this")();
    } catch (e) {
      "object" == typeof window && (g = window);
    }

    module.exports = g;
  },
  "./AppSwitcher/AppSwitcher.module.scss": function AppSwitcherAppSwitcherModuleScss(module, exports, __webpack_require__) {
    module.exports = {
      themeRoot: "jut__AppSwitcher__themeRoot",
      appSwitcher: "jut__AppSwitcher__appSwitcher",
      menu: "jut__AppSwitcher__menu",
      items: "jut__AppSwitcher__items",
      itemsModal: "jut__AppSwitcher__itemsModal",
      separator: "jut__AppSwitcher__separator",
      item: "jut__AppSwitcher__item",
      itemIcon: "jut__AppSwitcher__itemIcon",
      itemLabel: "jut__AppSwitcher__itemLabel",
      footer: "jut__AppSwitcher__footer",
      footerLink: "jut__AppSwitcher__footerLink",
      footerText: "jut__AppSwitcher__footerText",
      appSwitcherModal: "jut__AppSwitcher__appSwitcherModal"
    };
  },
  "./ApplicationHeader/ApplicationHeader.module.scss": function ApplicationHeaderApplicationHeaderModuleScss(module, exports, __webpack_require__) {
    module.exports = {
      themeRoot: "jut__ApplicationHeader__themeRoot",
      applicationHeaderWrapper: "jut__ApplicationHeader__applicationHeaderWrapper",
      applicationHeader: "jut__ApplicationHeader__applicationHeader",
      subApplicationHeader: "jut__ApplicationHeader__subApplicationHeader",
      hiddenOverflow: "jut__ApplicationHeader__hiddenOverflow",
      headerActions: "jut__ApplicationHeader__headerActions",
      applicationLogoTitleLink: "jut__ApplicationHeader__applicationLogoTitleLink",
      applicationLogo: "jut__ApplicationHeader__applicationLogo",
      navItem: "jut__ApplicationHeader__navItem",
      activeNavItem: "jut__ApplicationHeader__activeNavItem",
      headerActionButton: "jut__ApplicationHeader__headerActionButton",
      searchContainer: "jut__ApplicationHeader__searchContainer",
      darkSearchContainer: "jut__ApplicationHeader__darkSearchContainer",
      searchField: "jut__ApplicationHeader__searchField",
      burgerMenuSeparator: "jut__ApplicationHeader__burgerMenuSeparator",
      burgerMenuAuthLinks: "jut__ApplicationHeader__burgerMenuAuthLinks",
      burgerMenuSidebarStyledContent: "jut__ApplicationHeader__burgerMenuSidebarStyledContent",
      burgerMenuAvatar: "jut__ApplicationHeader__burgerMenuAvatar",
      burgerMenuAvatarChildren: "jut__ApplicationHeader__burgerMenuAvatarChildren",
      helpIcon: "jut__ApplicationHeader__helpIcon",
      centerWrapper: "jut__ApplicationHeader__centerWrapper"
    };
  },
  "./AsyncAction/AsyncAction.module.scss": function AsyncActionAsyncActionModuleScss(module, exports, __webpack_require__) {
    module.exports = {
      loader: "jut__AsyncAction__loader",
      loaderOnly: "jut__AsyncAction__loaderOnly",
      underLoader: "jut__AsyncAction__underLoader",
      ellipsis: "jut__AsyncAction__ellipsis",
      blink: "jut__AsyncAction__blink",
      ellipsisSecondDot: "jut__AsyncAction__ellipsisSecondDot",
      ellipsisThirdDot: "jut__AsyncAction__ellipsisThirdDot"
    };
  },
  "./AsyncButtonLink/AsyncButtonLink.module.scss": function AsyncButtonLinkAsyncButtonLinkModuleScss(module, exports, __webpack_require__) {
    module.exports = {
      asyncButtonLink: "jut__AsyncButtonLink__asyncButtonLink"
    };
  },
  "./BurgerMenu/BurgerMenu.module.scss": function BurgerMenuBurgerMenuModuleScss(module, exports, __webpack_require__) {
    module.exports = {
      burgerMenu: "jut__BurgerMenu__burgerMenu",
      burgerButtonContainer: "jut__BurgerMenu__burgerButtonContainer",
      burgerButton: "jut__BurgerMenu__burgerButton",
      burgerButtonBar: "jut__BurgerMenu__burgerButtonBar",
      burgerSidebar: "jut__BurgerMenu__burgerSidebar",
      sidebarItem: "jut__BurgerMenu__sidebarItem",
      isClosed: "jut__BurgerMenu__isClosed",
      sidebarHeader: "jut__BurgerMenu__sidebarHeader",
      menu: "jut__BurgerMenu__menu",
      dismissButtonIcon: "jut__BurgerMenu__dismissButtonIcon",
      backdrop: "jut__BurgerMenu__backdrop",
      burgerAppSwitcherAccordion: "jut__BurgerMenu__burgerAppSwitcherAccordion",
      burgerAppSwitcherButtonTitle: "jut__BurgerMenu__burgerAppSwitcherButtonTitle"
    };
  },
  "./ButtonLink/ButtonLink.module.scss": function ButtonLinkButtonLinkModuleScss(module, exports, __webpack_require__) {
    module.exports = {
      buttonLink: "jut__ButtonLink__buttonLink"
    };
  },
  "./DropdownMenu/DropdownMenu.module.scss": function DropdownMenuDropdownMenuModuleScss(module, exports, __webpack_require__) {
    module.exports = {
      dropdownMenu: "jut__DropdownMenu__dropdownMenu",
      dropdownMenuPosition: "jut__DropdownMenu__dropdownMenuPosition",
      menu: "jut__DropdownMenu__menu",
      link: "jut__DropdownMenu__link",
      dropdownSeparator: "jut__DropdownMenu__dropdownSeparator",
      "menu-top": "jut__DropdownMenu__menu-top",
      "menu-left": "jut__DropdownMenu__menu-left",
      "menu-active": "jut__DropdownMenu__menu-active",
      disabled: "jut__DropdownMenu__disabled",
      dropdownHeaderTitle: "jut__DropdownMenu__dropdownHeaderTitle",
      dropdownHeader: "jut__DropdownMenu__dropdownHeader"
    };
  },
  "./DropdownMenu/DropdownMenuAvatar.module.scss": function DropdownMenuDropdownMenuAvatarModuleScss(module, exports, __webpack_require__) {
    module.exports = {
      dropdownMenuAvatar: "jut__DropdownMenuAvatar__dropdownMenuAvatar",
      dropdownMenuAvatarHeader: "jut__DropdownMenuAvatar__dropdownMenuAvatarHeader",
      headerText: "jut__DropdownMenuAvatar__headerText",
      headerTitle: "jut__DropdownMenuAvatar__headerTitle",
      headerSubtitle: "jut__DropdownMenuAvatar__headerSubtitle",
      dropdownMenuAvatarMenu: "jut__DropdownMenuAvatar__dropdownMenuAvatarMenu",
      dropdownMenuAvatarTrigger: "jut__DropdownMenuAvatar__dropdownMenuAvatarTrigger"
    };
  },
  "./DropdownMenu/DropdownMenuButton.module.scss": function DropdownMenuDropdownMenuButtonModuleScss(module, exports, __webpack_require__) {
    module.exports = {
      fullWidth: "jut__DropdownMenuButton__fullWidth"
    };
  },
  "./NavBar/NavBarItem.module.scss": function NavBarNavBarItemModuleScss(module, exports, __webpack_require__) {
    module.exports = {
      navBarItem: "jut__NavBarItem__navBarItem",
      topNavBarItem: "jut__NavBarItem__topNavBarItem",
      leftNavBarItem: "jut__NavBarItem__leftNavBarItem",
      titleContentWrapper: "jut__NavBarItem__titleContentWrapper",
      titleWrapper: "jut__NavBarItem__titleWrapper",
      title: "jut__NavBarItem__title",
      activeTopNavBarItem: "jut__NavBarItem__activeTopNavBarItem",
      activeLeftNavBarItem: "jut__NavBarItem__activeLeftNavBarItem",
      navBarItemChevron: "jut__NavBarItem__navBarItemChevron",
      navBarItemIcon: "jut__NavBarItem__navBarItemIcon",
      active: "jut__NavBarItem__active",
      navBarDropdown: "jut__NavBarItem__navBarDropdown"
    };
  },
  "./NavBar/NavigationContent.module.scss": function NavBarNavigationContentModuleScss(module, exports, __webpack_require__) {
    module.exports = {
      navigationContent: "jut__NavigationContent__navigationContent",
      topNavigationItem: "jut__NavigationContent__topNavigationItem"
    };
  },
  "./NavBar/SideNavigation/SideNavigation.module.scss": function NavBarSideNavigationSideNavigationModuleScss(module, exports, __webpack_require__) {
    module.exports = {
      sideNavigation: "jut__SideNavigation__sideNavigation",
      content: "jut__SideNavigation__content",
      layout: "jut__SideNavigation__layout",
      cardBody: "jut__SideNavigation__cardBody",
      navigationContent: "jut__SideNavigation__navigationContent",
      footer: "jut__SideNavigation__footer",
      chevronIcon: "jut__SideNavigation__chevronIcon",
      badgeWrapper: "jut__SideNavigation__badgeWrapper",
      notificationWrapper: "jut__SideNavigation__notificationWrapper",
      badgeDot: "jut__SideNavigation__badgeDot",
      collapsed: "jut__SideNavigation__collapsed",
      navBarLink: "jut__SideNavigation__navBarLink",
      chevron: "jut__SideNavigation__chevron",
      titleWrapper: "jut__SideNavigation__titleWrapper",
      accordionCollapse: "jut__SideNavigation__accordionCollapse",
      sideNavAccordion: "jut__SideNavigation__sideNavAccordion",
      cardTitle: "jut__SideNavigation__cardTitle",
      cardHeading: "jut__SideNavigation__cardHeading",
      rightAlignChevron: "jut__SideNavigation__rightAlignChevron",
      activeAccordion: "jut__SideNavigation__activeAccordion",
      expandedAccordion: "jut__SideNavigation__expandedAccordion",
      subItem: "jut__SideNavigation__subItem",
      notifications: "jut__SideNavigation__notifications",
      subItemWithIcon: "jut__SideNavigation__subItemWithIcon"
    };
  },
  "./NavBar/TopNavigation/TopNavigation.module.scss": function NavBarTopNavigationTopNavigationModuleScss(module, exports, __webpack_require__) {
    module.exports = {
      topNavigation: "jut__TopNavigation__topNavigation",
      noWrap: "jut__TopNavigation__noWrap"
    };
  },
  "./index.js": function indexJs(module, __webpack_exports__, __webpack_require__) {
    "use strict";

    __webpack_require__.r(__webpack_exports__), __webpack_require__.d(__webpack_exports__, "RouteTracker", function () {
      return RouteTracker;
    }), __webpack_require__.d(__webpack_exports__, "routeConfirmationModal", function () {
      return routeConfirmationModal;
    }), __webpack_require__.d(__webpack_exports__, "AsyncLink", function () {
      return AsyncLink;
    }), __webpack_require__.d(__webpack_exports__, "AsyncButtonLink", function () {
      return AsyncButtonLink;
    }), __webpack_require__.d(__webpack_exports__, "ButtonLink", function () {
      return ButtonLink;
    }), __webpack_require__.d(__webpack_exports__, "NavRoutes", function () {
      return NavRoutes;
    }), __webpack_require__.d(__webpack_exports__, "BurgerMenu", function () {
      return BurgerMenu;
    }), __webpack_require__.d(__webpack_exports__, "BurgerAppSwitcherAccordion", function () {
      return BurgerAppSwitcherAccordion;
    }), __webpack_require__.d(__webpack_exports__, "TopNavigation", function () {
      return TopNavigation;
    }), __webpack_require__.d(__webpack_exports__, "NavBarDropdown", function () {
      return NavBarDropdown;
    }), __webpack_require__.d(__webpack_exports__, "SideNavigation", function () {
      return SideNavigation;
    }), __webpack_require__.d(__webpack_exports__, "NavBarAccordion", function () {
      return NavBarAccordion;
    }), __webpack_require__.d(__webpack_exports__, "NavBarLink", function () {
      return NavBarLink;
    }), __webpack_require__.d(__webpack_exports__, "PrivateRoute", function () {
      return PrivateRoute;
    }), __webpack_require__.d(__webpack_exports__, "invokeAction", function () {
      return invokeAction;
    }), __webpack_require__.d(__webpack_exports__, "handleAction", function () {
      return handleAction;
    }), __webpack_require__.d(__webpack_exports__, "checkActionIntegrity", function () {
      return checkActionIntegrity;
    }), __webpack_require__.d(__webpack_exports__, "actionResultWithPaths", function () {
      return actionResultWithPaths;
    }), __webpack_require__.d(__webpack_exports__, "showAlert", function () {
      return showAlert;
    }), __webpack_require__.d(__webpack_exports__, "navigateTo", function () {
      return navigateTo;
    }), __webpack_require__.d(__webpack_exports__, "PromptService", function () {
      return PromptService;
    }), __webpack_require__.d(__webpack_exports__, "PROMPT_SERVICE_ID", function () {
      return PROMPT_SERVICE_ID;
    }), __webpack_require__.d(__webpack_exports__, "getErrorCategory", function () {
      return getErrorCategory;
    }), __webpack_require__.d(__webpack_exports__, "setErrorCategoryKnockoutMaps", function () {
      return setErrorCategoryKnockoutMaps;
    }), __webpack_require__.d(__webpack_exports__, "DropdownMenu", function () {
      return DropdownMenu;
    }), __webpack_require__.d(__webpack_exports__, "DropdownMenuHeader", function () {
      return DropdownMenuHeader;
    }), __webpack_require__.d(__webpack_exports__, "DropdownMenuSeparator", function () {
      return DropdownMenuSeparator;
    }), __webpack_require__.d(__webpack_exports__, "DropdownMenuLink", function () {
      return DropdownMenuLink;
    }), __webpack_require__.d(__webpack_exports__, "DropdownMenuAvatar", function () {
      return DropdownMenuAvatar;
    }), __webpack_require__.d(__webpack_exports__, "DropdownMenuButton", function () {
      return DropdownMenuButton;
    }), __webpack_require__.d(__webpack_exports__, "AppSwitcher", function () {
      return AppSwitcher;
    }), __webpack_require__.d(__webpack_exports__, "ApplicationHeader", function () {
      return ApplicationHeader;
    }), __webpack_require__.d(__webpack_exports__, "ApplicationHeaderPropTypes", function () {
      return ApplicationHeaderPropTypes;
    }), __webpack_require__.d(__webpack_exports__, "PageHead", function () {
      return PageHead;
    }), __webpack_require__.d(__webpack_exports__, "PageTitle", function () {
      return PageTitle;
    });

    __webpack_require__("core-js/modules/web.dom-collections.iterator");

    var construct_ = __webpack_require__("@babel/runtime-corejs3/core-js-stable/reflect/construct"),
        construct_default = __webpack_require__.n(construct_),
        classCallCheck = __webpack_require__("../../node_modules/@babel/runtime-corejs3/helpers/classCallCheck.js"),
        classCallCheck_default = __webpack_require__.n(classCallCheck),
        createClass = __webpack_require__("../../node_modules/@babel/runtime-corejs3/helpers/createClass.js"),
        createClass_default = __webpack_require__.n(createClass),
        assertThisInitialized = __webpack_require__("../../node_modules/@babel/runtime-corejs3/helpers/assertThisInitialized.js"),
        assertThisInitialized_default = __webpack_require__.n(assertThisInitialized),
        inherits_ = __webpack_require__("@babel/runtime-corejs3/helpers/inherits"),
        inherits_default = __webpack_require__.n(inherits_),
        possibleConstructorReturn = __webpack_require__("../../node_modules/@babel/runtime-corejs3/helpers/possibleConstructorReturn.js"),
        possibleConstructorReturn_default = __webpack_require__.n(possibleConstructorReturn),
        getPrototypeOf = __webpack_require__("../../node_modules/@babel/runtime-corejs3/helpers/getPrototypeOf.js"),
        getPrototypeOf_default = __webpack_require__.n(getPrototypeOf),
        defineProperty = __webpack_require__("../../node_modules/@babel/runtime-corejs3/helpers/defineProperty.js"),
        defineProperty_default = __webpack_require__.n(defineProperty),
        external_react_ = __webpack_require__("react"),
        external_react_default = __webpack_require__.n(external_react_),
        external_prop_types_ = __webpack_require__("prop-types"),
        external_prop_types_default = __webpack_require__.n(external_prop_types_),
        external_react_router_dom_ = __webpack_require__("react-router-dom"),
        events_ = __webpack_require__("@jutro/events");

    function _createSuper(Derived) {
      var hasNativeReflectConstruct = function () {
        if ("undefined" == typeof Reflect || !construct_default.a) return !1;
        if (construct_default.a.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Date.prototype.toString.call(construct_default()(Date, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var result,
            Super = getPrototypeOf_default()(Derived);

        if (hasNativeReflectConstruct) {
          var NewTarget = getPrototypeOf_default()(this).constructor;
          result = construct_default()(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);

        return possibleConstructorReturn_default()(this, result);
      };
    }

    var RouteTracker_RouteTrackerInternal = function (_Component) {
      inherits_default()(RouteTrackerInternal, _Component);

      var _super = _createSuper(RouteTrackerInternal);

      function RouteTrackerInternal() {
        var _this;

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return classCallCheck_default()(this, RouteTrackerInternal), _this = _super.call.apply(_super, [this].concat(args)), defineProperty_default()(assertThisInitialized_default()(_this), "unlisten", null), defineProperty_default()(assertThisInitialized_default()(_this), "handleChange", function (params, state) {
          var track = _this.props.track;
          track && track(params, state), Object(events_.publish)(events_.JUTRO_TOPICS.ROUTE_CHANGED, {
            pathname: params.pathname,
            state: state
          });
        }), _this;
      }

      return createClass_default()(RouteTrackerInternal, [{
        key: "componentWillMount",
        value: function value() {
          this.listen(this.handleChange);
        }
      }, {
        key: "componentWillUnmount",
        value: function value() {
          this.unlisten();
        }
      }, {
        key: "listen",
        value: function value(track) {
          if (!track) return;
          var history = this.props.history;
          this.unlisten = history.listen(track);
        }
      }, {
        key: "unlisten",
        value: function value() {
          this.unlisten && (this.unlisten(), this.unlisten = null);
        }
      }, {
        key: "render",
        value: function value() {
          return null;
        }
      }]), RouteTrackerInternal;
    }(external_react_.Component);

    defineProperty_default()(RouteTracker_RouteTrackerInternal, "propTypes", {
      track: external_prop_types_default.a.func
    }), defineProperty_default()(RouteTracker_RouteTrackerInternal, "displayName", "RouteTracker");
    var RouteTracker = Object(external_react_router_dom_.withRouter)(RouteTracker_RouteTrackerInternal);
    RouteTracker_RouteTrackerInternal.__docgenInfo = {
      componentName: "RouteTracker",
      packageName: "@jutro/router",
      description: "RouteTracker is a component that will register a listener with route history.\nDrop into any component render that is contained in a <Router>.",
      displayName: "RouteTracker",
      methods: [{
        name: "handleChange",
        docblock: "Callback on route changed\n@param {object} params - params\n@param {object} state - state",
        modifiers: [],
        params: [{
          name: "params",
          description: "params",
          type: {
            name: "object"
          },
          optional: !1
        }, {
          name: "state",
          description: "state",
          type: {
            name: "object"
          },
          optional: !1
        }],
        returns: null,
        description: "Callback on route changed"
      }, {
        name: "listen",
        docblock: "Register a callback with history listener\n\n@param {(location:Location, action:string) => void} track - callback to register with history listener",
        modifiers: [],
        params: [{
          name: "track"
        }],
        returns: null,
        description: "Register a callback with history listener"
      }, {
        name: "unlisten",
        docblock: "Unregister a callback with history listener",
        modifiers: [],
        params: [],
        returns: null,
        description: "Unregister a callback with history listener"
      }],
      actualName: "RouteTrackerInternal",
      props: {
        track: {
          type: {
            name: "func"
          },
          required: !1,
          description: ""
        }
      }
    };

    var _class,
        components_ = __webpack_require__("@jutro/components"),
        external_lodash_ = __webpack_require__("lodash"),
        external_lodash_default = __webpack_require__.n(external_lodash_),
        logger_ = __webpack_require__("@jutro/logger"),
        services_ = __webpack_require__("@jutro/services");

    var PROMPT_SERVICE_ID = "PROMPT_SERVICE",
        prompts = {};
    Object(services_.service)(PROMPT_SERVICE_ID)(_class = function () {
      function PromptServiceInternal() {
        classCallCheck_default()(this, PromptServiceInternal);
      }

      return createClass_default()(PromptServiceInternal, [{
        key: "pushPrompt",
        value: function value(name, props) {
          prompts[name] ? logger_.log.warning("The prompt name ".concat(name, " has been used")) : prompts[name] = props;
        }
      }, {
        key: "popPrompt",
        value: function value(name) {
          var prompt = prompts[name];
          return delete prompts[name], prompt;
        }
      }]), PromptServiceInternal;
    }());
    var PromptService = services_.ServiceManager.getService(PROMPT_SERVICE_ID);

    var reduce_ = __webpack_require__("@babel/runtime-corejs3/core-js-stable/instance/reduce"),
        reduce_default = __webpack_require__.n(reduce_),
        for_each_ = __webpack_require__("@babel/runtime-corejs3/core-js-stable/instance/for-each"),
        for_each_default = __webpack_require__.n(for_each_),
        objectWithoutProperties = __webpack_require__("../../node_modules/@babel/runtime-corejs3/helpers/objectWithoutProperties.js"),
        objectWithoutProperties_default = __webpack_require__.n(objectWithoutProperties),
        map_ = __webpack_require__("@babel/runtime-corejs3/core-js-stable/instance/map"),
        map_default = __webpack_require__.n(map_),
        platform_ = __webpack_require__("@jutro/platform"),
        external_react_intl_ = __webpack_require__("react-intl");

    var messages = Object(external_react_intl_.defineMessages)({
      actionWarning: {
        id: "jutro-router.alert.Action Warning",
        defaultMessage: "Action Warning"
      },
      ok: {
        id: "jutro-router.alert.OK",
        defaultMessage: "OK"
      }
    });

    function showAlert(message, title) {
      var callback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};
      components_.ModalService.showWarning({
        title: title || messages.actionWarning,
        message: message,
        actionLabel: messages.ok,
        showCancelButton: !1
      }).result.then(callback, function () {});
    }

    __webpack_require__("core-js/modules/es.string.replace");

    function navigateTo(instance, path, result) {
      if (instance && path && !function (instance, path) {
        var loc = instance.props.location;

        if ("object" == typeof path) {
          var pathname = path.pathname,
              _path$search = path.search,
              search = void 0 === _path$search ? "" : _path$search,
              _path$hash = path.hash,
              hash = void 0 === _path$hash ? "" : _path$hash;
          return pathname === loc.pathname && search === loc.search && hash === loc.hash;
        }

        return path === loc.pathname;
      }(instance, path)) {
        var location = path;
        external_lodash_default.a.isString(location) ? location = {
          pathname: path,
          state: {
            action: "redirect",
            result: result
          }
        } : result && external_lodash_default.a.set(location, "state.result", result);
        var _instance$props = instance.props,
            history = _instance$props.history;
        _instance$props.replace ? history.replace(location) : history.push(location);
      }
    }

    var defaultErrorCategory = {};
    var errorCategories, errorCategoryKnockoutPaths;

    function getErrorCategory(errorCode) {
      if (errorCategories && errorCategories[errorCode]) {
        var errorCategory = errorCategories[errorCode],
            categoryMapping = errorCategory.categoryMapping;
        return {
          categoryMapping: categoryMapping,
          appErrorCode: errorCategory.appErrorCode,
          knockoutPath: function (errorCategory, knockoutPaths) {
            var knockoutPath = knockoutPaths[errorCategory];
            return knockoutPath || logger_.log.warning("Missing KnockoutPath configuration for error category: " + errorCategory), knockoutPath;
          }(categoryMapping, errorCategoryKnockoutPaths)
        };
      }

      return defaultErrorCategory;
    }

    function setErrorCategoryKnockoutMaps(appErrorCategories, appKnockoutPaths) {
      if (!external_lodash_default.a.isObject(appErrorCategories)) throw new TypeError("Expected an object for 'errorCategories', got a '".concat(typeof appErrorCategories, "' instead"));
      if (errorCategories = appErrorCategories, !external_lodash_default.a.isObject(appKnockoutPaths)) throw new TypeError("Expected an object for 'knockoutPaths', got a '".concat(typeof appKnockoutPaths, "' instead"));
      errorCategoryKnockoutPaths = appKnockoutPaths;
    }

    function invokeAction(name, props, context, onSuccess, onFailure) {
      var actionFunction = props.function;
      var result,
          resultException,
          actionArgs = props.args;

      if (actionFunction && !external_lodash_default.a.isString(actionFunction)) {
        actionArgs && (actionArgs = map_default()(actionArgs).call(actionArgs, function (prop) {
          return context[prop];
        }));

        try {
          result = actionArgs ? actionFunction.apply(void 0, _toConsumableArray(actionArgs)) : actionFunction();
        } catch (ex) {
          result = !1, resultException = ex;
        }

        return {
          name: name,
          result: result,
          resultException: resultException,
          progress: props.progress,
          success: props.success,
          failure: props.failure,
          onSuccess: onSuccess,
          onFailure: onFailure
        };
      }

      logger_.log.error("Could not resolve action function: \"".concat(actionFunction || name, "\""));
    }

    function actionResultWithPaths(result, successPath, failurePath, progressMsg) {
      var actionObject = {
        name: "unnamed",
        result: result
      };
      return void 0 !== progressMsg && (actionObject.progress = {
        message: progressMsg
      }), void 0 !== successPath && (actionObject.success = {
        path: successPath
      }), void 0 !== failurePath && (actionObject.failure = {
        path: failurePath
      }), actionObject;
    }

    function handleAction(actionObject, instance, translator) {
      var name, result, resultException, progress, success, failure, onSuccess, onFailure, message, _ref2, to, toMessage, _ref3, failTo, failToMessage, onAlert, onNavigate, data, computedFailTo, errorData, errorCategory, knockoutPath, errorProps;

      return _regeneratorRuntime.async(function handleAction$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (!(instance && (!instance.setState || !instance.props || !instance.props.history))) {
                _context3.next = 2;
                break;
              }

              return _context3.abrupt("return", void logger_.log.error('"Instance" provided to AsyncLink.handleAction does not have "setState" or "history" props'));

            case 2:
              name = actionObject.name, result = actionObject.result, resultException = actionObject.resultException, progress = actionObject.progress, success = actionObject.success, failure = actionObject.failure, onSuccess = actionObject.onSuccess, onFailure = actionObject.onFailure, message = (progress || {}).message, _ref2 = success || {}, to = _ref2.path, toMessage = _ref2.message, _ref3 = failure || {}, failTo = _ref3.path, failToMessage = _ref3.message, onAlert = showAlert, onNavigate = navigateTo;

              if (Object(platform_.isPromise)(result)) {
                _context3.next = 5;
                break;
              }

              return _context3.abrupt("return", !1 !== result ? (onSuccess && onSuccess(name, result), void (to && onNavigate ? onNavigate(instance, to, result) : toMessage && onAlert && onAlert(translator(toMessage)))) : void 0 !== resultException && !1 !== resultException ? (onFailure && onFailure(name, resultException), void (failTo && onNavigate ? onNavigate(instance, failTo, resultException) : failToMessage && onAlert && onAlert(translator(failToMessage)))) : void 0);

            case 5:
              _context3.prev = 5;
              instance && instance.setState({
                loading: !0,
                message: translator(message)
              });
              _context3.next = 9;
              return _regeneratorRuntime.awrap(result);

            case 9:
              data = _context3.sent;
              instance && instance.setState({
                loading: !1,
                message: null
              }), !1 !== data && (onSuccess && onSuccess(name, data), to && onNavigate ? onNavigate(instance, to, data) : toMessage && onAlert && onAlert(translator(toMessage)));
              _context3.next = 23;
              break;

            case 13:
              _context3.prev = 13;
              _context3.t0 = _context3["catch"](5);
              computedFailTo = failTo;

              if (!(_context3.t0 instanceof Error && logger_.log.error("AsyncLink: " + _context3.t0), instance && instance.setState({
                loading: !1,
                message: null
              }), !1 === _context3.t0)) {
                _context3.next = 18;
                break;
              }

              return _context3.abrupt("return");

            case 18:
              if (!(onFailure && onFailure(name, _context3.t0), !1 === _context3.t0)) {
                _context3.next = 20;
                break;
              }

              return _context3.abrupt("return");

            case 20:
              errorData = _context3.t0;
              errorCategory = getErrorCategory(_context3.t0.errorCode || _context3.t0), knockoutPath = errorCategory.knockoutPath, errorProps = objectWithoutProperties_default()(errorCategory, ["knockoutPath"]);
              knockoutPath && (computedFailTo = knockoutPath), external_lodash_default.a.isEmpty(errorProps) || (errorData = _objectSpread({}, errorProps, {
                error: _context3.t0
              })), computedFailTo && onNavigate ? onNavigate(instance, computedFailTo, errorData) : failToMessage && onAlert && onAlert(translator(failToMessage));

            case 23:
            case "end":
              return _context3.stop();
          }
        }
      }, null, null, [[5, 13]], Promise);
    }

    function checkActionIntegrity(events, props, context) {
      events && props && context && for_each_default()(events).call(events, function (evt) {
        var actionProps = props[evt];

        if (actionProps) {
          if (external_lodash_default.a.isString(actionProps.function)) return void logger_.log.error("Could not resolve action function: \"".concat(actionProps.function, "\". Check return from \"getActionFunctions()\""));

          if (actionProps.function && actionProps.args) {
            var _context;

            var missing = reduce_default()(_context = actionProps.args).call(_context, function (list, prop) {
              return context.hasOwnProperty(prop) || list.push(prop), list;
            }, []);
            0 !== missing.length && logger_.log.error("Could not resolve action function arguments from action context: \"".concat(actionProps.name, "(").concat(missing, ")\". Check return from \"getActionContext()\""));
          }
        }
      });
    }

    var routeConfirmationModal = function routeConfirmationModal(promptName, promptCallback) {
      var promptProps = PromptService.popPrompt(promptName);
      if (!promptProps) return void promptCallback(!0);
      var title = promptProps.title,
          message = promptProps.message;

      if (title && message) {
        var icon = "exclamation-triangle";
        components_.ModalService.showWarning({
          title: title,
          message: message,
          icon: icon
        }).result.then(function () {
          handleTriggerEvent(promptProps, promptCallback);
        }, function () {
          promptCallback(!1);
        });
      } else handleTriggerEvent(promptProps, promptCallback);
    };

    function handleTriggerEvent(promptProps, promptCallback) {
      var trigger, instance, triggerAnswer;
      return _regeneratorRuntime.async(function handleTriggerEvent$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              trigger = promptProps.trigger, instance = promptProps.instance;

              if (!(trigger && external_lodash_default.a.isFunction(trigger))) {
                _context4.next = 18;
                break;
              }

              triggerAnswer = trigger();

              if (!external_lodash_default.a.isObject(triggerAnswer)) {
                _context4.next = 15;
                break;
              }

              _context4.prev = 4;
              _context4.next = 7;
              return _regeneratorRuntime.awrap(handleAction(triggerAnswer, instance));

            case 7:
              promptCallback(instance.props.history.location === instance.props.location);
              _context4.next = 13;
              break;

            case 10:
              _context4.prev = 10;
              _context4.t0 = _context4["catch"](4);
              logger_.log.error(_context4.t0), promptCallback(!1);

            case 13:
              _context4.next = 16;
              break;

            case 15:
              external_lodash_default.a.isBoolean(triggerAnswer) ? promptCallback(triggerAnswer) : promptCallback(!0);

            case 16:
              _context4.next = 19;
              break;

            case 18:
              promptCallback(!0);

            case 19:
            case "end":
              return _context4.stop();
          }
        }
      }, null, null, [[4, 10]], Promise);
    }

    var extends_ = __webpack_require__("@babel/runtime-corejs3/helpers/extends"),
        extends_default = __webpack_require__.n(extends_),
        external_history_ = __webpack_require__("history"),
        external_memoize_one_ = __webpack_require__("memoize-one"),
        external_memoize_one_default = __webpack_require__.n(external_memoize_one_),
        prop_types_ = __webpack_require__("@jutro/prop-types"),
        uimetadata_ = __webpack_require__("@jutro/uimetadata"),
        entries_ = __webpack_require__("@babel/runtime-corejs3/core-js-stable/object/entries"),
        entries_default = __webpack_require__.n(entries_),
        isObject = __webpack_require__("../../node_modules/lodash/isObject.js"),
        isObject_default = __webpack_require__.n(isObject),
        external_classnames_ = __webpack_require__("classnames"),
        external_classnames_default = __webpack_require__.n(external_classnames_),
        locale_ = __webpack_require__("@jutro/locale"),
        AsyncAction_module = __webpack_require__("./AsyncAction/AsyncAction.module.scss"),
        AsyncAction_module_default = __webpack_require__.n(AsyncAction_module);

    function AsyncAction_createSuper(Derived) {
      var hasNativeReflectConstruct = function () {
        if ("undefined" == typeof Reflect || !construct_default.a) return !1;
        if (construct_default.a.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Date.prototype.toString.call(construct_default()(Date, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var result,
            Super = getPrototypeOf_default()(Derived);

        if (hasNativeReflectConstruct) {
          var NewTarget = getPrototypeOf_default()(this).constructor;
          result = construct_default()(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);

        return possibleConstructorReturn_default()(this, result);
      };
    }

    var propTypes = {
      failTo: external_prop_types_default.a.oneOfType([external_prop_types_default.a.string, external_prop_types_default.a.object]),
      failToMessage: external_prop_types_default.a.string,
      message: prop_types_.intlMessageShape,
      replace: external_prop_types_default.a.bool,
      to: external_prop_types_default.a.oneOfType([external_prop_types_default.a.string, external_prop_types_default.a.object]),
      toMessage: external_prop_types_default.a.string,
      translator: external_prop_types_default.a.func,
      onTrigger: external_prop_types_default.a.func.isRequired,
      onClick: external_prop_types_default.a.func
    },
        defaultProps = {
      replace: !1
    },
        withAsyncAction = function withAsyncAction(WrappedComponent) {
      var AsyncAction = function (_Component) {
        inherits_default()(AsyncAction, _Component);

        var _super = AsyncAction_createSuper(AsyncAction);

        function AsyncAction() {
          var _this, instance;

          for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            args[_key2] = arguments[_key2];
          }

          return classCallCheck_default()(this, AsyncAction), _this = _super.call.apply(_super, [this].concat(args)), defineProperty_default()(assertThisInitialized_default()(_this), "state", {
            loading: !1
          }), defineProperty_default()(assertThisInitialized_default()(_this), "translator", _this.context), defineProperty_default()(assertThisInitialized_default()(_this), "handleClick", (instance = assertThisInitialized_default()(_this), function (event) {
            var _instance$props = instance.props,
                onClick = _instance$props.onClick,
                target = _instance$props.target;

            if (onClick && onClick(event), !(event.defaultPrevented || void 0 !== event.button && 0 !== event.button || target)) {
              var _context;

              if (event.preventDefault(), instance.state.loading) return;
              var _instance$props2 = instance.props,
                  deprecatedTrigger = _instance$props2.trigger,
                  onTrigger = _instance$props2.onTrigger,
                  to = _instance$props2.to,
                  failTo = _instance$props2.failTo,
                  message = _instance$props2.message,
                  toMessage = _instance$props2.toMessage,
                  failToMessage = _instance$props2.failToMessage,
                  translator = instance.translator,
                  trigger = onTrigger || deprecatedTrigger;
              var resultException,
                  result = !1;

              try {
                result = trigger();
              } catch (ex) {
                resultException = ex;
              }

              var actionObject = isObject_default()(result) && !Object(platform_.isPromise)(result) ? result : {
                name: "unknown",
                result: result,
                resultException: resultException
              };
              for_each_default()(_context = entries_default()({
                progress: {
                  message: message
                },
                success: {
                  path: to,
                  message: toMessage
                },
                failure: {
                  path: failTo,
                  message: failToMessage
                }
              })).call(_context, function (_ref) {
                var _ref4 = _slicedToArray(_ref, 2),
                    key = _ref4[0],
                    value = _ref4[1];

                actionObject[key] || (actionObject[key] = value);
              }), handleAction(actionObject, instance, translator);
            }
          })), defineProperty_default()(assertThisInitialized_default()(_this), "renderContent", function () {
            var children = _this.props.children;
            return _this.state.loading ? external_react_default.a.createElement(external_react_default.a.Fragment, null, external_react_default.a.createElement("div", {
              className: AsyncAction_module_default.a.underLoader
            }, _this.translator(children)), _this.renderLoaderContent()) : children;
          }), _this;
        }

        return createClass_default()(AsyncAction, [{
          key: "renderLoaderContent",
          value: function value() {
            var _context2;

            var message = this.state.message || this.props.message,
                loading = this.state.loading;
            if (!message) return external_react_default.a.createElement(components_.InlineLoader, {
              loading: loading,
              className: AsyncAction_module_default.a.loaderOnly
            });
            var ellipsisClasses = map_default()(_context2 = [null, AsyncAction_module_default.a.ellipsisSecondDot, AsyncAction_module_default.a.ellipsisThirdDot]).call(_context2, function (specificClassName) {
              return external_classnames_default()(AsyncAction_module_default.a.ellipsis, specificClassName);
            });
            return external_react_default.a.createElement("div", {
              className: AsyncAction_module_default.a.loader
            }, this.translator(message) + " ", map_default()(ellipsisClasses).call(ellipsisClasses, function (dotClassName, index) {
              return external_react_default.a.createElement("span", {
                key: index,
                className: dotClassName
              }, ".");
            }));
          }
        }, {
          key: "render",
          value: function value() {
            var _this$props = this.props,
                props = (_this$props.children, _this$props.staticContext, _this$props.replace, objectWithoutProperties_default()(_this$props, ["children", "staticContext", "replace"])),
                loading = (this.state || this.props).loading;
            return external_react_default.a.createElement(WrappedComponent, extends_default()({}, props, {
              onClick: this.handleClick,
              loading: loading
            }), this.renderContent());
          }
        }]), AsyncAction;
      }(external_react_.Component);

      defineProperty_default()(AsyncAction, "propTypes", _objectSpread({}, propTypes, {}, WrappedComponent.propTypes)), defineProperty_default()(AsyncAction, "defaultProps", _objectSpread({}, defaultProps, {}, WrappedComponent.defaultProps)), defineProperty_default()(AsyncAction, "contextType", locale_.TranslatorContext);
      var wrapped = Object(external_react_router_dom_.withRouter)(Object(locale_.withTranslator)(AsyncAction));
      return wrapped.displayName = WrappedComponent.displayName || WrappedComponent.name || "Component", wrapped.WrappedComponent = WrappedComponent, wrapped;
    };

    function AsyncLink_createSuper(Derived) {
      var hasNativeReflectConstruct = function () {
        if ("undefined" == typeof Reflect || !construct_default.a) return !1;
        if (construct_default.a.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Date.prototype.toString.call(construct_default()(Date, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var result,
            Super = getPrototypeOf_default()(Derived);

        if (hasNativeReflectConstruct) {
          var NewTarget = getPrototypeOf_default()(this).constructor;
          result = construct_default()(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);

        return possibleConstructorReturn_default()(this, result);
      };
    }

    var getHref = function getHref(to, history) {
      if (!to) return;
      var locationTo = "string" == typeof to ? Object(external_history_.createLocation)(to, null, null, history.location) : to;
      return history.createHref(locationTo);
    },
        isRecalculationNeeded = function isRecalculationNeeded(_ref5, _ref6) {
      var _ref7 = _slicedToArray(_ref5, 2),
          to1 = _ref7[0],
          history1 = _ref7[1];

      var _ref8 = _slicedToArray(_ref6, 2),
          to2 = _ref8[0],
          history2 = _ref8[1];

      return to1 === to2 && history1.location === history2.location;
    };

    var AsyncLink_AsyncLinkInternal = function (_Component) {
      inherits_default()(AsyncLinkInternal, _Component);

      var _super = AsyncLink_createSuper(AsyncLinkInternal);

      function AsyncLinkInternal() {
        var _this;

        for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
          args[_key3] = arguments[_key3];
        }

        return classCallCheck_default()(this, AsyncLinkInternal), _this = _super.call.apply(_super, [this].concat(args)), defineProperty_default()(assertThisInitialized_default()(_this), "getHref", external_memoize_one_default()(getHref, isRecalculationNeeded)), _this;
      }

      return createClass_default()(AsyncLinkInternal, [{
        key: "render",
        value: function value() {
          var _this$props = this.props,
              onClick = _this$props.onClick,
              to = _this$props.to,
              history = _this$props.history,
              children = _this$props.children,
              rest = (_this$props.location, _this$props.match, _this$props.loading, _this$props.trigger, _this$props.onTrigger, objectWithoutProperties_default()(_this$props, ["onClick", "to", "history", "children", "location", "match", "loading", "trigger", "onTrigger"]));
          return external_react_default.a.createElement(components_.Link, extends_default()({
            onClick: onClick,
            href: this.getHref(to, history)
          }, rest), children);
        }
      }]), AsyncLinkInternal;
    }(external_react_.Component);

    defineProperty_default()(AsyncLink_AsyncLinkInternal, "propTypes", {
      failTo: external_prop_types_default.a.oneOfType([external_prop_types_default.a.string, external_prop_types_default.a.object]),
      failToMessage: external_prop_types_default.a.string,
      message: prop_types_.intlMessageShape,
      replace: external_prop_types_default.a.bool,
      to: external_prop_types_default.a.oneOfType([external_prop_types_default.a.string, external_prop_types_default.a.object]),
      toMessage: external_prop_types_default.a.string,
      trigger: Object(prop_types_.deprecated)(external_prop_types_default.a.func, "5.0.0", "Please use onTrigger instead"),
      onTrigger: external_prop_types_default.a.func.isRequired,
      onClick: external_prop_types_default.a.func,
      children: external_prop_types_default.a.node,
      className: external_prop_types_default.a.string
    }), defineProperty_default()(AsyncLink_AsyncLinkInternal, "metadataType", uimetadata_.metadataTypes.ACTION), defineProperty_default()(AsyncLink_AsyncLinkInternal, "displayName", "AsyncLink");
    var AsyncLink = withAsyncAction(AsyncLink_AsyncLinkInternal);
    AsyncLink_AsyncLinkInternal.__docgenInfo = {
      componentName: "AsyncLink",
      packageName: "@jutro/router",
      description: "AsyncLink is a Jutro component,\ndesigned following the principles of Link (React Router 4).\nAsyncLink invokes the trigger and wait for promise to be resolved or rejected.\nMeanwhile the promise is in execution, the component updates its content within the message provided by property {message}\nCase promise has been resolved, AsyncLink attempts to navigate to destination provided by property {to}\nCase promise has been rejected, AsyncLink attempts to navigate to destination provided by property {failTo}\n\nAsyncLink automatically adds the href for anchor tag having the to property defined; It follows the react-router-4 implementation:\nhttps://github.com/ReactTraining/react-router/blob/master/packages/react-router-dom/modules/Link.js",
      displayName: "AsyncLink",
      methods: [],
      actualName: "AsyncLinkInternal",
      metadataType: "action",
      props: {
        failTo: {
          type: {
            name: "union",
            value: [{
              name: "string"
            }, {
              name: "object"
            }]
          },
          required: !1,
          description: "The destination path when promise is rejected; can be an object like <Link to>"
        },
        failToMessage: {
          type: {
            name: "string"
          },
          required: !1,
          description: "The message shown when promise is rejected; shown if 'failTo' is not provided"
        },
        message: {
          type: {
            name: "union",
            value: [{
              name: "string"
            }, {
              name: "shape",
              value: {
                id: {
                  name: "string",
                  required: !1
                },
                defaultMessage: {
                  name: "string",
                  required: !1
                }
              }
            }]
          },
          required: !1,
          description: "The message shown when executing trigger/promise"
        },
        replace: {
          type: {
            name: "bool"
          },
          required: !1,
          description: "The replace prop will replace the current entry in the history stack"
        },
        to: {
          type: {
            name: "union",
            value: [{
              name: "string"
            }, {
              name: "object"
            }]
          },
          required: !1,
          description: "The destination path when promise is resolved; can be an object like <Link to>"
        },
        toMessage: {
          type: {
            name: "string"
          },
          required: !1,
          description: "The message shown when promise is resolved; shown if 'to' is not provided"
        },
        trigger: {
          type: {
            name: "func"
          },
          required: !1,
          description: "@deprecated The method used to trigger the promise",
          deprecationInfo: {
            version: "5.0.0",
            mapTo: null
          }
        },
        onTrigger: {
          type: {
            name: "func"
          },
          required: !0,
          description: "The method used to trigger the promise"
        },
        onClick: {
          type: {
            name: "func"
          },
          required: !1,
          description: "The method to be called before (instead in case of event.preventDefault been called) built-in onClick handler"
        },
        children: {
          type: {
            name: "node"
          },
          required: !1,
          description: "The children elements to render inside of the AsyncLink"
        },
        className: {
          type: {
            name: "string"
          },
          required: !1,
          description: "CSS class name for this component"
        }
      }
    };

    var AsyncButtonLink_module = __webpack_require__("./AsyncButtonLink/AsyncButtonLink.module.scss"),
        AsyncButtonLink_module_default = __webpack_require__.n(AsyncButtonLink_module);

    function AsyncButtonLink_createSuper(Derived) {
      var hasNativeReflectConstruct = function () {
        if ("undefined" == typeof Reflect || !construct_default.a) return !1;
        if (construct_default.a.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Date.prototype.toString.call(construct_default()(Date, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var result,
            Super = getPrototypeOf_default()(Derived);

        if (hasNativeReflectConstruct) {
          var NewTarget = getPrototypeOf_default()(this).constructor;
          result = construct_default()(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);

        return possibleConstructorReturn_default()(this, result);
      };
    }

    var AsyncButtonLink_AsyncButtonLinkInternal = function (_Component) {
      inherits_default()(AsyncButtonLinkInternal, _Component);

      var _super = AsyncButtonLink_createSuper(AsyncButtonLinkInternal);

      function AsyncButtonLinkInternal() {
        return classCallCheck_default()(this, AsyncButtonLinkInternal), _super.apply(this, arguments);
      }

      return createClass_default()(AsyncButtonLinkInternal, [{
        key: "render",
        value: function value() {
          var _this$props = this.props,
              className = _this$props.className,
              onClick = _this$props.onClick,
              children = _this$props.children,
              innerRef = _this$props.innerRef,
              loading = _this$props.loading,
              props = (_this$props.trigger, _this$props.onTrigger, _this$props.failTo, objectWithoutProperties_default()(_this$props, ["className", "onClick", "children", "innerRef", "loading", "trigger", "onTrigger", "failTo"])),
              classes = external_classnames_default()(AsyncButtonLink_module_default.a.asyncButtonLink, className);
          return loading && delete props.icon, external_react_default.a.createElement(components_.Button, extends_default()({}, props, {
            onClick: onClick,
            ref: innerRef,
            className: classes
          }), children);
        }
      }]), AsyncButtonLinkInternal;
    }(external_react_.Component);

    defineProperty_default()(AsyncButtonLink_AsyncButtonLinkInternal, "propTypes", _objectSpread({}, components_.Button.propTypes, {
      failTo: external_prop_types_default.a.oneOfType([external_prop_types_default.a.string, external_prop_types_default.a.object]),
      failToMessage: external_prop_types_default.a.string,
      message: prop_types_.intlMessageShape,
      replace: external_prop_types_default.a.bool,
      to: external_prop_types_default.a.oneOfType([external_prop_types_default.a.string, external_prop_types_default.a.object]),
      toMessage: external_prop_types_default.a.string,
      trigger: Object(prop_types_.deprecated)(external_prop_types_default.a.func, "5.0.0", "Please use onTrigger instead"),
      onTrigger: external_prop_types_default.a.func.isRequired,
      onClick: external_prop_types_default.a.func,
      children: external_prop_types_default.a.oneOfType([external_prop_types_default.a.node, prop_types_.intlMessageShape]),
      className: external_prop_types_default.a.string,
      innerRef: external_prop_types_default.a.oneOfType([external_prop_types_default.a.string, external_prop_types_default.a.func])
    })), defineProperty_default()(AsyncButtonLink_AsyncButtonLinkInternal, "defaultProps", _objectSpread({}, components_.Button.defaultProps)), defineProperty_default()(AsyncButtonLink_AsyncButtonLinkInternal, "displayName", "AsyncButtonLink");
    var AsyncButtonLink = withAsyncAction(AsyncButtonLink_AsyncButtonLinkInternal);
    AsyncButtonLink_AsyncButtonLinkInternal.__docgenInfo = {
      componentName: "AsyncButtonLink",
      packageName: "@jutro/router",
      description: "AsyncButtonLink is a Jutro component,\ndesigned following the principles of Link (React Router 4).\nAsyncButtonLink invokes the trigger and wait for promise to be resolved or rejected.\nMeanwhile the promise is in execution, the component updates its content within the message provided by property {message}\nCase promise has been resolved, AsyncButtonLink attempts to navigate to destination provided by property {to}\nCase promise has been rejected, AsyncButtonLink attempts to navigate to destination provided by property {failTo}",
      displayName: "AsyncButtonLink",
      methods: [],
      actualName: "AsyncButtonLinkInternal",
      metadataType: "action",
      props: {
        failTo: {
          type: {
            name: "union",
            value: [{
              name: "string"
            }, {
              name: "object"
            }]
          },
          required: !1,
          description: "The destination path when promise is rejected; can be an object like <Link to>"
        },
        failToMessage: {
          type: {
            name: "string"
          },
          required: !1,
          description: "The message shown when promise is rejected; shown if 'failTo' is not provided"
        },
        message: {
          type: {
            name: "union",
            value: [{
              name: "string"
            }, {
              name: "shape",
              value: {
                id: {
                  name: "string",
                  required: !1
                },
                defaultMessage: {
                  name: "string",
                  required: !1
                }
              }
            }]
          },
          required: !1,
          description: "The message shown when executing trigger/promise"
        },
        replace: {
          type: {
            name: "bool"
          },
          required: !1,
          description: "The replace prop will replace the current entry in the history stack"
        },
        to: {
          type: {
            name: "union",
            value: [{
              name: "string"
            }, {
              name: "object"
            }]
          },
          required: !1,
          description: "The destination path when promise is resolved; can be an object like <Link to>"
        },
        toMessage: {
          type: {
            name: "string"
          },
          required: !1,
          description: "The message shown when promise is resolved; shown if 'to' is not provided"
        },
        trigger: {
          type: {
            name: "func"
          },
          required: !1,
          description: "@deprecated The method used to trigger the promise",
          deprecationInfo: {
            version: "5.0.0",
            mapTo: null
          }
        },
        onTrigger: {
          type: {
            name: "func"
          },
          required: !0,
          description: "The method used to trigger the promise"
        },
        onClick: {
          type: {
            name: "func"
          },
          required: !1,
          description: "The method to be called before (instead in case of event.preventDefault been called) built-in onClick handler"
        },
        children: {
          type: {
            name: "union",
            value: [{
              name: "node"
            }, {
              name: "union",
              value: [{
                name: "string"
              }, {
                name: "shape",
                value: {
                  id: {
                    name: "string",
                    required: !1
                  },
                  defaultMessage: {
                    name: "string",
                    required: !1
                  }
                }
              }]
            }]
          },
          required: !1,
          description: "The children elements to render inside of the AsyncLink"
        },
        className: {
          type: {
            name: "string"
          },
          required: !1,
          description: "CSS class name for this component"
        },
        innerRef: {
          type: {
            name: "union",
            value: [{
              name: "string"
            }, {
              name: "func"
            }]
          },
          required: !1,
          description: "Get ref to the inner rendered <a> or <button>"
        }
      },
      composes: ["@jutro/components"]
    };

    var external_react_router_ = __webpack_require__("react-router"),
        ButtonLink_module = __webpack_require__("./ButtonLink/ButtonLink.module.scss"),
        ButtonLink_module_default = __webpack_require__.n(ButtonLink_module);

    function ButtonLink_createSuper(Derived) {
      var hasNativeReflectConstruct = function () {
        if ("undefined" == typeof Reflect || !construct_default.a) return !1;
        if (construct_default.a.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Date.prototype.toString.call(construct_default()(Date, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var result,
            Super = getPrototypeOf_default()(Derived);

        if (hasNativeReflectConstruct) {
          var NewTarget = getPrototypeOf_default()(this).constructor;
          result = construct_default()(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);

        return possibleConstructorReturn_default()(this, result);
      };
    }

    var ButtonLink_ButtonLinkInternal = function (_Component) {
      inherits_default()(ButtonLinkInternal, _Component);

      var _super = ButtonLink_createSuper(ButtonLinkInternal);

      function ButtonLinkInternal() {
        var _this;

        for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
          args[_key4] = arguments[_key4];
        }

        return classCallCheck_default()(this, ButtonLinkInternal), _this = _super.call.apply(_super, [this].concat(args)), defineProperty_default()(assertThisInitialized_default()(_this), "handleClick", function (event) {
          var _this$props = _this.props,
              onClick = _this$props.onClick,
              target = _this$props.target,
              href = _this$props.href;

          if (onClick && onClick(event), !href && !(event.defaultPrevented || void 0 !== event.button && 0 !== event.button || target)) {
            event.preventDefault();
            var history = _this.props.history;
            if (!history) return;
            var _this$props2 = _this.props,
                replace = _this$props2.replace,
                to = _this$props2.to;
            replace ? history.replace(to) : history.push(to);
          }
        }), _this;
      }

      return createClass_default()(ButtonLinkInternal, [{
        key: "render",
        value: function value() {
          var _this$props3 = this.props,
              to = (_this$props3.onClick, _this$props3.replace, _this$props3.to),
              href = _this$props3.href,
              innerRef = _this$props3.innerRef,
              className = _this$props3.className,
              other = (_this$props3.staticContext, objectWithoutProperties_default()(_this$props3, ["onClick", "replace", "to", "href", "innerRef", "className", "staticContext"]));
          to || href || logger_.log.error('"href" or "to". One of these properties is required for the component ButtonLink. Use "to" for internal routing and "href" for external routing');
          var classes = external_classnames_default()(ButtonLink_module_default.a.buttonLink, className);
          return external_react_default.a.createElement(components_.Button, extends_default()({
            href: href,
            onClick: this.handleClick
          }, other, {
            ref: innerRef,
            className: classes
          }));
        }
      }]), ButtonLinkInternal;
    }(external_react_.Component);

    defineProperty_default()(ButtonLink_ButtonLinkInternal, "propTypes", {
      replace: external_prop_types_default.a.bool,
      to: external_prop_types_default.a.oneOfType([external_prop_types_default.a.string, external_prop_types_default.a.object]),
      href: external_prop_types_default.a.string,
      innerRef: external_prop_types_default.a.oneOfType([external_prop_types_default.a.string, external_prop_types_default.a.func]),
      children: external_prop_types_default.a.oneOfType([external_prop_types_default.a.node, prop_types_.intlMessageShape]),
      onClick: external_prop_types_default.a.func,
      className: external_prop_types_default.a.string
    }), defineProperty_default()(ButtonLink_ButtonLinkInternal, "displayName", "ButtonLink"), defineProperty_default()(ButtonLink_ButtonLinkInternal, "defaultProps", _objectSpread({}, components_.Button.defaultProps, {
      replace: !1
    }));
    var ButtonLink = Object(external_react_router_.withRouter)(ButtonLink_ButtonLinkInternal);
    ButtonLink_ButtonLinkInternal.__docgenInfo = {
      componentName: "ButtonLink",
      packageName: "@jutro/router",
      description: "ButtonLink is an Jutro component,",
      displayName: "ButtonLink",
      methods: [{
        name: "handleClick",
        docblock: "'onClick' callback to invoke callback and continue navigation\n\n@param {Event} event - event object",
        modifiers: [],
        params: [{
          name: "event",
          description: "event object",
          type: {
            name: "Event"
          },
          optional: !1
        }],
        returns: null,
        description: "'onClick' callback to invoke callback and continue navigation"
      }],
      actualName: "ButtonLinkInternal",
      metadataType: "action",
      props: {
        replace: {
          type: {
            name: "bool"
          },
          required: !1,
          description: "The replace prop will replace the current entry in the history stack",
          defaultValue: {
            value: "false",
            computed: !1
          }
        },
        to: {
          type: {
            name: "union",
            value: [{
              name: "string"
            }, {
              name: "object"
            }]
          },
          required: !1,
          description: "The destination path when promise is resolved; can be an object like <Link to>.\nUse this for paths internal to the application."
        },
        href: {
          type: {
            name: "string"
          },
          required: !1,
          description: "The destination path when promise is resolved;\nUse this for paths external to the application."
        },
        innerRef: {
          type: {
            name: "union",
            value: [{
              name: "string"
            }, {
              name: "func"
            }]
          },
          required: !1,
          description: "Get ref to the inner rendered <a> or <button>"
        },
        children: {
          type: {
            name: "union",
            value: [{
              name: "node"
            }, {
              name: "union",
              value: [{
                name: "string"
              }, {
                name: "shape",
                value: {
                  id: {
                    name: "string",
                    required: !1
                  },
                  defaultMessage: {
                    name: "string",
                    required: !1
                  }
                }
              }]
            }]
          },
          required: !1,
          description: "The child element wrapped in the component"
        },
        onClick: {
          type: {
            name: "func"
          },
          required: !1,
          description: "Callback when button is clicked"
        },
        className: {
          type: {
            name: "string"
          },
          required: !1,
          description: "CSS class name for this component"
        }
      }
    };

    var is_array_ = __webpack_require__("@babel/runtime-corejs3/core-js-stable/array/is-array"),
        is_array_default = __webpack_require__.n(is_array_),
        isString = __webpack_require__("../../node_modules/lodash/isString.js"),
        isString_default = __webpack_require__.n(isString),
        external_react_helmet_ = __webpack_require__("react-helmet");

    var PageTitle = function PageTitle(props) {
      var title = props.title;
      return external_react_default.a.createElement(external_react_helmet_.Helmet, null, external_react_default.a.createElement("title", null, title));
    };

    PageTitle.propTypes = {
      title: external_prop_types_default.a.string.isRequired
    }, PageTitle.__docgenInfo = {
      componentName: "PageTitle",
      packageName: "@jutro/router",
      description: "PageHead component provides an api to configure and manipulate\nthe head tag title property on the page",
      displayName: "PageTitle",
      methods: [],
      actualName: "PageTitle",
      props: {
        title: {
          type: {
            name: "string"
          },
          required: !0,
          description: "Page title text"
        }
      }
    };
    var logDeprecationWarning = Object(logger_.makeUniqueWarningLog)("Support for componentMaps with case-insensitive keys has been deprecated. Adjust the keys in your componentMap to match the name of the component");

    var NavRoutes = function NavRoutes(_ref9) {
      var routes = _ref9.routes,
          resolveComponentMap = _ref9.resolveComponentMap,
          resolveComponentCallback = _ref9.resolveComponent;
      var translator = Object(external_react_.useContext)(locale_.TranslatorContext),
          routesArray = is_array_default()(routes) ? routes : routes.routes;
      return external_react_default.a.createElement(external_react_router_dom_.Switch, null, null == routesArray ? void 0 : map_default()(routesArray).call(routesArray, function renderNavRoute(routeProps) {
        var _context;

        return routeProps.routes ? map_default()(_context = routeProps.routes).call(_context, renderNavRoute) : routeProps.redirect ? function (_ref10) {
          var redirect = _ref10.redirect,
              title = _ref10.title,
              showOnNavBar = _ref10.showOnNavBar,
              other = _objectWithoutProperties(_ref10, ["redirect", "title", "showOnNavBar"]);

          return external_react_default.a.createElement(external_react_router_dom_.Route, extends_default()({
            key: redirect || title
          }, other, {
            render: function render() {
              return external_react_default.a.createElement(external_react_router_dom_.Redirect, {
                to: Object(platform_.sanitizeUrl)(redirect)
              });
            }
          }));
        }(routeProps) : routeProps.component ? function (routeProps) {
          var component = routeProps.component,
              _routeProps$component = routeProps.componentProps,
              componentProps = void 0 === _routeProps$component ? {} : _routeProps$component,
              title = (routeProps.navLink, routeProps.title),
              other = (routeProps.showOnNavBar, objectWithoutProperties_default()(routeProps, ["component", "componentProps", "navLink", "title", "showOnNavBar"])),
              ResolvedComponent = resolveComponentCallback(component, resolveComponentMap);
          return external_react_default.a.createElement(external_react_router_dom_.Route, extends_default()({
            key: other.path || title
          }, other), external_react_default.a.createElement(external_react_default.a.Fragment, null, external_react_default.a.createElement(PageTitle, {
            title: translator(title)
          }), external_react_default.a.createElement(ResolvedComponent, componentProps)));
        }(routeProps) : void Object(logger_.warning)("Either redirect or component must be provided for every route definition");
      }));
    };

    NavRoutes.propTypes = {
      routes: external_prop_types_default.a.arrayOf(external_prop_types_default.a.object).isRequired,
      resolveComponentMap: external_prop_types_default.a.object.isRequired,
      resolveComponent: external_prop_types_default.a.func
    }, NavRoutes.defaultProps = {
      resolveComponent: function resolveComponent(component) {
        var componentMap = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        if (isString_default()(component)) {
          var resolvedComponent = componentMap[component];
          return resolvedComponent || (logDeprecationWarning(), resolvedComponent = componentMap[component.toLowerCase()]), resolvedComponent;
        }

        return component;
      }
    }, NavRoutes.__docgenInfo = {
      componentName: "NavRoutes",
      packageName: "@jutro/router",
      description: "",
      displayName: "NavRoutes",
      methods: [],
      actualName: "NavRoutes",
      props: {
        routes: {
          type: {
            name: "arrayOf",
            value: {
              name: "object"
            }
          },
          required: !0,
          description: "Routing metadata object"
        },
        resolveComponentMap: {
          type: {
            name: "object"
          },
          required: !0,
          description: "Map of component name to component classes (required if using route metadata in json files)"
        },
        resolveComponent: {
          type: {
            name: "func"
          },
          required: !1,
          description: "Optional callback function to resolve component; const Component = resolveComponent(componentName, componentMap)",
          defaultValue: {
            value: "function resolveComponentFromMap(component, componentMap = {}) {\n    if (isString(component)) {\n        let resolvedComponent = componentMap[component];\n        if (!resolvedComponent) {\n            logDeprecationWarning();\n            resolvedComponent = componentMap[component.toLowerCase()];\n        }\n        return resolvedComponent;\n    }\n    return component;\n}",
            computed: !1
          }
        }
      }
    };

    var slicedToArray = __webpack_require__("../../node_modules/@babel/runtime-corejs3/helpers/slicedToArray.js"),
        slicedToArray_default = __webpack_require__.n(slicedToArray),
        theme_ = __webpack_require__("@jutro/theme"),
        BurgerMenu_module = __webpack_require__("./BurgerMenu/BurgerMenu.module.scss"),
        BurgerMenu_module_default = __webpack_require__.n(BurgerMenu_module),
        filter_ = __webpack_require__("@babel/runtime-corejs3/core-js-stable/instance/filter"),
        filter_default = __webpack_require__.n(filter_),
        external_react_focus_lock_ = __webpack_require__("react-focus-lock"),
        external_react_focus_lock_default = __webpack_require__.n(external_react_focus_lock_);

    var BurgerMenu_messages_messages = Object(external_react_intl_.defineMessages)({
      openBurgerMenu: {
        id: "jutro-router.BurgerMenu.Open Menu",
        defaultMessage: "Open Menu"
      },
      menuHeaderTitle: {
        id: "jutro-router.BurgerMenu.Menu header title",
        defaultMessage: "Menu"
      },
      closeNavigationLabel: {
        id: "jutro-router.BurgerMenu.Close navigation",
        defaultMessage: "Close navigation"
      }
    });

    var DropdownMenu_module = __webpack_require__("./DropdownMenu/DropdownMenu.module.scss"),
        DropdownMenu_module_default = __webpack_require__.n(DropdownMenu_module);

    var DropdownMenuSeparator = function DropdownMenuSeparator(props) {
      var id = props.id,
          className = props.className,
          separatorClasses = external_classnames_default()(DropdownMenu_module_default.a.dropdownSeparator, className);
      return external_react_default.a.createElement("div", {
        id: id,
        className: separatorClasses,
        role: "separator"
      });
    };

    DropdownMenuSeparator.propTypes = {
      id: external_prop_types_default.a.string,
      className: external_prop_types_default.a.string
    }, DropdownMenuSeparator.__docgenInfo = {
      componentName: "DropdownMenuSeparator",
      packageName: "@jutro/router",
      description: "",
      displayName: "DropdownMenuSeparator",
      methods: [],
      actualName: "DropdownMenuSeparator",
      metadataType: "element",
      props: {
        id: {
          type: {
            name: "string"
          },
          required: !1,
          description: "Used to identify dropdown menu separator component."
        },
        className: {
          type: {
            name: "string"
          },
          required: !1,
          description: "Additional style class for the separator."
        }
      }
    };

    var BurgerSidebarItem = function BurgerSidebarItem(_ref11) {
      var id = _ref11.id,
          separatorClassName = _ref11.separatorClassName,
          children = _ref11.children;
      return external_react_default.a.createElement(external_react_default.a.Fragment, null, external_react_default.a.createElement("div", {
        className: BurgerMenu_module_default.a.separatorContainer
      }, external_react_default.a.createElement(DropdownMenuSeparator, {
        className: separatorClassName
      })), external_react_default.a.createElement("div", {
        className: BurgerMenu_module_default.a.sidebarItem,
        id: id
      }, children));
    };

    BurgerSidebarItem.propTypes = {
      id: external_prop_types_default.a.string.isRequired,
      separatorClassName: external_prop_types_default.a.string,
      children: external_prop_types_default.a.node
    }, BurgerSidebarItem.__docgenInfo = {
      componentName: "BurgerSidebarItem",
      packageName: "@jutro/router",
      description: "BurgerSidebarItem renders single sidebar content element",
      displayName: "BurgerSidebarItem",
      methods: [],
      actualName: "BurgerSidebarItem",
      props: {
        id: {
          type: {
            name: "string"
          },
          required: !0,
          description: "Component unique identifier"
        },
        separatorClassName: {
          type: {
            name: "string"
          },
          required: !1,
          description: "Optional css class to the burger sidebar item separator"
        },
        children: {
          type: {
            name: "node"
          },
          required: !1,
          description: "The item's content."
        }
      }
    };

    var BurgerSidebarInternal = function BurgerSidebarInternal(_ref12) {
      var isOpen = _ref12.isOpen,
          setIsOpen = _ref12.setIsOpen,
          burgerContent = _ref12.burgerContent,
          separatorClassName = _ref12.separatorClassName;

      var translator = Object(external_react_.useContext)(locale_.TranslatorContext),
          visibilityStyles = _defineProperty({}, BurgerMenu_module_default.a.isClosed, !isOpen),
          sidebarClassNames = external_classnames_default()(BurgerMenu_module_default.a.burgerSidebar, visibilityStyles),
          backdropClassNames = external_classnames_default()(BurgerMenu_module_default.a.backdrop, visibilityStyles),
          closeOnClick = function closeOnClick() {
        setIsOpen(!1);
      },
          location = Object(external_react_router_dom_.useLocation)();

      Object(external_react_.useEffect)(closeOnClick, [location.pathname]);
      var burgerSidebarHeader = external_react_default.a.createElement("div", {
        className: BurgerMenu_module_default.a.sidebarHeader
      }, external_react_default.a.createElement("span", {
        className: BurgerMenu_module_default.a.menu
      }, translator(BurgerMenu_messages_messages.menuHeaderTitle)), external_react_default.a.createElement(components_.IconButton, {
        icon: "mi-close",
        size: "medium",
        iconColor: "neutral",
        onClick: closeOnClick,
        className: BurgerMenu_module_default.a.dismissButtonIcon,
        "aria-label": translator(BurgerMenu_messages_messages.closeNavigationLabel)
      })),
          burgerSidebarBackdrop = external_react_default.a.createElement("div", {
        className: backdropClassNames,
        onClick: closeOnClick,
        role: "presentation"
      }),
          filteredBurgerContent = filter_default()(burgerContent).call(burgerContent, Boolean);
      return external_react_default.a.createElement(external_react_default.a.Fragment, null, external_react_default.a.createElement("div", {
        className: sidebarClassNames,
        "aria-hidden": !isOpen
      }, external_react_default.a.createElement(external_react_focus_lock_default.a, {
        noFocusGuards: !0,
        whiteList: function whiteList(node) {
          var _document$getElementB;

          return null === (_document$getElementB = document.getElementById("appSwitcherModal")) || void 0 === _document$getElementB ? void 0 : _document$getElementB.contains(node);
        }
      }, burgerSidebarHeader, map_default()(filteredBurgerContent).call(filteredBurgerContent, function (item, index) {
        var innerId = Object(platform_.uniqueInnerId)("sidebarItemId", "" + index)["" + index];
        return external_react_default.a.createElement(BurgerSidebarItem, {
          id: innerId,
          key: "" + index,
          separatorClassName: separatorClassName
        }, item);
      }))), burgerSidebarBackdrop);
    };

    BurgerSidebarInternal.propTypes = {
      separatorClassName: external_prop_types_default.a.string,
      isOpen: external_prop_types_default.a.bool,
      setIsOpen: external_prop_types_default.a.func,
      burgerContent: external_prop_types_default.a.arrayOf(external_prop_types_default.a.node)
    }, BurgerSidebarInternal.defaultProps = {
      isOpen: !1
    }, BurgerSidebarInternal.displayName = "BurgerSidebar";
    var BurgerSidebar = Object(external_react_router_dom_.withRouter)(BurgerSidebarInternal);
    BurgerSidebarInternal.__docgenInfo = {
      componentName: "BurgerSidebar",
      packageName: "@jutro/router",
      description: "BurgerSidebar renders content of burger menu in a sidebar",
      displayName: "BurgerSidebar",
      methods: [],
      actualName: "BurgerSidebarInternal",
      metadataType: "container",
      props: {
        separatorClassName: {
          type: {
            name: "string"
          },
          required: !1,
          description: "Optional css class to the burger sidebar separator"
        },
        isOpen: {
          type: {
            name: "bool"
          },
          required: !1,
          description: "Sidebar state",
          defaultValue: {
            value: "false",
            computed: !1
          }
        },
        setIsOpen: {
          type: {
            name: "func"
          },
          required: !1,
          description: "Sidebar set state function"
        },
        burgerContent: {
          type: {
            name: "arrayOf",
            value: {
              name: "node"
            }
          },
          required: !1,
          description: "Sidebar content"
        }
      }
    };

    var BurgerMenu = function BurgerMenu(_ref13) {
      var burgerContent = _ref13.burgerContent,
          separatorClassName = _ref13.separatorClassName,
          buttonClassName = _ref13.buttonClassName;

      var _useState = Object(external_react_.useState)(!1),
          _useState2 = slicedToArray_default()(_useState, 2),
          isOpen = _useState2[0],
          setIsOpen = _useState2[1],
          _useState3 = Object(external_react_.useState)(document.body.style.overflow),
          initialBodyOverflow = slicedToArray_default()(_useState3, 1)[0],
          translator = Object(external_react_.useContext)(locale_.TranslatorContext),
          theme = Object(external_react_.useContext)(theme_.ThemeContext),
          toggleSidebar = Object(external_react_.useCallback)(function () {
        return setIsOpen(function (prevIsOpen) {
          return !prevIsOpen;
        });
      }, []),
          handleKeyPress = Object(components_.getKeyPressHandler)(toggleSidebar, ["Enter", " "]);

      Object(external_react_.useEffect)(function () {
        document.body.style.overflow = isOpen ? "hidden" : initialBodyOverflow;
      }, [isOpen]);
      var themeStyles = theme.getStyles("BurgerMenu", BurgerMenu_module_default.a),
          burgerMenuStyles = external_classnames_default()(themeStyles.burgerMenu),
          adjustSidebarMenuToViewportHeight = Object(external_react_.useCallback)(function () {
        var viewportHeight = window.innerHeight;
        document.documentElement.style.setProperty("--burger-menu-sidebar-height", viewportHeight + "px");
      }, []);
      return Object(external_react_.useEffect)(function () {
        return window.addEventListener("resize", adjustSidebarMenuToViewportHeight), function () {
          window.removeEventListener("resize", adjustSidebarMenuToViewportHeight);
        };
      }, [adjustSidebarMenuToViewportHeight]), external_react_default.a.createElement("div", {
        className: burgerMenuStyles
      }, external_react_default.a.createElement("button", {
        className: external_classnames_default()(BurgerMenu_module_default.a.burgerButtonContainer, buttonClassName),
        onClick: toggleSidebar,
        "aria-label": translator(BurgerMenu_messages_messages.openBurgerMenu),
        "aria-expanded": isOpen
      }, external_react_default.a.createElement("div", {
        className: BurgerMenu_module_default.a.burgerButton,
        onKeyPress: handleKeyPress,
        role: "presentation"
      }, external_react_default.a.createElement("div", {
        className: BurgerMenu_module_default.a.burgerButtonBar
      }), external_react_default.a.createElement("div", {
        className: BurgerMenu_module_default.a.burgerButtonBar
      }), external_react_default.a.createElement("div", {
        className: BurgerMenu_module_default.a.burgerButtonBar
      }))), external_react_default.a.createElement(BurgerSidebar, {
        isOpen: isOpen,
        setIsOpen: setIsOpen,
        burgerContent: burgerContent,
        separatorClassName: separatorClassName
      }));
    };

    BurgerMenu.propTypes = {
      burgerContent: external_prop_types_default.a.arrayOf(external_prop_types_default.a.node),
      separatorClassName: external_prop_types_default.a.string,
      buttonClassName: external_prop_types_default.a.string
    }, BurgerMenu.__docgenInfo = {
      componentName: "BurgerMenu",
      packageName: "@jutro/router",
      description: "BurgerMenu component renders burger menu",
      displayName: "BurgerMenu",
      methods: [],
      actualName: "BurgerMenu",
      props: {
        burgerContent: {
          type: {
            name: "arrayOf",
            value: {
              name: "node"
            }
          },
          required: !1,
          description: "Sidebar content"
        },
        separatorClassName: {
          type: {
            name: "string"
          },
          required: !1,
          description: "Optional css class to the burger sidebar separator"
        },
        buttonClassName: {
          type: {
            name: "string"
          },
          required: !1,
          description: "Optional css class to the burger menu button"
        }
      }
    };

    var DropdownMenuHeader = function DropdownMenuHeader(props) {
      var id = props.id,
          title = props.title,
          children = props.children,
          translator = Object(external_react_.useContext)(locale_.TranslatorContext);
      return external_react_default.a.createElement("div", {
        id: id,
        className: DropdownMenu_module_default.a.dropdownHeader
      }, external_react_default.a.createElement("div", {
        className: DropdownMenu_module_default.a.dropdownHeaderTitle,
        role: "none"
      }, translator(title)), children);
    };

    DropdownMenuHeader.propTypes = {
      id: external_prop_types_default.a.string,
      title: external_prop_types_default.a.oneOfType([external_prop_types_default.a.node, prop_types_.intlMessageShape]),
      children: external_prop_types_default.a.node
    }, DropdownMenuHeader.__docgenInfo = {
      componentName: "DropdownMenuHeader",
      packageName: "@jutro/router",
      description: "",
      displayName: "DropdownMenuHeader",
      methods: [],
      actualName: "DropdownMenuHeader",
      metadataType: "container",
      props: {
        id: {
          type: {
            name: "string"
          },
          required: !1,
          description: "Used to identify dropdown menu header component."
        },
        title: {
          type: {
            name: "union",
            value: [{
              name: "node"
            }, {
              name: "union",
              value: [{
                name: "string"
              }, {
                name: "shape",
                value: {
                  id: {
                    name: "string",
                    required: !1
                  },
                  defaultMessage: {
                    name: "string",
                    required: !1
                  }
                }
              }]
            }]
          },
          required: !1,
          description: "The element node representing the header title, in most cases, will be a plain string."
        },
        children: {
          type: {
            name: "node"
          },
          required: !1,
          description: "The component children wrapped by the dropdown menu header component."
        }
      }
    };

    var DropdownMenu = function DropdownMenu(_ref14) {
      var id = _ref14.id,
          renderTrigger = _ref14.renderTrigger,
          _ref14$onRenderTrigge = _ref14.onRenderTrigger,
          onRenderTrigger = _ref14$onRenderTrigge === void 0 ? renderTrigger : _ref14$onRenderTrigge,
          isOpen = _ref14.isOpen,
          dropUp = _ref14.dropUp,
          alignRight = _ref14.alignRight,
          className = _ref14.className,
          menuClassName = _ref14.menuClassName,
          children = _ref14.children,
          focused = _ref14.focused,
          openMenuId = _ref14.openMenuId,
          onMenuOpen = _ref14.onMenuOpen,
          onMenuClose = _ref14.onMenuClose;

      var _context;

      var dropdownMenuRef = Object(external_react_.useRef)(),
          triggerRef = Object(external_react_.useRef)(),
          _useState = Object(external_react_.useState)(null != isOpen && isOpen),
          _useState2 = slicedToArray_default()(_useState, 2),
          isMenuOpen = _useState2[0],
          setIsMenuOpen = _useState2[1],
          componentClasses = external_classnames_default()(DropdownMenu_module_default.a.dropdownMenu, DropdownMenu_module_default.a.dropdownMenuPosition, className),
          menuClasses = external_classnames_default()(DropdownMenu_module_default.a.menu, _defineProperty({}, DropdownMenu_module_default.a["menu-top"], dropUp), _defineProperty({}, DropdownMenu_module_default.a["menu-left"], alignRight), _defineProperty({}, DropdownMenu_module_default.a["menu-active"], isMenuOpen), menuClassName),
          _uniqueInnerId = Object(platform_.uniqueInnerId)(id, "triggerId", "menuId"),
          triggerId = _uniqueInnerId.triggerId,
          menuId = _uniqueInnerId.menuId,
          hideMenuOnClickOut = Object(external_react_.useCallback)(function () {
        isMenuOpen && toggleMenu({
          open: !1,
          moveFocusToTrigger: !0,
          callbackOnClose: !0
        });
      }),
          keyPressHandler = Object(external_react_.useCallback)(function (event) {
        "Escape" === event.key && toggleMenu({
          open: !1,
          moveFocusToTrigger: !0,
          callbackOnClose: !0
        });
      }),
          toggleMenu = Object(external_react_.useCallback)(function (_ref15) {
        var open = _ref15.open,
            moveFocusToTrigger = _ref15.moveFocusToTrigger,
            callbackOnClose = _ref15.callbackOnClose;
        var newIsOpen = void 0 === open ? !isMenuOpen : !!open;

        if (isMenuOpen !== newIsOpen) {
          var _triggerRef$current, _triggerRef$current$f;

          if (newIsOpen && (null == onMenuOpen || onMenuOpen(id)), !newIsOpen && moveFocusToTrigger) null === (_triggerRef$current = triggerRef.current) || void 0 === _triggerRef$current || null === (_triggerRef$current$f = _triggerRef$current.focus) || void 0 === _triggerRef$current$f || _triggerRef$current$f.call(_triggerRef$current);
          !newIsOpen && callbackOnClose && (null == onMenuClose || onMenuClose()), setIsMenuOpen(newIsOpen);
        }
      }, [isMenuOpen, onMenuOpen, onMenuClose]),
          blurHandler = Object(external_react_.useCallback)(function (event) {
        dropdownMenuRef.current.contains(event.relatedTarget) || (event.preventDefault(), toggleMenu({
          open: !1,
          callbackOnClose: !0,
          moveFocusToTrigger: !1
        }));
      }, [toggleMenu]);

      Object(external_react_.useEffect)(function () {
        void 0 !== isOpen && toggleMenu({
          open: isOpen
        });
      }, [isOpen]), Object(external_react_.useEffect)(function () {
        var _triggerRef$current2, _triggerRef$current2$;

        focused && (null === (_triggerRef$current2 = triggerRef.current) || void 0 === _triggerRef$current2 || null === (_triggerRef$current2$ = _triggerRef$current2.focus) || void 0 === _triggerRef$current2$ || _triggerRef$current2$.call(_triggerRef$current2));
      }, [focused]), Object(external_react_.useEffect)(function () {
        var _dropdownMenuRef$curr, _dropdownMenuRef$curr2, _dropdownMenuRef$curr3;

        isMenuOpen && (null === (_dropdownMenuRef$curr = dropdownMenuRef.current) || void 0 === _dropdownMenuRef$curr || null === (_dropdownMenuRef$curr2 = _dropdownMenuRef$curr.children[1]) || void 0 === _dropdownMenuRef$curr2 || null === (_dropdownMenuRef$curr3 = _dropdownMenuRef$curr2.children[0]) || void 0 === _dropdownMenuRef$curr3 || _dropdownMenuRef$curr3.focus());
      }, [isMenuOpen]), Object(external_react_.useEffect)(function () {
        return window.addEventListener("click", hideMenuOnClickOut), window.addEventListener("keydown", keyPressHandler), window.addEventListener("blur", blurHandler), function () {
          window.removeEventListener("click", hideMenuOnClickOut), window.removeEventListener("keydown", keyPressHandler), window.removeEventListener("blur", blurHandler);
        };
      }, [hideMenuOnClickOut, keyPressHandler, blurHandler]);

      var dropdownTrigger = Object(external_react_.useMemo)(function () {
        return onRenderTrigger && onRenderTrigger({
          id: triggerId,
          menuId: menuId,
          isOpen: isMenuOpen,
          ref: triggerRef,
          "aria-haspopup": !0,
          "aria-expanded": isOpen
        }, function (open) {
          return toggleMenu({
            open: open,
            moveFocusToTrigger: !0,
            callbackOnClose: !0
          });
        });
      }, [onRenderTrigger, triggerId, menuId, isMenuOpen, triggerRef, isOpen, toggleMenu]),
          renderItem = function renderItem(child) {
        return external_react_default.a.cloneElement(child, {
          onMenuItemClick: function onMenuItemClick() {
            var _triggerRef$current3, _triggerRef$current3$;

            null == onMenuClose || onMenuClose(), null === (_triggerRef$current3 = triggerRef.current) || void 0 === _triggerRef$current3 || null === (_triggerRef$current3$ = _triggerRef$current3.focus) || void 0 === _triggerRef$current3$ || _triggerRef$current3$.call(_triggerRef$current3);
          }
        });
      },
          mappedChildren = map_default()(_context = external_react_default.a.Children.toArray(children)).call(_context, function (child) {
        var item = renderItem(child);

        if (child.type === DropdownMenuHeader && child.props.children && is_array_default()(child.props.children) && children.length) {
          var _context2;

          var itemChildren = map_default()(_context2 = external_react_default.a.Children.toArray(item.props.children)).call(_context2, function (subChild) {
            if (subChild.props.disabled) return subChild;
            return renderItem(subChild);
          });
          item = external_react_default.a.cloneElement(child, {
            children: itemChildren
          });
        }

        return item;
      });

      return external_react_default.a.createElement("div", {
        className: componentClasses,
        id: id,
        ref: dropdownMenuRef,
        onBlur: blurHandler
      }, dropdownTrigger, external_react_default.a.createElement("div", {
        id: menuId,
        className: menuClasses,
        "aria-hidden": !isMenuOpen,
        "aria-labelledby": triggerId
      }, mappedChildren));
    };

    DropdownMenu.propTypes = {
      id: external_prop_types_default.a.string.isRequired,
      renderTrigger: external_prop_types_default.a.func,
      onRenderTrigger: external_prop_types_default.a.func,
      isOpen: external_prop_types_default.a.bool,
      dropUp: external_prop_types_default.a.bool,
      alignRight: external_prop_types_default.a.bool,
      className: external_prop_types_default.a.string,
      menuClassName: external_prop_types_default.a.string,
      children: external_prop_types_default.a.node,
      focused: external_prop_types_default.a.bool,
      openMenuId: external_prop_types_default.a.string,
      onMenuOpen: external_prop_types_default.a.func,
      onMenuClose: external_prop_types_default.a.func
    }, DropdownMenu.__docgenInfo = {
      componentName: "DropdownMenu",
      packageName: "@jutro/router",
      description: "A dropdown menu where you can add your actions to each item.",
      displayName: "DropdownMenu",
      methods: [],
      actualName: "DropdownMenu",
      metadataType: "container",
      props: {
        id: {
          type: {
            name: "string"
          },
          required: !0,
          description: "Used to identify menu component."
        },
        renderTrigger: {
          type: {
            name: "func"
          },
          required: !1,
          description: "*** deprecated *** The function that generates a component that the user clicks on to show the menu."
        },
        onRenderTrigger: {
          type: {
            name: "func"
          },
          required: !1,
          description: "The function that generates a component that the user clicks on to show the menu.",
          defaultValue: {
            value: "renderTrigger",
            computed: !0
          }
        },
        isOpen: {
          type: {
            name: "bool"
          },
          required: !1,
          description: "The prop that indicates if the menu is currently visible."
        },
        dropUp: {
          type: {
            name: "bool"
          },
          required: !1,
          description: "If `true`, the menu appears above the trigger component."
        },
        alignRight: {
          type: {
            name: "bool"
          },
          required: !1,
          description: "If `true`, items are aligned to the right edge of the menu."
        },
        className: {
          type: {
            name: "string"
          },
          required: !1,
          description: "Override class for dropdown menu"
        },
        menuClassName: {
          type: {
            name: "string"
          },
          required: !1,
          description: "Override class for the inner menu of the dropdown menu"
        },
        children: {
          type: {
            name: "node"
          },
          required: !1,
          description: "The component children wrapped by the dropdown menu component."
        },
        focused: {
          type: {
            name: "bool"
          },
          required: !1,
          description: "If `true`, root element is considered as a currently active one"
        },
        openMenuId: {
          type: {
            name: "string"
          },
          required: !1,
          description: "Optional id of the component instance that's supposed be to currently opened.\nMostly useful when rendering multiple instances next to each other (e.g. within Header)"
        },
        onMenuOpen: {
          type: {
            name: "func"
          },
          required: !1,
          description: "Optional callback that's supposed to be triggered when menu gets opened"
        },
        onMenuClose: {
          type: {
            name: "func"
          },
          required: !1,
          description: "Optional callback that's supposed to be triggered when menu gets closed"
        }
      }
    };

    var DropdownMenuLink = function DropdownMenuLink(props) {
      var id = props.id,
          className = props.className,
          activeClassName = props.activeClassName,
          disabled = props.disabled,
          children = props.children,
          onClickProp = props.onClick,
          visible = props.visible,
          focused = props.focused,
          onMenuItemClick = props.onMenuItemClick,
          to = (props.dangerouslySetInnerHTML, props.to),
          href = props.href,
          target = props.target,
          relProp = props.rel,
          other = objectWithoutProperties_default()(props, ["id", "className", "activeClassName", "disabled", "children", "onClick", "visible", "focused", "onMenuItemClick", "dangerouslySetInnerHTML", "to", "href", "target", "rel"]),
          translator = Object(external_react_.useContext)(locale_.TranslatorContext),
          onClick = Object(external_react_.useMemo)(function () {
        return disabled ? function (evt) {
          return evt.preventDefault();
        } : function (evt) {
          null == onMenuItemClick || onMenuItemClick(), null == onClickProp || onClickProp(evt);
        };
      }, [disabled, onMenuItemClick, onClickProp]),
          linkRef = Object(platform_.useAccessibleRef)(focused);
      if (!1 === visible) return null;
      var translatedChildren = translator(children),
          classes = external_classnames_default()(DropdownMenu_module_default.a.link, _defineProperty({}, DropdownMenu_module_default.a.disabled, disabled), className),
          safeTo = to && Object(platform_.sanitizeUrl)(translator(to));
      if (safeTo) return external_react_default.a.createElement(external_react_router_dom_.NavLink, extends_default()({
        id: id,
        className: classes,
        activeClassName: activeClassName,
        onClick: onClick,
        disabled: disabled,
        "aria-disabled": disabled,
        innerRef: linkRef,
        tabIndex: disabled ? -1 : 0,
        to: safeTo
      }, other), translatedChildren);
      var safeHref = href ? Object(platform_.sanitizeUrl)(href) : safeTo,
          rel = "_blank" === target ? "noreferrer" : relProp;
      return external_react_default.a.createElement("a", extends_default()({
        id: id,
        className: classes,
        onClick: onClick,
        href: safeHref,
        "aria-disabled": disabled,
        ref: linkRef,
        target: target,
        rel: rel,
        tabIndex: disabled ? -1 : 0
      }, other), translatedChildren);
    };

    DropdownMenuLink.propTypes = prop_types_.dropdownMenuLinkPropTypes, DropdownMenuLink.__docgenInfo = {
      componentName: "DropdownMenuLink",
      packageName: "@jutro/router",
      description: "",
      displayName: "DropdownMenuLink",
      methods: [],
      actualName: "DropdownMenuLink",
      metadataType: "action",
      composes: ["@jutro/prop-types"]
    };
    var appSwitcherButtonPropTypes = {
      id: external_prop_types_default.a.string.isRequired,
      togglePopover: external_prop_types_default.a.func,
      hasShownPopover: external_prop_types_default.a.bool,
      isFocused: external_prop_types_default.a.bool,
      iconColor: external_prop_types_default.a.oneOf(components_.availableIconColors),
      iconClassName: external_prop_types_default.a.string,
      onIndexFocusChange: external_prop_types_default.a.func,
      iconSize: external_prop_types_default.a.string
    },
        AppSwitcherButton = external_react_default.a.forwardRef(function (_ref16, ref) {
      var id = _ref16.id,
          togglePopover = _ref16.togglePopover,
          hasShownPopover = _ref16.hasShownPopover,
          iconColor = _ref16.iconColor,
          iconClassName = _ref16.iconClassName,
          isFocused = _ref16.isFocused,
          onIndexFocusChange = _ref16.onIndexFocusChange,
          iconSize = _ref16.iconSize;
      var iconRef = Object(platform_.useAccessibleRef)(isFocused),
          showPopover = Object(external_react_.useCallback)(function () {
        !hasShownPopover && togglePopover();
      }, [hasShownPopover, togglePopover]),
          handleArrowUpPress = Object(external_react_.useCallback)(function (event, isDownKeyPress) {
        isDownKeyPress && (onIndexFocusChange(-1), showPopover()), event.preventDefault();
      }, [onIndexFocusChange, showPopover]),
          handleArrowDownPress = Object(external_react_.useCallback)(function (event, isDownKeyPress) {
        isDownKeyPress && (onIndexFocusChange(0), showPopover()), event.preventDefault();
      }, [onIndexFocusChange, showPopover]);
      return Object(platform_.useKeyPress)(iconRef, ["ArrowUp"], handleArrowUpPress), Object(platform_.useKeyPress)(iconRef, ["ArrowDown"], handleArrowDownPress), external_react_default.a.createElement(components_.IconButton, {
        id: id,
        icon: "mi-apps",
        ref: Object(platform_.combineRefs)(ref, iconRef),
        onClick: togglePopover,
        iconColor: iconColor,
        className: iconClassName,
        "aria-haspopup": "menu",
        "aria-expanded": hasShownPopover,
        size: iconSize
      });
    });
    AppSwitcherButton.displayName = "AppSwitcherButton", AppSwitcherButton.propTypes = appSwitcherButtonPropTypes, AppSwitcherButton.__docgenInfo = {
      componentName: "AppSwitcherButton",
      packageName: "@jutro/router",
      description: "",
      displayName: "AppSwitcherButton",
      methods: [],
      actualName: "AppSwitcherButton",
      props: {
        id: {
          type: {
            name: "string"
          },
          required: !0,
          description: "Used to identify this component."
        },
        togglePopover: {
          type: {
            name: "func"
          },
          required: !1,
          description: "Callback to toggle the popover"
        },
        hasShownPopover: {
          type: {
            name: "bool"
          },
          required: !1,
          description: "Flag states if the popover is currently opened"
        },
        isFocused: {
          type: {
            name: "bool"
          },
          required: !1,
          description: "Flag states if the trigger icon should be focused"
        },
        iconColor: {
          type: {
            name: "enum",
            computed: !1,
            value: [{
              value: "'light'",
              computed: !1
            }, {
              value: "'neutral'",
              computed: !1
            }, {
              value: "'dark'",
              computed: !1
            }]
          },
          required: !1,
          description: "The color of the icon"
        },
        iconClassName: {
          type: {
            name: "string"
          },
          required: !1,
          description: "CSS class name of the icon"
        },
        onIndexFocusChange: {
          type: {
            name: "func"
          },
          required: !1,
          description: "Callback to set a new focused index"
        },
        iconSize: {
          type: {
            name: "string"
          },
          required: !1,
          description: "The size of trigger icon"
        }
      }
    };

    var AppSwitcher_module = __webpack_require__("./AppSwitcher/AppSwitcher.module.scss"),
        AppSwitcher_module_default = __webpack_require__.n(AppSwitcher_module);

    function renderLink(_ref17, translator) {
      var label = _ref17.label,
          onClick = _ref17.onClick,
          href = _ref17.href,
          className = _ref17.className,
          textClassName = _ref17.textClassName;
      if (!label || !onClick && !href) return null;
      var props = {
        children: translator(label),
        href: href,
        onClick: onClick,
        className: className,
        textClassName: textClassName
      };
      return external_react_default.a.createElement(components_.Link, props);
    }

    var AppSwitcher = function AppSwitcher(_ref18) {
      var id = _ref18.id,
          className = _ref18.className,
          items = _ref18.items,
          onRouteClick = _ref18.onRouteClick,
          iconColor = _ref18.iconColor,
          iconClassName = _ref18.iconClassName,
          iconSize = _ref18.iconSize,
          footerText = _ref18.footerText,
          footerUrl = _ref18.footerUrl,
          onFooterClick = _ref18.onFooterClick,
          isDropdown = _ref18.isDropdown;

      var translator = Object(external_react_.useContext)(locale_.TranslatorContext),
          themeStyles = Object(external_react_.useContext)(theme_.ThemeContext).getStyles("AppSwitcher", AppSwitcher_module_default.a),
          containerClasses = external_classnames_default()(themeStyles.appSwitcher, className),
          dropdownMenuProps = {
        id: id,
        isOpen: !1,
        dropUp: !1,
        alignRight: !0,
        menuClassName: themeStyles.menu
      },
          AppSwitcherButtonId = Object(platform_.uniqueInnerId)(id, ["button"]).button,
          itemsClasses = external_classnames_default()(themeStyles.items, _defineProperty({}, themeStyles.itemsModal, !isDropdown)),
          onFooterClickCallback = function onFooterClickCallback(event) {
        onFooterClick && onFooterClick(event), onRouteClick && onRouteClick();
      },
          renderContent = function renderContent() {
        return external_react_default.a.createElement(external_react_default.a.Fragment, null, external_react_default.a.createElement("div", {
          className: itemsClasses
        }, null == items ? void 0 : map_default()(items).call(items, function (item, index) {
          if (item.hasOwnProperty("separator")) return external_react_default.a.createElement(DropdownMenuSeparator, {
            key: index,
            className: themeStyles.separator
          });
          var title = item.title,
              imageUrl = item.imageUrl,
              imageAlt = item.imageAlt,
              to = item.to,
              href = item.href,
              _onClick = item.onClick,
              translatedTitle = translator(title);
          return external_react_default.a.createElement(DropdownMenuLink, {
            className: themeStyles.item,
            to: Object(platform_.sanitizeUrl)(to),
            href: href,
            onClick: function onClick(event) {
              _onClick && _onClick(event), onRouteClick && onRouteClick();
            },
            key: index
          }, external_react_default.a.createElement("img", {
            src: imageUrl,
            className: themeStyles.itemIcon,
            alt: imageAlt || translatedTitle
          }), external_react_default.a.createElement("div", {
            className: themeStyles.itemLabel
          }, translatedTitle));
        })), external_react_default.a.createElement("div", {
          className: themeStyles.footer
        }, renderLink({
          label: footerText,
          href: Object(platform_.sanitizeUrl)(footerUrl),
          onClick: onFooterClickCallback,
          className: themeStyles.footerLink,
          textClassName: themeStyles.footerText
        }, translator)));
      };

      return isDropdown ? external_react_default.a.createElement(DropdownMenu, extends_default()({}, dropdownMenuProps, {
        className: containerClasses,
        onRenderTrigger: function onRenderTrigger(_ref19, toggleMenu) {
          var isOpen = _ref19.isOpen,
              ref = _ref19.ref;
          return external_react_default.a.createElement(AppSwitcherButton, {
            id: AppSwitcherButtonId,
            togglePopover: toggleMenu,
            ref: ref,
            hasShownPopover: isOpen,
            iconColor: iconColor,
            iconClassName: iconClassName,
            iconSize: iconSize
          });
        }
      }), renderContent()) : external_react_default.a.createElement("div", {
        className: containerClasses
      }, renderContent());
    },
        separatorPropType = external_prop_types_default.a.shape({
      separator: external_prop_types_default.a.bool
    });

    AppSwitcher.displayName = "AppSwitcher", AppSwitcher.propTypes = {
      id: external_prop_types_default.a.string.isRequired,
      className: external_prop_types_default.a.string,
      items: external_prop_types_default.a.oneOfType([external_prop_types_default.a.arrayOf(prop_types_.appSwitcherRoutePropTypes), separatorPropType]),
      onRouteClick: external_prop_types_default.a.func,
      iconColor: external_prop_types_default.a.oneOf(components_.availableIconColors),
      iconClassName: external_prop_types_default.a.string,
      iconSize: external_prop_types_default.a.string,
      footerText: prop_types_.intlMessageShape,
      footerUrl: external_prop_types_default.a.string,
      onFooterClick: external_prop_types_default.a.func
    }, AppSwitcher.defaultProps = {
      isDropdown: !0
    }, renderLink.__docgenInfo = {
      componentName: "renderLink",
      packageName: "@jutro/router",
      description: "",
      displayName: "renderLink",
      methods: [],
      actualName: "renderLink"
    }, AppSwitcher.__docgenInfo = {
      componentName: "AppSwitcher",
      packageName: "@jutro/router",
      description: "",
      displayName: "AppSwitcher",
      methods: [],
      actualName: "AppSwitcher",
      props: {
        id: {
          type: {
            name: "string"
          },
          required: !0,
          description: "Used to identify this component."
        },
        className: {
          type: {
            name: "string"
          },
          required: !1,
          description: "CSS class name for the wrapper div"
        },
        items: {
          type: {
            name: "union",
            value: [{
              name: "arrayOf",
              value: {
                name: "shape",
                value: {
                  title: {
                    name: "custom",
                    raw: "intlMessageShape",
                    description: "Title that will be displayed below the icon",
                    required: !1
                  },
                  to: {
                    name: "custom",
                    raw: "toShape",
                    description: "Internal path to the application",
                    required: !1
                  },
                  href: {
                    name: "string",
                    description: "External path",
                    required: !1
                  },
                  imageUrl: {
                    name: "string",
                    description: "Source of the image",
                    required: !1
                  },
                  imageAlt: {
                    name: "string",
                    description: "Alternative text of the image",
                    required: !1
                  },
                  exact: {
                    name: "bool",
                    description: "Flag for the exact path matching in react-router",
                    required: !1
                  },
                  onClick: {
                    name: "func",
                    description: "Callback on item click event handler",
                    required: !1
                  },
                  isFocused: {
                    name: "bool",
                    description: "Flag to indicate if the current item is focused",
                    required: !1
                  }
                }
              }
            }, {
              name: "custom",
              raw: "separatorPropType"
            }]
          },
          required: !1,
          description: "Array of Items to be displayed in the menu"
        },
        onRouteClick: {
          type: {
            name: "func"
          },
          required: !1,
          description: "Callback invoked when any route is clicked"
        },
        iconColor: {
          type: {
            name: "enum",
            computed: !1,
            value: [{
              value: "'light'",
              computed: !1
            }, {
              value: "'neutral'",
              computed: !1
            }, {
              value: "'dark'",
              computed: !1
            }]
          },
          required: !1,
          description: "The color of trigger icon"
        },
        iconClassName: {
          type: {
            name: "string"
          },
          required: !1,
          description: "CSS class name for trigger icon"
        },
        iconSize: {
          type: {
            name: "string"
          },
          required: !1,
          description: "The size of trigger icon"
        },
        footerText: {
          type: {
            name: "union",
            value: [{
              name: "string"
            }, {
              name: "shape",
              value: {
                id: {
                  name: "string",
                  required: !1
                },
                defaultMessage: {
                  name: "string",
                  required: !1
                }
              }
            }]
          },
          required: !1,
          description: "Text displayed on footer link"
        },
        footerUrl: {
          type: {
            name: "string"
          },
          required: !1,
          description: "URL to which footer link leads"
        },
        onFooterClick: {
          type: {
            name: "func"
          },
          required: !1,
          description: "Callback which will be triggered when footer link is clicked"
        },
        isDropdown: {
          defaultValue: {
            value: "true",
            computed: !1
          },
          required: !1
        }
      }
    };
    var SideNavigationContext = Object(external_react_.createContext)({
      activeRoute: "",
      setActiveRoute: function setActiveRoute() {}
    });

    var SideNavigation_module = __webpack_require__("./NavBar/SideNavigation/SideNavigation.module.scss"),
        SideNavigation_module_default = __webpack_require__.n(SideNavigation_module),
        NavBarItem_module = __webpack_require__("./NavBar/NavBarItem.module.scss"),
        NavBarItem_module_default = __webpack_require__.n(NavBarItem_module);

    var BurgerAppSwitcherAccordion = function BurgerAppSwitcherAccordion(_ref20) {
      var header = _ref20.header,
          icon = _ref20.icon,
          disabled = _ref20.disabled,
          className = _ref20.className,
          appSwitcherRoutes = _ref20.appSwitcherRoutes,
          appSwitcherTitle = _ref20.appSwitcherTitle;
      var setActiveRoute = Object(external_react_.useContext)(SideNavigationContext).setActiveRoute,
          theme = Object(external_react_.useContext)(theme_.ThemeContext),
          translator = Object(external_react_.useContext)(locale_.TranslatorContext),
          themeStyles = theme.getStyles("SideNavigation", SideNavigation_module_default.a),
          navBarThemeStyles = theme.getStyles("NavBar", NavBarItem_module_default.a),
          burgerThemeStyles = theme.getStyles("Burger", BurgerMenu_module_default.a),
          sideNavAccordionStyles = external_classnames_default()(themeStyles.sideNavAccordion, burgerThemeStyles.burgerAppSwitcherAccordion),
          safeAppSwitcherRoutes = appSwitcherRoutes && appSwitcherRoutes.length && map_default()(appSwitcherRoutes).call(appSwitcherRoutes, function (route) {
        return Object(platform_.sanitizeProps)(route);
      }),
          appSwitcher = safeAppSwitcherRoutes && safeAppSwitcherRoutes.length && external_react_default.a.createElement(AppSwitcher, {
        id: "appSwitcher",
        routes: safeAppSwitcherRoutes,
        title: appSwitcherTitle,
        iconColor: "light",
        iconClassName: themeStyles.headerActionButton,
        iconSize: "large",
        isMobile: !0
      });
      return external_react_default.a.createElement(components_.Accordion, {
        disabled: disabled,
        showFrame: !1,
        closeOthers: !1,
        className: sideNavAccordionStyles
      }, external_react_default.a.createElement(components_.AccordionCard, {
        id: "burgerAppSwitcherAccordionCard",
        cardBodyClassName: themeStyles.cardBody,
        cardTitleClassName: themeStyles.cardTitle,
        cardHeadingClassName: themeStyles.cardHeading,
        collapseClassName: themeStyles.accordionCollapse,
        renderHeader: function renderHeader(isOpen) {
          var iconComponent = icon && external_react_default.a.createElement(components_.Icon, {
            icon: icon,
            className: navBarThemeStyles.navBarItemIcon
          }),
              classes = external_classnames_default()(navBarThemeStyles.navBarItem, navBarThemeStyles.leftNavBarItem, _defineProperty({}, themeStyles.expandedAccordion, isOpen), className),
              chevronClasses = external_classnames_default()(themeStyles.chevron, _defineProperty({}, themeStyles.rightAlignChevron, !0));
          return external_react_default.a.createElement("button", {
            tabIndex: "-1",
            className: classes,
            onClick: function onClick() {
              setActiveRoute("/appSwitcher");
            }
          }, external_react_default.a.createElement(components_.InlineLabel, {
            tag: "div",
            icon: iconComponent,
            className: navBarThemeStyles.titleWrapper
          }, external_react_default.a.createElement("div", {
            className: NavBarItem_module_default.a.titleContentWrapper
          }, external_react_default.a.createElement("span", null, translator(header)), external_react_default.a.createElement(components_.Chevron, {
            className: chevronClasses,
            align: "right",
            chevronIcon: "mi-expand-more",
            size: "small",
            isOpen: isOpen
          }))));
        }
      }, appSwitcher));
    };

    BurgerAppSwitcherAccordion.propTypes = {
      className: external_prop_types_default.a.string,
      header: prop_types_.intlMessageShape.isRequired,
      icon: external_prop_types_default.a.string,
      disabled: external_prop_types_default.a.bool,
      appSwitcherRoutes: external_prop_types_default.a.arrayOf(prop_types_.appSwitcherRoutePropTypes),
      appSwitcherTitle: prop_types_.intlMessageShape
    }, BurgerAppSwitcherAccordion.__docgenInfo = {
      componentName: "BurgerAppSwitcherAccordion",
      packageName: "@jutro/router",
      description: "The `BurgerAppSwitcherAccordion` component is designed as a container for burgerMenu aooSwitcherAccordion",
      displayName: "BurgerAppSwitcherAccordion",
      methods: [],
      actualName: "BurgerAppSwitcherAccordion",
      props: {
        className: {
          type: {
            name: "string"
          },
          required: !1,
          description: "Additional class names for component."
        },
        header: {
          type: {
            name: "union",
            value: [{
              name: "string"
            }, {
              name: "shape",
              value: {
                id: {
                  name: "string",
                  required: !1
                },
                defaultMessage: {
                  name: "string",
                  required: !1
                }
              }
            }]
          },
          required: !0,
          description: "Link header."
        },
        icon: {
          type: {
            name: "string"
          },
          required: !1,
          description: "Icon to render to the left of the header"
        },
        disabled: {
          type: {
            name: "bool"
          },
          required: !1,
          description: "Flag to make item disabled"
        },
        appSwitcherRoutes: {
          type: {
            name: "arrayOf",
            value: {
              name: "shape",
              value: {
                title: {
                  name: "custom",
                  raw: "intlMessageShape",
                  description: "Title that will be displayed below the icon",
                  required: !1
                },
                to: {
                  name: "custom",
                  raw: "toShape",
                  description: "Internal path to the application",
                  required: !1
                },
                href: {
                  name: "string",
                  description: "External path",
                  required: !1
                },
                imageUrl: {
                  name: "string",
                  description: "Source of the image",
                  required: !1
                },
                imageAlt: {
                  name: "string",
                  description: "Alternative text of the image",
                  required: !1
                },
                exact: {
                  name: "bool",
                  description: "Flag for the exact path matching in react-router",
                  required: !1
                },
                onClick: {
                  name: "func",
                  description: "Callback on item click event handler",
                  required: !1
                },
                isFocused: {
                  name: "bool",
                  description: "Flag to indicate if the current item is focused",
                  required: !1
                }
              }
            }
          },
          required: !1,
          description: "App switchers items metadata"
        },
        appSwitcherTitle: {
          type: {
            name: "union",
            value: [{
              name: "string"
            }, {
              name: "shape",
              value: {
                id: {
                  name: "string",
                  required: !1
                },
                defaultMessage: {
                  name: "string",
                  required: !1
                }
              }
            }]
          },
          required: !1,
          description: "Title of AppSwitcher"
        }
      }
    };

    var TopNavigation_module = __webpack_require__("./NavBar/TopNavigation/TopNavigation.module.scss"),
        TopNavigation_module_default = __webpack_require__.n(TopNavigation_module),
        get_ = __webpack_require__("lodash/get"),
        get_default = __webpack_require__.n(get_);

    var renderBadge = function renderBadge(notifications, id, hasDot) {
      var badge = notifications ? external_react_default.a.createElement("span", {
        className: SideNavigation_module_default.a.notificationWrapper
      }, external_react_default.a.createElement(components_.Badge, {
        id: id,
        size: "small",
        type: "primary",
        value: notifications,
        maxValue: 99,
        className: SideNavigation_module_default.a.notifications
      })) : null;
      return badge || hasDot ? external_react_default.a.createElement("span", {
        className: SideNavigation_module_default.a.badgeWrapper
      }, external_react_default.a.createElement("span", {
        className: SideNavigation_module_default.a.badgeDot
      }), badge) : null;
    };

    renderBadge.__docgenInfo = {
      componentName: "renderBadge",
      packageName: "@jutro/router",
      description: "",
      displayName: "renderBadge",
      methods: [],
      actualName: "renderBadge"
    };

    var getIdFromPath = function getIdFromPath(path) {
      var _context;

      var pathArr = filter_default()(_context = path.split("/")).call(_context, Boolean),
          parentPath = pathArr[0],
          childPath = external_lodash_default.a.last(pathArr);
      return parentPath === childPath ? childPath : "".concat(parentPath, "__").concat(childPath);
    },
        NavBarLinkInternal = function NavBarLinkInternal(_ref21) {
      var _external_classnames_8;

      var header = _ref21.header,
          to = _ref21.to,
          exact = _ref21.exact,
          icon = _ref21.icon,
          disabled = _ref21.disabled,
          className = _ref21.className,
          activeClassName = _ref21.activeClassName,
          alignment = _ref21.alignment,
          notifications = _ref21.notifications;
      var setActiveRoute = Object(external_react_.useContext)(SideNavigationContext).setActiveRoute,
          theme = Object(external_react_.useContext)(theme_.ThemeContext),
          translator = Object(external_react_.useContext)(locale_.TranslatorContext),
          linkRef = Object(platform_.useAccessibleRef)(),
          themeStyles = theme.getStyles("NavBar", NavBarItem_module_default.a),
          isTopNavBar = "top" === alignment,
          location = Object(external_react_router_dom_.useLocation)(),
          isActiveRoute = to === location.pathname,
          classes = external_classnames_default()(themeStyles.navBarItem, isTopNavBar ? themeStyles.topNavBarItem : themeStyles.leftNavBarItem, (_external_classnames_8 = {}, _defineProperty(_external_classnames_8, themeStyles.activeTopNavBarItem, isActiveRoute && isTopNavBar), _defineProperty(_external_classnames_8, themeStyles.activeLeftNavBarItem, isActiveRoute && !isTopNavBar), _external_classnames_8), className),
          activeClasses = external_classnames_default()(isTopNavBar ? themeStyles.activeTopNavBarItem : themeStyles.activeLeftNavBarItem, activeClassName),
          iconComponent = icon && external_react_default.a.createElement(components_.Icon, {
        icon: icon,
        className: themeStyles.navBarItemIcon
      }),
          title = external_react_default.a.createElement("span", {
        className: themeStyles.title
      }, translator(header)),
          content = isTopNavBar ? title : external_react_default.a.createElement("div", {
        className: themeStyles.titleContentWrapper
      }, title, renderBadge(notifications, getIdFromPath(to))),
          clickHandler = Object(external_react_.useCallback)(function (event) {
        var _event$persist;

        null === (_event$persist = event.persist) || void 0 === _event$persist || _event$persist.call(event), setActiveRoute(to);
      }, [setActiveRoute, to]);
      return external_react_default.a.createElement(external_react_router_dom_.NavLink, {
        to: Object(platform_.sanitizeUrl)(to),
        exact: exact,
        activeClassName: activeClasses,
        tabIndex: disabled ? -1 : 0,
        disabled: disabled,
        className: classes,
        type: "link",
        role: "menuitem",
        onClick: clickHandler,
        innerRef: linkRef
      }, external_react_default.a.createElement(components_.InlineLabel, {
        tag: "div",
        icon: iconComponent,
        className: themeStyles.titleWrapper
      }, content));
    };

    NavBarLinkInternal.propTypes = {
      className: external_prop_types_default.a.string,
      header: prop_types_.intlMessageShape.isRequired,
      to: external_prop_types_default.a.string.isRequired,
      icon: external_prop_types_default.a.string,
      disabled: external_prop_types_default.a.bool,
      activeClassName: external_prop_types_default.a.string,
      alignment: external_prop_types_default.a.oneOf(["top", "left"]),
      notifications: external_prop_types_default.a.number
    }, NavBarLinkInternal.displayName = "NavBarLink";
    var NavBarLink = Object(external_react_router_dom_.withRouter)(NavBarLinkInternal);
    NavBarLinkInternal.__docgenInfo = {
      componentName: "NavBarLink",
      packageName: "@jutro/router",
      description: "The NavBarLink component is designed as a simple component for presenting a navigation link inside the NavBar container.",
      displayName: "NavBarLink",
      methods: [],
      actualName: "NavBarLinkInternal",
      props: {
        className: {
          type: {
            name: "string"
          },
          required: !1,
          description: "Additional class names for component."
        },
        header: {
          type: {
            name: "union",
            value: [{
              name: "string"
            }, {
              name: "shape",
              value: {
                id: {
                  name: "string",
                  required: !1
                },
                defaultMessage: {
                  name: "string",
                  required: !1
                }
              }
            }]
          },
          required: !0,
          description: "Link header."
        },
        to: {
          type: {
            name: "string"
          },
          required: !0,
          description: "External link."
        },
        icon: {
          type: {
            name: "string"
          },
          required: !1,
          description: "Icon to render to the left of the header"
        },
        disabled: {
          type: {
            name: "bool"
          },
          required: !1,
          description: "Flag to make item disabled"
        },
        activeClassName: {
          type: {
            name: "string"
          },
          required: !1,
          description: "Additional class names for  active component."
        },
        alignment: {
          type: {
            name: "enum",
            value: [{
              value: "'top'",
              computed: !1
            }, {
              value: "'left'",
              computed: !1
            }]
          },
          required: !1,
          description: "Navigation alignment"
        },
        notifications: {
          type: {
            name: "number"
          },
          required: !1,
          description: "The value of the Badge"
        }
      }
    };

    var NavigationContent_module = __webpack_require__("./NavBar/NavigationContent.module.scss"),
        NavigationContent_module_default = __webpack_require__.n(NavigationContent_module);

    var NavigationContent = function NavigationContent(_ref22) {
      var routes = _ref22.routes,
          nestedRoutesComponent = _ref22.nestedRoutesComponent,
          alignment = _ref22.alignment,
          className = _ref22.className;
      var isTop = "top" === alignment,
          classes = external_classnames_default()(NavigationContent_module_default.a.navigationContent, className),
          items = Object(external_react_.useMemo)(function () {
        var _context;

        var index = -1;
        return filter_default()(_context = map_default()(routes).call(routes, function (_ref23) {
          var title = _ref23.title,
              _ref23$navLink = _ref23.navLink,
              navLink = _ref23$navLink === void 0 ? {} : _ref23$navLink,
              _ref23$path = _ref23.path,
              path = _ref23$path === void 0 ? "/" : _ref23$path,
              _ref23$showOnNavBar = _ref23.showOnNavBar,
              showOnNavBar = _ref23$showOnNavBar === void 0 ? !0 : _ref23$showOnNavBar,
              exact = _ref23.exact,
              navRoutes = _ref23.routes,
              nestedRoutesComponentForNavItem = _ref23.nestedRoutesComponent,
              id = _ref23.id;
          if (!showOnNavBar) return null;
          index += 1;

          var navItemProps = _objectSpread({
            header: navLink.text || title,
            icon: navLink.icon,
            to: path,
            exact: exact,
            className: navLink.className,
            activeClassName: navLink.activeClassName,
            alignment: alignment,
            id: navLink.id || id || "navLink_" + index,
            routes: navRoutes,
            role: "menuitem",
            notifications: navLink.notifications
          }, navLink.componentProps),
              routesComponent = get_default()(navRoutes, "length", 0) && (nestedRoutesComponentForNavItem || nestedRoutesComponent),
              NavComponent = navLink.component || routesComponent || NavBarLink;

          return {
            key: path + title + index,
            NavComponent: NavComponent,
            navItemProps: navItemProps
          };
        })).call(_context, function (item) {
          return item;
        });
      }, [routes, alignment, nestedRoutesComponent]);
      return external_react_default.a.createElement("ul", {
        className: classes,
        role: isTop ? "menubar" : "menu",
        tabIndex: "0"
      }, map_default()(items).call(items, function (_ref24) {
        var key = _ref24.key,
            NavComponent = _ref24.NavComponent,
            navItemProps = _ref24.navItemProps;
        return external_react_default.a.createElement("li", {
          className: external_classnames_default()(_defineProperty({}, NavigationContent_module_default.a.topNavigationItem, isTop)),
          role: "none",
          key: key
        }, external_react_default.a.createElement(NavComponent, navItemProps));
      }));
    };

    NavigationContent.propTypes = {
      routes: external_prop_types_default.a.arrayOf(prop_types_.routeShape),
      alignment: external_prop_types_default.a.oneOf(["top", "left"]),
      className: external_prop_types_default.a.string
    }, NavigationContent.__docgenInfo = {
      componentName: "NavigationContent",
      packageName: "@jutro/router",
      description: "",
      displayName: "NavigationContent",
      methods: [],
      actualName: "NavigationContent",
      props: {
        routes: {
          type: {
            name: "arrayOf",
            value: {
              name: "shape",
              value: {
                title: {
                  name: "custom",
                  raw: "intlMessageShape",
                  description: "Route title",
                  required: !1
                },
                path: {
                  name: "string",
                  description: "Route path",
                  required: !1
                },
                showOnNavBar: {
                  name: "bool",
                  description: "When `true` then route will be rendered on nav bar",
                  required: !1
                },
                exact: {
                  name: "bool",
                  description: "When true, will only match if the path matches the location.pathname exactly",
                  required: !1
                },
                navLink: {
                  name: "shape",
                  value: {
                    text: {
                      name: "string",
                      description: "Text for nav link",
                      required: !1
                    },
                    icon: {
                      name: "string",
                      description: "Icon for nav link",
                      required: !1
                    },
                    className: {
                      name: "string",
                      description: "Custom CSS className for nav link",
                      required: !1
                    },
                    activeClassName: {
                      name: "string",
                      description: "Custom CSS className for nav link in active state",
                      required: !1
                    },
                    component: {
                      name: "elementType",
                      description: "React element to render nav item",
                      required: !1
                    }
                  },
                  description: "Nav link props",
                  required: !1
                }
              }
            }
          },
          required: !1,
          description: "Routing metadata object"
        },
        alignment: {
          type: {
            name: "enum",
            value: [{
              value: "'top'",
              computed: !1
            }, {
              value: "'left'",
              computed: !1
            }]
          },
          required: !1,
          description: "Navigation alignment"
        },
        className: {
          type: {
            name: "string"
          },
          required: !1,
          description: "Additional class names for component"
        }
      }
    };

    var every_ = __webpack_require__("@babel/runtime-corejs3/core-js-stable/instance/every"),
        every_default = __webpack_require__.n(every_);

    var removeNavLinkIcon = function removeNavLinkIcon(_ref25) {
      var navLink = _ref25.navLink,
          rest = _objectWithoutProperties(_ref25, ["navLink"]);

      return navLink ? _objectSpread({}, rest, {
        navLink: external_lodash_default.a.omit(navLink, "icon")
      }) : rest;
    };

    var some_ = __webpack_require__("@babel/runtime-corejs3/core-js-stable/instance/some"),
        some_default = __webpack_require__.n(some_);

    var NavBarDropdownInternal = function NavBarDropdownInternal(props) {
      var _external_classnames_10;

      var header = props.header,
          icon = props.icon,
          disabled = props.disabled,
          className = props.className,
          activeClassName = props.activeClassName,
          alignment = props.alignment,
          routes = props.routes,
          id = props.id,
          theme = Object(external_react_.useContext)(theme_.ThemeContext),
          translator = Object(external_react_.useContext)(locale_.TranslatorContext),
          themeStyles = theme.getStyles("NavBar", NavBarItem_module_default.a),
          isTopNavBar = "top" === alignment,
          hasActiveRoute = some_default()(external_lodash_default.a).call(external_lodash_default.a, routes, function (route) {
        return route.path === props.location.pathname;
      }),
          classes = external_classnames_default()(themeStyles.navBarItem, className, isTopNavBar ? themeStyles.topNavBarItem : themeStyles.leftNavBarItem, (_external_classnames_10 = {}, _defineProperty(_external_classnames_10, themeStyles.activeLeftNavBarItem, hasActiveRoute && !isTopNavBar), _defineProperty(_external_classnames_10, themeStyles.activeTopNavBarItem, hasActiveRoute), _defineProperty(_external_classnames_10, activeClassName, hasActiveRoute), _external_classnames_10)),
          iconComponent = icon && external_react_default.a.createElement(components_.Icon, {
        icon: icon,
        className: themeStyles.navBarItemIcon
      }),
          handleRenderTrigger = Object(external_react_.useCallback)(function (_ref26, toggleMenu) {
        var triggerId = _ref26.id,
            isOpen = _ref26.isOpen,
            menuId = _ref26.menuId,
            others = _objectWithoutProperties(_ref26, ["id", "isOpen", "menuId"]);

        return external_react_default.a.createElement("button", extends_default()({
          id: triggerId,
          tabIndex: disabled ? -1 : 0,
          disabled: disabled,
          className: classes,
          onClick: function onClick() {
            toggleMenu(!isOpen);
          },
          "aria-expanded": isOpen
        }, others), external_react_default.a.createElement(components_.InlineLabel, {
          icon: iconComponent
        }, translator(header)), external_react_default.a.createElement(components_.Icon, {
          icon: "mi-expand-more",
          className: themeStyles.navBarItemChevron
        }));
      }, [classes, disabled, header, iconComponent, themeStyles.navBarItemChevron, translator]);
      return external_react_default.a.createElement(DropdownMenu, {
        className: themeStyles.navBarDropdown,
        id: id,
        onRenderTrigger: handleRenderTrigger
      }, routes && map_default()(routes).call(routes, function (_ref27) {
        var title = _ref27.title,
            path = _ref27.path;
        return external_react_default.a.createElement(DropdownMenuLink, {
          key: path,
          activeClassName: NavBarItem_module_default.a.active,
          to: path
        }, title);
      }));
    };

    NavBarDropdownInternal.propTypes = {
      id: external_prop_types_default.a.string,
      className: external_prop_types_default.a.string,
      header: prop_types_.intlMessageShape.isRequired,
      icon: external_prop_types_default.a.string,
      disabled: external_prop_types_default.a.bool,
      alignment: external_prop_types_default.a.oneOf(["top", "left"])
    }, NavBarDropdownInternal.displayName = "NavBarDropdown";
    var NavBarDropdown = Object(external_react_router_dom_.withRouter)(NavBarDropdownInternal);
    NavBarDropdownInternal.__docgenInfo = {
      componentName: "NavBarDropdown",
      packageName: "@jutro/router",
      description: "The NavBarLink component is designed as a simple component for presenting a dropdown inside the NavBar container.",
      displayName: "NavBarDropdown",
      methods: [],
      actualName: "NavBarDropdownInternal",
      props: {
        id: {
          type: {
            name: "string"
          },
          required: !1,
          description: "Used to identify the component"
        },
        className: {
          type: {
            name: "string"
          },
          required: !1,
          description: "Additional class names for component."
        },
        header: {
          type: {
            name: "union",
            value: [{
              name: "string"
            }, {
              name: "shape",
              value: {
                id: {
                  name: "string",
                  required: !1
                },
                defaultMessage: {
                  name: "string",
                  required: !1
                }
              }
            }]
          },
          required: !0,
          description: "Link header."
        },
        icon: {
          type: {
            name: "string"
          },
          required: !1,
          description: "Icon to render to the left of the header"
        },
        disabled: {
          type: {
            name: "bool"
          },
          required: !1,
          description: "Flag to make dropdown disabled"
        },
        alignment: {
          type: {
            name: "enum",
            value: [{
              value: "'top'",
              computed: !1
            }, {
              value: "'left'",
              computed: !1
            }]
          },
          required: !1,
          description: "Navigation alignment"
        }
      }
    };

    var TopNavigation = function TopNavigation(_ref28) {
      var className = _ref28.className,
          routes = _ref28.routes,
          wrap = _ref28.wrap;
      var themeStyles = Object(external_react_.useContext)(theme_.ThemeContext).getStyles("TopNavigation", TopNavigation_module_default.a),
          classes = external_classnames_default()(themeStyles.topNavigation, _defineProperty({}, themeStyles.noWrap, !wrap), className);
      return external_react_default.a.createElement(NavigationContent, {
        routes: map_default()(routes).call(routes, removeNavLinkIcon),
        nestedRoutesComponent: NavBarDropdown,
        alignment: "top",
        className: classes
      });
    };

    TopNavigation.propTypes = {
      className: external_prop_types_default.a.string,
      routes: external_prop_types_default.a.arrayOf(prop_types_.routeShape).isRequired,
      wrap: external_prop_types_default.a.bool
    }, TopNavigation.defaultProps = {
      wrap: !0
    }, TopNavigation.__docgenInfo = {
      componentName: "TopNavigation",
      packageName: "@jutro/router",
      description: "The `TopNavigation` component is designed as a container for navigation links and dropdowns in Header.",
      displayName: "TopNavigation",
      methods: [],
      actualName: "TopNavigation",
      metadataType: "container",
      props: {
        className: {
          type: {
            name: "string"
          },
          required: !1,
          description: "Additional class names for component"
        },
        routes: {
          type: {
            name: "arrayOf",
            value: {
              name: "shape",
              value: {
                title: {
                  name: "custom",
                  raw: "intlMessageShape",
                  description: "Route title",
                  required: !1
                },
                path: {
                  name: "string",
                  description: "Route path",
                  required: !1
                },
                showOnNavBar: {
                  name: "bool",
                  description: "When `true` then route will be rendered on nav bar",
                  required: !1
                },
                exact: {
                  name: "bool",
                  description: "When true, will only match if the path matches the location.pathname exactly",
                  required: !1
                },
                navLink: {
                  name: "shape",
                  value: {
                    text: {
                      name: "string",
                      description: "Text for nav link",
                      required: !1
                    },
                    icon: {
                      name: "string",
                      description: "Icon for nav link",
                      required: !1
                    },
                    className: {
                      name: "string",
                      description: "Custom CSS className for nav link",
                      required: !1
                    },
                    activeClassName: {
                      name: "string",
                      description: "Custom CSS className for nav link in active state",
                      required: !1
                    },
                    component: {
                      name: "elementType",
                      description: "React element to render nav item",
                      required: !1
                    }
                  },
                  description: "Nav link props",
                  required: !1
                }
              }
            }
          },
          required: !0,
          description: "Routing metadata object"
        },
        wrap: {
          type: {
            name: "bool"
          },
          required: !1,
          description: "Defines if items should wrap when not enough space",
          defaultValue: {
            value: "true",
            computed: !1
          }
        }
      }
    };

    var SideNavigation_messages_messages = Object(external_react_intl_.defineMessages)({
      collapsedButtonLabel: {
        id: "jutro-router.SideNavigation.collapsedButtonLabel",
        defaultMessage: "Expand menu"
      },
      expandedButtonLabel: {
        id: "jutro-router.SideNavigation.expandedButtonLabel",
        defaultMessage: "Collapse menu"
      }
    }),
        NavBarAccordionInternal = function NavBarAccordionInternal(_ref29) {
      var to = _ref29.to,
          header = _ref29.header,
          icon = _ref29.icon,
          disabled = _ref29.disabled,
          className = _ref29.className,
          routes = _ref29.routes,
          loc = _ref29.location,
          notifications = _ref29.notifications;

      var _useContext = Object(external_react_.useContext)(SideNavigationContext),
          activeRoute = _useContext.activeRoute,
          setActiveRoute = _useContext.setActiveRoute,
          theme = Object(external_react_.useContext)(theme_.ThemeContext),
          translator = Object(external_react_.useContext)(locale_.TranslatorContext),
          themeStyles = theme.getStyles("SideNavigation", SideNavigation_module_default.a),
          navBarThemeStyles = theme.getStyles("NavBar", NavBarItem_module_default.a),
          hasActiveRoute = some_default()(routes).call(routes, function (_ref30) {
        var path = _ref30.path;
        return path === loc.pathname;
      }),
          cardID = getIdFromPath(to),
          classes = external_classnames_default()(themeStyles.subItem, _defineProperty({}, themeStyles.subItemWithIcon, icon)),
          styledRoutes = map_default()(routes).call(routes, function (_ref31) {
        var navLink = _ref31.navLink,
            rest = _objectWithoutProperties(_ref31, ["navLink"]);

        return _objectSpread({}, rest, {
          navLink: _objectSpread({}, navLink, {
            className: external_classnames_default()(navLink && navLink.className, classes)
          })
        });
      });

      return external_react_default.a.createElement(components_.Accordion, extends_default()({
        disabled: disabled,
        showFrame: !1,
        closeOthers: !1,
        className: themeStyles.sideNavAccordion
      }, activeRoute !== to && !hasActiveRoute && {
        accordionStates: []
      }), external_react_default.a.createElement(components_.AccordionCard, {
        id: cardID,
        cardBodyClassName: themeStyles.cardBody,
        cardTitleClassName: themeStyles.cardTitle,
        cardHeadingClassName: themeStyles.cardHeading,
        collapseClassName: themeStyles.accordionCollapse,
        renderHeader: function renderHeader(isOpen) {
          var _external_classnames_13;

          var iconComponent = icon && external_react_default.a.createElement(components_.Icon, {
            icon: icon,
            className: navBarThemeStyles.navBarItemIcon
          }),
              subNavsNotifications = function (routes) {
            return reduce_default()(routes).call(routes, function (notifications, route) {
              return notifications + external_lodash_default.a.get(route, "navLink.notifications", 0);
            }, 0);
          }(routes),
              classes = external_classnames_default()(navBarThemeStyles.navBarItem, navBarThemeStyles.leftNavBarItem, (_external_classnames_13 = {}, _defineProperty(_external_classnames_13, themeStyles.activeAccordion, hasActiveRoute), _defineProperty(_external_classnames_13, themeStyles.expandedAccordion, isOpen), _external_classnames_13), className),
              chevronClasses = external_classnames_default()(themeStyles.chevron, _defineProperty({}, themeStyles.rightAlignChevron, !notifications));

          return external_react_default.a.createElement("button", {
            tabIndex: "-1",
            className: classes,
            onClick: function onClick() {
              setActiveRoute(to);
            }
          }, external_react_default.a.createElement(components_.InlineLabel, {
            tag: "div",
            icon: iconComponent,
            className: navBarThemeStyles.titleWrapper
          }, external_react_default.a.createElement("div", {
            className: NavBarItem_module_default.a.titleContentWrapper
          }, external_react_default.a.createElement("span", {
            className: navBarThemeStyles.title
          }, translator(header)), renderBadge(notifications, "badge__" + cardID, notifications || subNavsNotifications), external_react_default.a.createElement(components_.Chevron, {
            className: chevronClasses,
            align: "right",
            chevronIcon: "mi-expand-more",
            size: "small",
            isOpen: isOpen
          }))));
        }
      }, external_react_default.a.createElement(NavigationContent, {
        routes: styledRoutes,
        alignment: "left"
      })));
    };

    NavBarAccordionInternal.propTypes = {
      className: external_prop_types_default.a.string,
      header: prop_types_.intlMessageShape.isRequired,
      to: external_prop_types_default.a.string.isRequired,
      icon: external_prop_types_default.a.string,
      disabled: external_prop_types_default.a.bool,
      activeClassName: external_prop_types_default.a.string,
      exact: external_prop_types_default.a.bool,
      routes: external_prop_types_default.a.arrayOf(prop_types_.routeShape)
    }, NavBarAccordionInternal.displayName = "NavBarAccordion";
    var NavBarAccordion = Object(external_react_router_dom_.withRouter)(NavBarAccordionInternal);
    NavBarAccordionInternal.__docgenInfo = {
      componentName: "NavBarAccordion",
      packageName: "@jutro/router",
      description: "The `NavBarAccordion` component is designed as a container for sub nav links of side navigation",
      displayName: "NavBarAccordion",
      methods: [],
      actualName: "NavBarAccordionInternal",
      props: {
        className: {
          type: {
            name: "string"
          },
          required: !1,
          description: "Additional class names for component."
        },
        header: {
          type: {
            name: "union",
            value: [{
              name: "string"
            }, {
              name: "shape",
              value: {
                id: {
                  name: "string",
                  required: !1
                },
                defaultMessage: {
                  name: "string",
                  required: !1
                }
              }
            }]
          },
          required: !0,
          description: "Link header."
        },
        to: {
          type: {
            name: "string"
          },
          required: !0,
          description: "External link."
        },
        icon: {
          type: {
            name: "string"
          },
          required: !1,
          description: "Icon to render to the left of the header"
        },
        disabled: {
          type: {
            name: "bool"
          },
          required: !1,
          description: "Flag to make item disabled"
        },
        activeClassName: {
          type: {
            name: "string"
          },
          required: !1,
          description: "Additional class names for  active component."
        },
        exact: {
          type: {
            name: "bool"
          },
          required: !1,
          description: "When true, will only match if the path matches the location.pathname exactly"
        },
        routes: {
          type: {
            name: "arrayOf",
            value: {
              name: "shape",
              value: {
                title: {
                  name: "custom",
                  raw: "intlMessageShape",
                  description: "Route title",
                  required: !1
                },
                path: {
                  name: "string",
                  description: "Route path",
                  required: !1
                },
                showOnNavBar: {
                  name: "bool",
                  description: "When `true` then route will be rendered on nav bar",
                  required: !1
                },
                exact: {
                  name: "bool",
                  description: "When true, will only match if the path matches the location.pathname exactly",
                  required: !1
                },
                navLink: {
                  name: "shape",
                  value: {
                    text: {
                      name: "string",
                      description: "Text for nav link",
                      required: !1
                    },
                    icon: {
                      name: "string",
                      description: "Icon for nav link",
                      required: !1
                    },
                    className: {
                      name: "string",
                      description: "Custom CSS className for nav link",
                      required: !1
                    },
                    activeClassName: {
                      name: "string",
                      description: "Custom CSS className for nav link in active state",
                      required: !1
                    },
                    component: {
                      name: "elementType",
                      description: "React element to render nav item",
                      required: !1
                    }
                  },
                  description: "Nav link props",
                  required: !1
                }
              }
            }
          },
          required: !1,
          description: "Sub navigation items metadata"
        }
      }
    };

    var sideNavRouteShape = external_prop_types_default.a.shape(_objectSpread({}, prop_types_.routePropTypes, {
      navLink: external_prop_types_default.a.shape(_objectSpread({}, prop_types_.navLinkPropTypes, {
        notifications: external_prop_types_default.a.number
      }))
    })),
        SideNavigation = function SideNavigation(_ref32) {
      var className = _ref32.className,
          routes = _ref32.routes,
          collapsible = _ref32.collapsible,
          collapsed = _ref32.collapsed;

      var _useState = Object(external_react_.useState)(""),
          _useState2 = slicedToArray_default()(_useState, 2),
          activeRoute = _useState2[0],
          setActiveRoute = _useState2[1],
          _useState3 = Object(external_react_.useState)(collapsed),
          _useState4 = slicedToArray_default()(_useState3, 2),
          isCollapsed = _useState4[0],
          setIsCollapsed = _useState4[1];

      Object(external_react_.useEffect)(function () {
        setIsCollapsed(collapsed);
      }, [collapsed]);
      var themeStyles = Object(external_react_.useContext)(theme_.ThemeContext).getStyles("SideNavigation", SideNavigation_module_default.a),
          classes = external_classnames_default()(themeStyles.sideNavigation, _defineProperty({}, themeStyles.collapsed, collapsible && isCollapsed), className),
          addSideNavStyles = Object(external_react_.useCallback)(function (_ref33) {
        var navLink = _ref33.navLink,
            rest = _objectWithoutProperties(_ref33, ["navLink"]);

        return _objectSpread({}, rest, {
          navLink: _objectSpread({}, navLink, {
            className: external_classnames_default()(navLink && navLink.className, themeStyles.navBarLink)
          })
        });
      }, [themeStyles.navBarLink]),
          sideRoutes = function (routes) {
        var showOnNavBarRoutes = filter_default()(routes).call(routes, function (route) {
          return external_lodash_default.a.get(route, "showOnNavBar", !0);
        });
        return every_default()(showOnNavBarRoutes).call(showOnNavBarRoutes, function (_ref34) {
          var navLink = _ref34.navLink;
          return navLink;
        }) && every_default()(showOnNavBarRoutes).call(showOnNavBarRoutes, function (_ref35) {
          var icon = _ref35.navLink.icon;
          return icon;
        });
      }(routes) ? routes : map_default()(routes).call(routes, removeNavLinkIcon),
          translator = Object(external_react_.useContext)(locale_.TranslatorContext),
          footer = collapsible && external_react_default.a.createElement("div", {
        className: themeStyles.footer
      }, external_react_default.a.createElement(components_.IconButton, {
        size: "large",
        icon: isCollapsed ? "mi-chevron-right" : "mi-chevron-left",
        iconClassName: themeStyles.chevronIcon,
        onClick: function onClick() {
          setIsCollapsed(!isCollapsed);
        },
        ariaLabel: translator(isCollapsed ? SideNavigation_messages_messages.collapsedButtonLabel : SideNavigation_messages_messages.expandedButtonLabel)
      }));
      return external_react_default.a.createElement("div", {
        className: classes
      }, external_react_default.a.createElement("div", {
        className: themeStyles.content
      }, external_react_default.a.createElement("div", {
        className: themeStyles.layout
      }, external_react_default.a.createElement(SideNavigationContext.Provider, {
        value: {
          activeRoute: activeRoute,
          setActiveRoute: setActiveRoute
        }
      }, external_react_default.a.createElement(NavigationContent, {
        routes: map_default()(sideRoutes).call(sideRoutes, addSideNavStyles),
        alignment: "left",
        className: themeStyles.navigationContent,
        nestedRoutesComponent: NavBarAccordion
      })), footer)));
    };

    SideNavigation.propTypes = {
      className: external_prop_types_default.a.string,
      routes: external_prop_types_default.a.arrayOf(sideNavRouteShape).isRequired,
      collapsible: external_prop_types_default.a.bool,
      collapsed: external_prop_types_default.a.bool
    }, SideNavigation.defaultProps = {
      collapsible: !1,
      collapsed: !1
    }, SideNavigation.__docgenInfo = {
      componentName: "SideNavigation",
      packageName: "@jutro/router",
      description: "The `SideNavigation` component is designed as a container for navigation links and dropdowns",
      displayName: "SideNavigation",
      methods: [],
      actualName: "SideNavigation",
      metadataType: "container",
      props: {
        className: {
          type: {
            name: "string"
          },
          required: !1,
          description: "Additional class names for component."
        },
        routes: {
          type: {
            name: "arrayOf",
            value: {
              name: "custom",
              raw: "sideNavRouteShape"
            }
          },
          required: !0,
          description: "Routing metadata object"
        },
        collapsible: {
          type: {
            name: "bool"
          },
          required: !1,
          description: "Defines whether component can be collapsed",
          defaultValue: {
            value: "false",
            computed: !1
          }
        },
        collapsed: {
          type: {
            name: "bool"
          },
          required: !1,
          description: "Default state for SideNavigation",
          defaultValue: {
            value: "false",
            computed: !1
          }
        }
      }
    };

    var PrivateRoute = function PrivateRoute(_ref36) {
      var component = _ref36.component,
          render = _ref36.render,
          children = _ref36.children,
          redirect = _ref36.redirect,
          isAuthenticated = _ref36.isAuthenticated,
          other = _objectWithoutProperties(_ref36, ["component", "render", "children", "redirect", "isAuthenticated"]);

      var props;
      return props = isAuthenticated ? {
        component: component,
        render: render,
        children: children
      } : {
        render: function render() {
          return external_react_default.a.createElement(external_react_router_dom_.Redirect, {
            to: {
              pathname: Object(platform_.sanitizeUrl)(redirect),
              state: {
                from: other.path
              }
            }
          });
        }
      }, external_react_default.a.createElement(external_react_router_dom_.Route, extends_default()({}, props, other));
    };

    PrivateRoute.propTypes = {
      component: external_prop_types_default.a.node,
      render: external_prop_types_default.a.func,
      children: external_prop_types_default.a.node,
      redirect: external_prop_types_default.a.string,
      isAuthenticated: external_prop_types_default.a.bool
    }, PrivateRoute.__docgenInfo = {
      componentName: "PrivateRoute",
      packageName: "@jutro/router",
      description: "",
      displayName: "PrivateRoute",
      methods: [],
      actualName: "PrivateRoute",
      props: {
        component: {
          type: {
            name: "node"
          },
          required: !1,
          description: ""
        },
        render: {
          type: {
            name: "func"
          },
          required: !1,
          description: ""
        },
        children: {
          type: {
            name: "node"
          },
          required: !1,
          description: ""
        },
        redirect: {
          type: {
            name: "string"
          },
          required: !1,
          description: ""
        },
        isAuthenticated: {
          type: {
            name: "bool"
          },
          required: !1,
          description: ""
        }
      }
    };

    var includes_ = __webpack_require__("@babel/runtime-corejs3/core-js-stable/instance/includes"),
        includes_default = __webpack_require__.n(includes_),
        auth_ = __webpack_require__("@jutro/auth"),
        DropdownMenuAvatar_module = __webpack_require__("./DropdownMenu/DropdownMenuAvatar.module.scss"),
        DropdownMenuAvatar_module_default = __webpack_require__.n(DropdownMenuAvatar_module);

    var DropdownMenuAvatarHeader = function DropdownMenuAvatarHeader(_ref37) {
      var title = _ref37.title,
          subtitle = _ref37.subtitle,
          username = _ref37.username,
          icon = _ref37.icon,
          useAuthInfo = _ref37.useAuthInfo,
          headerAvatarSize = _ref37.headerAvatarSize,
          className = _ref37.className,
          imageSource = _ref37.imageSource,
          messageProps = _ref37.messageProps,
          showImageBorder = _ref37.showImageBorder;
      var auth = Object(external_react_.useContext)(auth_.AuthContext),
          translator = Object(external_react_.useContext)(locale_.TranslatorContext),
          avatarProps = {
        username: username,
        icon: icon,
        imageSource: useAuthInfo ? null == auth || null === (_auth$userInfo = auth.userInfo) || void 0 === _auth$userInfo ? void 0 : _auth$userInfo.pictureUrl : imageSource,
        messageProps: messageProps,
        showImageBorder: showImageBorder,
        useAuthInfo: useAuthInfo
      };

      var _auth$userInfo;

      headerAvatarSize = includes_default()(components_.availableAvatarSizes).call(components_.availableAvatarSizes, headerAvatarSize) ? headerAvatarSize : DropdownMenuAvatarHeader.defaultAvatarProps.headerAvatarSize;
      return external_react_default.a.createElement("div", {
        className: external_classnames_default()(DropdownMenuAvatar_module_default.a.dropdownMenuAvatarHeader, className)
      }, external_react_default.a.createElement(components_.Avatar, extends_default()({
        disabled: !0,
        size: headerAvatarSize
      }, avatarProps)), external_react_default.a.createElement("div", {
        className: DropdownMenuAvatar_module_default.a.headerText
      }, external_react_default.a.createElement("div", {
        className: DropdownMenuAvatar_module_default.a.headerTitle
      }, function () {
        var _auth$userInfo$name, _auth$userInfo2;

        var translatedTitle = translator(title);
        return useAuthInfo && null !== (_auth$userInfo$name = null == auth || null === (_auth$userInfo2 = auth.userInfo) || void 0 === _auth$userInfo2 ? void 0 : _auth$userInfo2.name) && void 0 !== _auth$userInfo$name ? _auth$userInfo$name : translatedTitle;
      }()), external_react_default.a.createElement("div", {
        className: DropdownMenuAvatar_module_default.a.headerSubtitle
      }, function () {
        var _auth$userInfo3, _auth$userInfo$email, _auth$userInfo4;

        var translatedSubtitle = translator(subtitle);
        return useAuthInfo ? (null == auth || null === (_auth$userInfo3 = auth.userInfo) || void 0 === _auth$userInfo3 ? void 0 : _auth$userInfo3.preferred_username) || (null !== (_auth$userInfo$email = null == auth || null === (_auth$userInfo4 = auth.userInfo) || void 0 === _auth$userInfo4 ? void 0 : _auth$userInfo4.email) && void 0 !== _auth$userInfo$email ? _auth$userInfo$email : translatedSubtitle) : translatedSubtitle;
      }())));
    };

    DropdownMenuAvatarHeader.propTypes = {
      title: prop_types_.intlMessageShape,
      subtitle: prop_types_.intlMessageShape,
      username: external_prop_types_default.a.string,
      icon: external_prop_types_default.a.string,
      className: external_prop_types_default.a.string,
      imageSource: external_prop_types_default.a.string,
      headerAvatarSize: external_prop_types_default.a.oneOf(components_.availableAvatarSizes),
      messageProps: external_prop_types_default.a.shape({
        userAvatar: components_.Avatar.propTypes.messageProps.userAvatar
      }),
      useAuthInfo: external_prop_types_default.a.bool,
      showImageBorder: external_prop_types_default.a.bool,
      headerClassName: external_prop_types_default.a.string
    }, DropdownMenuAvatarHeader.defaultAvatarProps = {
      headerAvatarSize: "medium",
      useAuthInfo: !1
    }, DropdownMenuAvatarHeader.__docgenInfo = {
      componentName: "DropdownMenuAvatarHeader",
      packageName: "@jutro/router",
      description: "",
      displayName: "DropdownMenuAvatarHeader",
      methods: [],
      actualName: "DropdownMenuAvatarHeader",
      props: {
        title: {
          type: {
            name: "union",
            value: [{
              name: "string"
            }, {
              name: "shape",
              value: {
                id: {
                  name: "string",
                  required: !1
                },
                defaultMessage: {
                  name: "string",
                  required: !1
                }
              }
            }]
          },
          required: !1,
          description: "Header title text"
        },
        subtitle: {
          type: {
            name: "union",
            value: [{
              name: "string"
            }, {
              name: "shape",
              value: {
                id: {
                  name: "string",
                  required: !1
                },
                defaultMessage: {
                  name: "string",
                  required: !1
                }
              }
            }]
          },
          required: !1,
          description: "Menu header subtitle text"
        },
        username: {
          type: {
            name: "string"
          },
          required: !1,
          description: "Users first and last names, used as component alt text as well\nas to display initials if no image selected"
        },
        icon: {
          type: {
            name: "string"
          },
          required: !1,
          description: "Icon name from the Font Awesome or Material Icons icon list to be displayed if no image or initials present"
        },
        className: {
          type: {
            name: "string"
          },
          required: !1,
          description: "Additional component styling class name"
        },
        imageSource: {
          type: {
            name: "string"
          },
          required: !1,
          description: "Path to user image, preferentially shown before user initials or icon"
        },
        headerAvatarSize: {
          type: {
            name: "enum",
            computed: !1,
            value: [{
              value: "'xxsmall'",
              computed: !1
            }, {
              value: "'xsmall'",
              computed: !1
            }, {
              value: "'small'",
              computed: !1
            }, {
              value: "'medium'",
              computed: !1
            }, {
              value: "'large'",
              computed: !1
            }, {
              value: "'xlarge'",
              computed: !1
            }, {
              value: "'xxlarge'",
              computed: !1
            }]
          },
          required: !1,
          description: "Avatar in header size from list of available sizes"
        },
        messageProps: {
          type: {
            name: "shape",
            value: {
              userAvatar: {
                name: "custom",
                raw: "Avatar.propTypes.messageProps.userAvatar",
                description: "userAvatar message",
                required: !1
              }
            }
          },
          required: !1,
          description: "Message props(error message/aria-label)"
        },
        useAuthInfo: {
          type: {
            name: "bool"
          },
          required: !1,
          description: "If `true`, display header information from Okta, if available, and Logout menu link"
        },
        showImageBorder: {
          type: {
            name: "bool"
          },
          required: !1,
          description: "Defines whether image border should be shown or not"
        },
        headerClassName: {
          type: {
            name: "string"
          },
          required: !1,
          description: "Additional css class to the dropdown menu avatar header"
        }
      }
    };

    var DropdownMenuAvatar_messages_messages = Object(external_react_intl_.defineMessages)({
      logout: {
        id: "jutro-router.DropdownMenu.Logout",
        defaultMessage: "Logout"
      }
    }),
        DropdownMenuAvatar = function DropdownMenuAvatar(_ref38) {
      var username = _ref38.username,
          icon = _ref38.icon,
          className = _ref38.className,
          imageSource = _ref38.imageSource,
          messageProps = _ref38.messageProps,
          showImageBorder = _ref38.showImageBorder,
          useAuthInfo = _ref38.useAuthInfo,
          id = _ref38.id,
          isOpenProp = _ref38.isOpen,
          dropUp = _ref38.dropUp,
          alignRight = _ref38.alignRight,
          buttonAvatarSize = _ref38.buttonAvatarSize,
          headerAvatarSize = _ref38.headerAvatarSize,
          title = _ref38.title,
          subtitle = _ref38.subtitle,
          children = _ref38.children,
          onBeforeLogout = _ref38.onBeforeLogout;

      var _context;

      var auth = Object(external_react_.useContext)(auth_.AuthContext),
          headerProps = {
        title: title,
        subtitle: subtitle,
        username: username,
        icon: icon,
        className: className,
        imageSource: imageSource,
        headerAvatarSize: headerAvatarSize,
        messageProps: messageProps,
        useAuthInfo: useAuthInfo,
        showImageBorder: showImageBorder
      },
          menuProps = {
        id: id,
        isOpen: isOpenProp,
        dropUp: dropUp,
        alignRight: alignRight
      },
          avatarProps = {
        username: username,
        icon: icon,
        className: external_classnames_default()(className, DropdownMenuAvatar_module_default.a.dropdownMenuAvatarTrigger),
        style: {
          "--avatar-size": "1.75rem"
        },
        imageSource: useAuthInfo ? external_lodash_default.a.get(auth, "userInfo.pictureUrl", null) : imageSource,
        messageProps: messageProps,
        showImageBorder: showImageBorder,
        useAuthInfo: useAuthInfo
      };
      buttonAvatarSize = includes_default()(components_.availableAvatarSizes).call(components_.availableAvatarSizes, buttonAvatarSize) ? buttonAvatarSize : DropdownMenuAvatar.defaultAvatarProps.buttonAvatarSize;
      var childrenArray = map_default()(_context = external_react_default.a.Children.toArray(children)).call(_context, function (e, index) {
        return external_react_default.a.cloneElement(e, {
          key: index
        });
      }),
          logoutCallback = Object(external_react_.useCallback)(function _callee() {
        return _regeneratorRuntime.async(function _callee$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.t0 = onBeforeLogout;

                if (!_context5.t0) {
                  _context5.next = 4;
                  break;
                }

                _context5.next = 4;
                return _regeneratorRuntime.awrap(onBeforeLogout());

              case 4:
                _context5.t1 = auth && auth.logout;

                if (!_context5.t1) {
                  _context5.next = 8;
                  break;
                }

                _context5.next = 8;
                return _regeneratorRuntime.awrap(auth.logout());

              case 8:
              case "end":
                return _context5.stop();
            }
          }
        }, null, null, null, Promise);
      }, [auth, onBeforeLogout]);
      return external_react_default.a.createElement(DropdownMenu, extends_default()({}, menuProps, {
        className: DropdownMenuAvatar_module_default.a.dropdownMenuAvatar,
        onRenderTrigger: function onRenderTrigger(_ref39, toggleMenu) {
          var isOpen = _ref39.isOpen,
              menuId = _ref39.menuId,
              other = _objectWithoutProperties(_ref39, ["isOpen", "menuId"]);

          return external_react_default.a.createElement(components_.Avatar, extends_default()({
            size: buttonAvatarSize,
            "aria-label": "Profile menu",
            "aria-controls": menuId
          }, other, avatarProps, {
            onClick: function onClick() {
              return toggleMenu(!isOpen);
            }
          }));
        },
        menuClassName: DropdownMenuAvatar_module_default.a.dropdownMenuAvatarMenu
      }), [external_react_default.a.createElement(DropdownMenuAvatarHeader, extends_default()({
        key: "header"
      }, headerProps))].concat(_toConsumableArray(childrenArray.length > 0 ? [external_react_default.a.createElement(DropdownMenuSeparator, {
        key: "children-separator"
      })].concat(_toConsumableArray(childrenArray)) : []), _toConsumableArray(useAuthInfo && auth ? [external_react_default.a.createElement(DropdownMenuSeparator, {
        key: "logout-separator"
      }), external_react_default.a.createElement(DropdownMenuLink, {
        key: "logout-button",
        "data-gw-test-auth-logout": !0,
        onClick: logoutCallback
      }, DropdownMenuAvatar_messages_messages.logout)] : [])));
    };

    DropdownMenuAvatar.propTypes = {
      title: prop_types_.intlMessageShape,
      subtitle: prop_types_.intlMessageShape,
      username: external_prop_types_default.a.string,
      icon: external_prop_types_default.a.string,
      className: external_prop_types_default.a.string,
      imageSource: external_prop_types_default.a.string,
      buttonAvatarSize: external_prop_types_default.a.oneOf(components_.availableAvatarSizes),
      headerAvatarSize: external_prop_types_default.a.oneOf(components_.availableAvatarSizes),
      messageProps: external_prop_types_default.a.shape({
        userAvatar: prop_types_.intlMessageShape
      }),
      id: external_prop_types_default.a.string.isRequired,
      isOpen: external_prop_types_default.a.bool,
      dropUp: external_prop_types_default.a.bool,
      alignRight: external_prop_types_default.a.bool,
      useAuthInfo: external_prop_types_default.a.bool,
      children: external_prop_types_default.a.node,
      showImageBorder: external_prop_types_default.a.bool,
      onBeforeLogout: external_prop_types_default.a.func
    }, DropdownMenuAvatar.defaultAvatarProps = {
      buttonAvatarSize: components_.Avatar.defaultProps.size,
      headerAvatarSize: "medium",
      alignRight: !0,
      useAuthInfo: !1
    }, DropdownMenuAvatar.__docgenInfo = {
      componentName: "DropdownMenuAvatar",
      packageName: "@jutro/router",
      description: "",
      displayName: "DropdownMenuAvatar",
      methods: [],
      actualName: "DropdownMenuAvatar",
      metadataType: "action",
      props: {
        title: {
          type: {
            name: "union",
            value: [{
              name: "string"
            }, {
              name: "shape",
              value: {
                id: {
                  name: "string",
                  required: !1
                },
                defaultMessage: {
                  name: "string",
                  required: !1
                }
              }
            }]
          },
          required: !1,
          description: "Menu header title text"
        },
        subtitle: {
          type: {
            name: "union",
            value: [{
              name: "string"
            }, {
              name: "shape",
              value: {
                id: {
                  name: "string",
                  required: !1
                },
                defaultMessage: {
                  name: "string",
                  required: !1
                }
              }
            }]
          },
          required: !1,
          description: "Menu header subtitle text"
        },
        username: {
          type: {
            name: "string"
          },
          required: !1,
          description: "Users first and last names, used as component alt text as well\nas to display initials if no image selected"
        },
        icon: {
          type: {
            name: "string"
          },
          required: !1,
          description: "Icon name from the Font Awesome or Material Icons icon list to be displayed if no image or initials present"
        },
        className: {
          type: {
            name: "string"
          },
          required: !1,
          description: "Additional component styling class name"
        },
        imageSource: {
          type: {
            name: "string"
          },
          required: !1,
          description: "Path to user image, preferentially shown before user initials or icon"
        },
        buttonAvatarSize: {
          type: {
            name: "enum",
            computed: !1,
            value: [{
              value: "'xxsmall'",
              computed: !1
            }, {
              value: "'xsmall'",
              computed: !1
            }, {
              value: "'small'",
              computed: !1
            }, {
              value: "'medium'",
              computed: !1
            }, {
              value: "'large'",
              computed: !1
            }, {
              value: "'xlarge'",
              computed: !1
            }, {
              value: "'xxlarge'",
              computed: !1
            }]
          },
          required: !1,
          description: "Button Avatar size from list of available sizes"
        },
        headerAvatarSize: {
          type: {
            name: "enum",
            computed: !1,
            value: [{
              value: "'xxsmall'",
              computed: !1
            }, {
              value: "'xsmall'",
              computed: !1
            }, {
              value: "'small'",
              computed: !1
            }, {
              value: "'medium'",
              computed: !1
            }, {
              value: "'large'",
              computed: !1
            }, {
              value: "'xlarge'",
              computed: !1
            }, {
              value: "'xxlarge'",
              computed: !1
            }]
          },
          required: !1,
          description: "Avatar in header size from list of available sizes"
        },
        messageProps: {
          type: {
            name: "shape",
            value: {
              userAvatar: {
                name: "union",
                description: "userAvatar message",
                required: !1,
                value: [{
                  name: "string"
                }, {
                  name: "shape",
                  value: {
                    id: {
                      name: "string",
                      required: !1
                    },
                    defaultMessage: {
                      name: "string",
                      required: !1
                    }
                  }
                }]
              }
            }
          },
          required: !1,
          description: "Message props(error message/aria-label)"
        },
        id: {
          type: {
            name: "string"
          },
          required: !0,
          description: "Used to identify menu component."
        },
        isOpen: {
          type: {
            name: "bool"
          },
          required: !1,
          description: "The prop that indicates if the menu is currently visible."
        },
        dropUp: {
          type: {
            name: "bool"
          },
          required: !1,
          description: "If `true`, the menu appears above the trigger component."
        },
        alignRight: {
          type: {
            name: "bool"
          },
          required: !1,
          description: "If `true`, items are aligned to the right edge of the menu."
        },
        useAuthInfo: {
          type: {
            name: "bool"
          },
          required: !1,
          description: "If `true`, display header information from Okta, if available, and Logout menu link"
        },
        children: {
          type: {
            name: "node"
          },
          required: !1,
          description: "The component children wrapped by the dropdown menu avatar component."
        },
        showImageBorder: {
          type: {
            name: "bool"
          },
          required: !1,
          description: "Defines whether image border should be shown or not"
        },
        onBeforeLogout: {
          type: {
            name: "func"
          },
          required: !1,
          description: "Callback to be called before okta logout"
        }
      }
    };

    var DropdownMenuButton_module = __webpack_require__("./DropdownMenu/DropdownMenuButton.module.scss"),
        DropdownMenuButton_module_default = __webpack_require__.n(DropdownMenuButton_module);

    var DropdownMenuButton = function DropdownMenuButton(_ref40) {
      var id = _ref40.id,
          buttonText = _ref40.buttonText,
          isOpenProp = _ref40.isOpen,
          dropUp = _ref40.dropUp,
          alignRight = _ref40.alignRight,
          menuClassName = _ref40.menuClassName,
          children = _ref40.children,
          buttonProps = _objectWithoutProperties(_ref40, ["id", "buttonText", "isOpen", "dropUp", "alignRight", "menuClassName", "children"]);

      var menuProps = {
        isOpen: isOpenProp,
        dropUp: dropUp,
        alignRight: alignRight,
        menuClassName: menuClassName
      },
          classes = external_classnames_default()(_defineProperty({}, DropdownMenuButton_module_default.a.fullWidth, buttonProps && buttonProps.fullWidth));
      return external_react_default.a.createElement(DropdownMenu, extends_default()({
        id: id,
        className: classes
      }, menuProps, {
        onRenderTrigger: function onRenderTrigger(_ref41, toggleMenu) {
          var buttonId = _ref41.id,
              menuId = _ref41.menuId,
              isOpen = _ref41.isOpen,
              other = _objectWithoutProperties(_ref41, ["id", "menuId", "isOpen"]);

          return external_react_default.a.createElement(components_.Button, extends_default()({
            id: buttonId
          }, other, buttonProps, {
            onClick: function onClick() {
              return toggleMenu(!isOpen);
            },
            "aria-controls": menuId,
            "aria-haspopup": "true"
          }), buttonText);
        }
      }), children);
    };

    DropdownMenuButton.propTypes = {
      id: external_prop_types_default.a.string.isRequired,
      buttonText: external_prop_types_default.a.oneOfType([external_prop_types_default.a.node, prop_types_.intlMessageShape]),
      isOpen: external_prop_types_default.a.bool,
      dropUp: external_prop_types_default.a.bool,
      alignRight: external_prop_types_default.a.bool,
      menuClassName: external_prop_types_default.a.string,
      children: external_prop_types_default.a.node
    }, DropdownMenuButton.__docgenInfo = {
      componentName: "DropdownMenuButton",
      packageName: "@jutro/router",
      description: "",
      displayName: "DropdownMenuButton",
      methods: [],
      actualName: "DropdownMenuButton",
      metadataType: "action",
      props: {
        id: {
          type: {
            name: "string"
          },
          required: !0,
          description: "Used to identify menu component."
        },
        buttonText: {
          type: {
            name: "union",
            value: [{
              name: "node"
            }, {
              name: "union",
              value: [{
                name: "string"
              }, {
                name: "shape",
                value: {
                  id: {
                    name: "string",
                    required: !1
                  },
                  defaultMessage: {
                    name: "string",
                    required: !1
                  }
                }
              }]
            }]
          },
          required: !1,
          description: "Content to be rendered as the 'children' for the 'Button' component."
        },
        isOpen: {
          type: {
            name: "bool"
          },
          required: !1,
          description: "The prop that indicates if the menu is currently visible."
        },
        dropUp: {
          type: {
            name: "bool"
          },
          required: !1,
          description: "If `true`, the menu appears above the trigger component."
        },
        alignRight: {
          type: {
            name: "bool"
          },
          required: !1,
          description: "If `true`, menu items are aligned to the right edge of the menu."
        },
        menuClassName: {
          type: {
            name: "string"
          },
          required: !1,
          description: "Override class for the inner menu of the dropdown menu"
        },
        children: {
          type: {
            name: "node"
          },
          required: !1,
          description: "The component children wrapped by the dropdown menu button component."
        }
      }
    };

    var isUndefined = __webpack_require__("../../node_modules/lodash/isUndefined.js"),
        isUndefined_default = __webpack_require__.n(isUndefined),
        layout_ = __webpack_require__("@jutro/layout");

    var DropdownMenuAvatarContent = function DropdownMenuAvatarContent(_ref42) {
      var children = _ref42.children,
          title = _ref42.title,
          subtitle = _ref42.subtitle,
          headerAvatarSize = _ref42.headerAvatarSize,
          useAuthInfo = _ref42.useAuthInfo,
          username = _ref42.username,
          icon = _ref42.icon,
          className = _ref42.className,
          imageSource = _ref42.imageSource,
          messageProps = _ref42.messageProps,
          showImageBorder = _ref42.showImageBorder,
          headerClassName = _ref42.headerClassName,
          authLinksClassName = _ref42.authLinksClassName,
          separatorClassName = _ref42.separatorClassName;
      var auth = Object(external_react_.useContext)(auth_.AuthContext);
      headerAvatarSize = includes_default()(components_.availableAvatarSizes).call(components_.availableAvatarSizes, headerAvatarSize) ? headerAvatarSize : DropdownMenuAvatarContent.defaultAvatarProps.headerAvatarSize;
      var authLinks = useAuthInfo && auth && external_react_default.a.createElement(external_react_default.a.Fragment, null, external_react_default.a.createElement(DropdownMenuSeparator, {
        className: separatorClassName
      }), external_react_default.a.createElement(DropdownMenuLink, {
        "data-gw-test-auth-logout": !0,
        onClick: auth.logout,
        className: authLinksClassName
      }, DropdownMenuAvatar_messages_messages.logout)),
          headerProps = {
        title: title,
        subtitle: subtitle,
        username: username,
        icon: icon,
        imageSource: imageSource,
        headerAvatarSize: headerAvatarSize,
        messageProps: messageProps,
        useAuthInfo: useAuthInfo,
        showImageBorder: showImageBorder
      },
          childrenArray = external_react_default.a.Children.toArray(children),
          classNames = external_classnames_default()(DropdownMenuAvatar_module_default.a.dropdownMenuAvatar, DropdownMenu_module_default.a.dropdownMenu, className);
      return external_react_default.a.createElement("div", {
        className: classNames
      }, external_react_default.a.createElement(DropdownMenuAvatarHeader, extends_default()({
        className: headerClassName
      }, headerProps)), childrenArray.length > 0 && external_react_default.a.createElement(external_react_default.a.Fragment, null, external_react_default.a.createElement(DropdownMenuSeparator, {
        className: separatorClassName
      }), children), authLinks);
    };

    DropdownMenuAvatarContent.propTypes = {
      title: prop_types_.intlMessageShape,
      subtitle: prop_types_.intlMessageShape,
      username: external_prop_types_default.a.string,
      icon: external_prop_types_default.a.string,
      className: external_prop_types_default.a.string,
      imageSource: external_prop_types_default.a.string,
      headerAvatarSize: external_prop_types_default.a.oneOf(components_.availableAvatarSizes),
      messageProps: external_prop_types_default.a.shape({
        userAvatar: components_.Avatar.propTypes.messageProps.userAvatar
      }),
      useAuthInfo: external_prop_types_default.a.bool,
      children: external_prop_types_default.a.node,
      showImageBorder: external_prop_types_default.a.bool,
      headerClassName: external_prop_types_default.a.string,
      authLinksClassName: external_prop_types_default.a.string,
      separatorClassName: external_prop_types_default.a.string
    }, DropdownMenuAvatarContent.defaultAvatarProps = {
      headerAvatarSize: "medium",
      useAuthInfo: !1
    }, DropdownMenuAvatarContent.__docgenInfo = {
      componentName: "DropdownMenuAvatarContent",
      packageName: "@jutro/router",
      description: "",
      displayName: "DropdownMenuAvatarContent",
      methods: [],
      actualName: "DropdownMenuAvatarContent",
      props: {
        title: {
          type: {
            name: "union",
            value: [{
              name: "string"
            }, {
              name: "shape",
              value: {
                id: {
                  name: "string",
                  required: !1
                },
                defaultMessage: {
                  name: "string",
                  required: !1
                }
              }
            }]
          },
          required: !1,
          description: "Menu header title text"
        },
        subtitle: {
          type: {
            name: "union",
            value: [{
              name: "string"
            }, {
              name: "shape",
              value: {
                id: {
                  name: "string",
                  required: !1
                },
                defaultMessage: {
                  name: "string",
                  required: !1
                }
              }
            }]
          },
          required: !1,
          description: "Menu header subtitle text"
        },
        username: {
          type: {
            name: "string"
          },
          required: !1,
          description: "Users first and last names, used as component alt text as well\nas to display initials if no image selected"
        },
        icon: {
          type: {
            name: "string"
          },
          required: !1,
          description: "Icon name from the Font Awesome or Material Icons icon list to be displayed if no image or initials present"
        },
        className: {
          type: {
            name: "string"
          },
          required: !1,
          description: "Additional component styling class name"
        },
        imageSource: {
          type: {
            name: "string"
          },
          required: !1,
          description: "Path to user image, preferentially shown before user initials or icon"
        },
        headerAvatarSize: {
          type: {
            name: "enum",
            computed: !1,
            value: [{
              value: "'xxsmall'",
              computed: !1
            }, {
              value: "'xsmall'",
              computed: !1
            }, {
              value: "'small'",
              computed: !1
            }, {
              value: "'medium'",
              computed: !1
            }, {
              value: "'large'",
              computed: !1
            }, {
              value: "'xlarge'",
              computed: !1
            }, {
              value: "'xxlarge'",
              computed: !1
            }]
          },
          required: !1,
          description: "Avatar in header size from list of available sizes"
        },
        messageProps: {
          type: {
            name: "shape",
            value: {
              userAvatar: {
                name: "custom",
                raw: "Avatar.propTypes.messageProps.userAvatar",
                description: "userAvatar message",
                required: !1
              }
            }
          },
          required: !1,
          description: "Message props(error message/aria-label)"
        },
        useAuthInfo: {
          type: {
            name: "bool"
          },
          required: !1,
          description: "If `true`, display header information from Okta, if available, and Logout menu link"
        },
        children: {
          type: {
            name: "node"
          },
          required: !1,
          description: "The component children wrapped by the dropdown menu avatar component."
        },
        showImageBorder: {
          type: {
            name: "bool"
          },
          required: !1,
          description: "Defines whether image border should be shown or not"
        },
        headerClassName: {
          type: {
            name: "string"
          },
          required: !1,
          description: "Additional css class to the dropdown menu avatar header"
        },
        authLinksClassName: {
          type: {
            name: "string"
          },
          required: !1,
          description: "Additional css class to the dropdown menu avatar auth links"
        },
        separatorClassName: {
          type: {
            name: "string"
          },
          required: !1,
          description: "Optional css class to the dropdown menu separator"
        }
      }
    };

    var ApplicationHeader_module = __webpack_require__("./ApplicationHeader/ApplicationHeader.module.scss"),
        ApplicationHeader_module_default = __webpack_require__.n(ApplicationHeader_module);

    var ApplicationHeader_messages_messages = Object(external_react_intl_.defineMessages)({
      notifications: {
        id: "jutro-router.ApplicationHeader.Notifications",
        defaultMessage: "Notifications"
      },
      logoAlt: {
        id: "jutro-router.ApplicationHeader.logo alt",
        defaultMessage: "Logo"
      },
      notificationButton: {
        id: "jutro-router.ApplicationHeader.Notification Button",
        defaultMessage: "Notification Button"
      },
      searchFieldPlaceholder: {
        id: "jutro-router.ApplicationHeader.SearchField Placeholder",
        defaultMessage: "Search..."
      },
      moreButtonText: {
        id: "jutro-router.ApplicationHeader.Subheader More",
        defaultMessage: "More"
      },
      help: {
        id: "jutro-router.ApplicationHeader.Help",
        defaultMessage: "Help"
      },
      switchApplication: {
        id: "jutro-router.ApplicationHeader.SwitchApplication",
        defaultMessage: "Switch Application"
      }
    });

    var slice_ = __webpack_require__("@babel/runtime-corejs3/core-js-stable/instance/slice"),
        slice_default = __webpack_require__.n(slice_),
        set_timeout_ = __webpack_require__("@babel/runtime-corejs3/core-js-stable/set-timeout"),
        set_timeout_default = __webpack_require__.n(set_timeout_),
        find_index_ = __webpack_require__("@babel/runtime-corejs3/core-js-stable/instance/find-index"),
        find_index_default = __webpack_require__.n(find_index_),
        parse_int_ = __webpack_require__("@babel/runtime-corejs3/core-js-stable/parse-int"),
        parse_int_default = __webpack_require__.n(parse_int_),
        merge_ = __webpack_require__("lodash/merge"),
        merge_default = __webpack_require__.n(merge_);

    var MoreButtonContent = function MoreButtonContent(_ref43) {
      var toggle = _ref43.toggle,
          routes = _ref43.routes,
          themeStyles = _ref43.themeStyles,
          setMoreButtonWidth = _ref43.setMoreButtonWidth,
          isOpen = _ref43.isOpen,
          accessibilityProps = _ref43.accessibilityProps,
          id = _ref43.id;
      var location = Object(external_react_router_dom_.useLocation)(),
          translator = Object(external_react_.useContext)(locale_.TranslatorContext);

      (function (callback) {
        var deps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        var location = Object(external_react_router_dom_.useLocation)(),
            oldLocation = Object(external_react_.useRef)(location),
            cb = Object(external_react_.useCallback)(callback, deps);
        Object(external_react_.useEffect)(function () {
          location !== oldLocation.current && cb(), oldLocation.current = location;
        }, [cb, location]);
      })(function () {
        return toggle(!1);
      }, [isOpen]);

      var isActivePath = function isActivePath(_ref44) {
        var path = _ref44.path;
        return path === location.pathname;
      },
          hasActiveRoute = some_default()(routes).call(routes, function (_ref45) {
        var path = _ref45.path,
            subRoutes = _ref45.routes;
        return isActivePath({
          path: path
        }) || (null == subRoutes ? void 0 : some_default()(subRoutes).call(subRoutes, isActivePath));
      });

      Object(external_react_.useEffect)(function () {
        var _accessibilityProps$r, _accessibilityProps$r2;

        (null === (_accessibilityProps$r = accessibilityProps.ref.current) || void 0 === _accessibilityProps$r ? void 0 : _accessibilityProps$r.offsetWidth) && setMoreButtonWidth(null === (_accessibilityProps$r2 = accessibilityProps.ref.current) || void 0 === _accessibilityProps$r2 ? void 0 : _accessibilityProps$r2.offsetWidth);
      }, [setMoreButtonWidth, accessibilityProps.ref]);
      var classes = external_classnames_default()(themeStyles.navItem, NavBarItem_module_default.a.topNavBarItem, NavBarItem_module_default.a.navBarItem, hasActiveRoute && themeStyles.activeNavItem);
      return external_react_default.a.createElement("button", extends_default()({
        id: id,
        onClick: function onClick() {
          toggle(!isOpen);
        },
        className: classes,
        tabIndex: 0,
        role: "menuitem"
      }, accessibilityProps), external_react_default.a.createElement(components_.InlineLabel, {
        iconPosition: "right",
        icon: external_react_default.a.createElement(components_.Icon, {
          icon: "mi-more-vert",
          style: {
            fontSize: "1rem"
          }
        }),
        className: themeStyles.titleWrapper
      }, translator(ApplicationHeader_messages_messages.moreButtonText)));
    },
        NestedRoutesComponent = function NestedRoutesComponent(_ref46) {
      var themeStyles = _ref46.themeStyles,
          routes = _ref46.routes,
          setMoreButtonWidth = _ref46.setMoreButtonWidth,
          id = _ref46.id,
          moreButtonListMenuOnLeft = _ref46.moreButtonListMenuOnLeft;
      var onRenderTriggerWrapFN = Object(external_react_.useCallback)(function (_ref47, toggle) {
        var triggerId = _ref47.id,
            menuId = _ref47.menuId,
            isOpen = _ref47.isOpen,
            __ = _ref47.onMenuItemClick,
            accessibilityProps = _objectWithoutProperties(_ref47, ["id", "menuId", "isOpen", "onMenuItemClick"]);

        return external_react_default.a.createElement(MoreButtonContent, {
          toggle: toggle,
          routes: routes,
          themeStyles: themeStyles,
          setMoreButtonWidth: setMoreButtonWidth,
          isOpen: isOpen,
          id: triggerId,
          accessibilityProps: accessibilityProps
        });
      }, [routes, themeStyles, setMoreButtonWidth]);
      return routes.length ? external_react_default.a.createElement(external_react_default.a.Fragment, null, external_react_default.a.createElement(DropdownMenu, {
        id: id,
        onRenderTrigger: onRenderTriggerWrapFN,
        alignRight: moreButtonListMenuOnLeft
      }, external_react_default.a.createElement(NavigationContent, {
        routes: map_default()(routes).call(routes, removeNavLinkIcon),
        nestedRoutesComponent: NavBarAccordion,
        alignment: "left"
      }))) : null;
    },
        createMoreButton = function createMoreButton(_ref48) {
      var themeStyles = _ref48.themeStyles,
          routes = _ref48.routes,
          setMoreButtonWidth = _ref48.setMoreButtonWidth,
          moreButtonListMenuOnLeft = _ref48.moreButtonListMenuOnLeft;
      return {
        nestedRoutesComponent: function nestedRoutesComponent(_ref49) {
          var focused = _ref49.focused,
              id = _ref49.id;
          return external_react_default.a.createElement(NestedRoutesComponent, {
            themeStyles: themeStyles,
            routes: routes,
            setMoreButtonWidth: setMoreButtonWidth,
            focused: focused,
            id: id,
            moreButtonListMenuOnLeft: moreButtonListMenuOnLeft
          });
        },
        routes: [{
          path: "/"
        }]
      };
    };

    MoreButtonContent.__docgenInfo = {
      componentName: "MoreButtonContent",
      packageName: "@jutro/router",
      description: "",
      displayName: "MoreButtonContent",
      methods: [],
      actualName: "MoreButtonContent"
    }, NestedRoutesComponent.__docgenInfo = {
      componentName: "NestedRoutesComponent",
      packageName: "@jutro/router",
      description: "",
      displayName: "NestedRoutesComponent",
      methods: [],
      actualName: "NestedRoutesComponent"
    };

    var getElementPaddings = function getElementPaddings(element, padding) {
      return parse_int_default()(getComputedStyle(element).getPropertyValue(padding));
    },
        useRoutesForNavigation = function useRoutesForNavigation() {
      var arrayWithElementsWidth = arguments.length <= 0 ? undefined : arguments[0],
          navigationRoutes = arguments.length <= 1 ? undefined : arguments[1],
          elementWidth = arguments.length <= 2 ? undefined : arguments[2],
          moreButtonWidth = arguments.length <= 3 ? undefined : arguments[3],
          _useState5 = Object(external_react_.useState)(navigationRoutes),
          _useState6 = slicedToArray_default()(_useState5, 2),
          routesForSubHeader = _useState6[0],
          setRoutesForSubheader = _useState6[1],
          _useState7 = Object(external_react_.useState)([]),
          _useState8 = slicedToArray_default()(_useState7, 2),
          routesForMoreButton = _useState8[0],
          setRoutesForMoreButton = _useState8[1],
          visibleNavigationRoutes = null == navigationRoutes ? void 0 : filter_default()(navigationRoutes).call(navigationRoutes, function (route) {
        return !1 !== route.showOnNavBar;
      }),
          _useState9 = Object(external_react_.useState)([]),
          _useState10 = slicedToArray_default()(_useState9, 2),
          subHeaderNavLinksWidths = _useState10[0],
          setSubHeaderNavLinksWidths = _useState10[1],
          _useState11 = Object(external_react_.useState)([]),
          _useState12 = slicedToArray_default()(_useState11, 2),
          moreListNavLinksWidths = _useState12[0],
          setMoreListNavLinksWidths = _useState12[1];

      return Object(external_react_.useLayoutEffect)(function () {
        var navItemIndexToSlice = function (initialWidth, elementWidth, arrayWithElements) {
          return null == arrayWithElements ? void 0 : find_index_default()(arrayWithElements).call(arrayWithElements, function (el) {
            return (initialWidth += el) > elementWidth;
          });
        }(moreButtonWidth, elementWidth, arrayWithElementsWidth);

        navItemIndexToSlice > 0 && (setRoutesForSubheader(null == visibleNavigationRoutes ? void 0 : slice_default()(visibleNavigationRoutes).call(visibleNavigationRoutes, 0, navItemIndexToSlice)), setRoutesForMoreButton(null == visibleNavigationRoutes ? void 0 : slice_default()(visibleNavigationRoutes).call(visibleNavigationRoutes, navItemIndexToSlice)), setSubHeaderNavLinksWidths(null == arrayWithElementsWidth ? void 0 : slice_default()(arrayWithElementsWidth).call(arrayWithElementsWidth, 0, navItemIndexToSlice)), setMoreListNavLinksWidths(null == arrayWithElementsWidth ? void 0 : slice_default()(arrayWithElementsWidth).call(arrayWithElementsWidth, navItemIndexToSlice))), 0 === navItemIndexToSlice && (setRoutesForSubheader([]), setRoutesForMoreButton(navigationRoutes), setSubHeaderNavLinksWidths([])), -1 === navItemIndexToSlice && (setRoutesForSubheader(navigationRoutes), setRoutesForMoreButton([]));
      }, [arrayWithElementsWidth, elementWidth, moreButtonWidth, navigationRoutes]), [routesForSubHeader, routesForMoreButton, subHeaderNavLinksWidths, moreListNavLinksWidths];
    },
        subApplicationHeaderPropTypes = {
      className: external_prop_types_default.a.string,
      navigationRoutes: external_prop_types_default.a.arrayOf(prop_types_.routeShape)
    },
        SubApplicationHeader = function SubApplicationHeader(_ref50) {
      var className = _ref50.className,
          navigationRoutes = _ref50.navigationRoutes;

      var themeStyles = Object(external_react_.useContext)(theme_.ThemeContext).getStyles("SubApplicationHeader", ApplicationHeader_module_default.a),
          classes = external_classnames_default()(themeStyles.subApplicationHeader, className),
          subHeaderRef = Object(external_react_.useRef)(),
          _useState15 = Object(external_react_.useState)(0),
          _useState16 = slicedToArray_default()(_useState15, 2),
          moreButtonWidth = _useState16[0],
          setMoreButtonWidth = _useState16[1],
          subHeaderWidth = function () {
        var _useState = Object(external_react_.useState)(0),
            _useState2 = slicedToArray_default()(_useState, 2),
            elementWidth = _useState2[0],
            setElementWidth = _useState2[1],
            element = arguments.length <= 0 ? undefined : arguments[0],
            navigationRoutes = arguments.length <= 1 ? undefined : arguments[1];

        return Object(external_react_.useLayoutEffect)(function () {
          var elementPaddings;

          var _element$current;

          element.current && (elementPaddings = getElementPaddings(element.current, "padding-right") + getElementPaddings(element.current, "padding-left"), setElementWidth((null === (_element$current = element.current) || void 0 === _element$current ? void 0 : _element$current.offsetWidth) - elementPaddings));

          var setElementWidthOnResize = function setElementWidthOnResize() {
            var _element$current2;

            element.current.classList.add(ApplicationHeader_module_default.a.hiddenOverflow), setElementWidth((null === (_element$current2 = element.current) || void 0 === _element$current2 ? void 0 : _element$current2.offsetWidth) - elementPaddings), set_timeout_default()(function () {
              return element.current.classList.remove(ApplicationHeader_module_default.a.hiddenOverflow);
            }, 1e3);
          };

          return window.addEventListener("resize", setElementWidthOnResize), function () {
            return window.removeEventListener("resize", setElementWidthOnResize);
          };
        }, [element, navigationRoutes]), elementWidth;
      }(subHeaderRef, navigationRoutes),
          debouncedSubHeaderWidth = Object(platform_.useDebounce)(subHeaderWidth, 100),
          initialChildrenWidthsArray = function () {
        var _useState3 = Object(external_react_.useState)([]),
            _useState4 = slicedToArray_default()(_useState3, 2),
            initialElementChildrenWidthsArray = _useState4[0],
            setInitialElementChildrenWidthsArray = _useState4[1],
            element = arguments.length <= 0 ? undefined : arguments[0],
            navigationRoutes = arguments.length <= 1 ? undefined : arguments[1];

        return Object(external_react_.useLayoutEffect)(function () {
          var _element$current3, _context;

          var navigationContentNode = null === (_element$current3 = element.current) || void 0 === _element$current3 ? void 0 : _element$current3.children[0],
              navigationContentNodeWidthsArray = navigationContentNode ? map_default()(_context = _toConsumableArray(navigationContentNode.children)).call(_context, function (node) {
            return node.offsetWidth;
          }) : void 0;
          setInitialElementChildrenWidthsArray(navigationContentNodeWidthsArray);
        }, [element, navigationRoutes]), initialElementChildrenWidthsArray;
      }(subHeaderRef, navigationRoutes),
          _useRoutesForNavigati = useRoutesForNavigation(initialChildrenWidthsArray, navigationRoutes, debouncedSubHeaderWidth, moreButtonWidth),
          _useRoutesForNavigati2 = slicedToArray_default()(_useRoutesForNavigati, 4),
          routesForSubHeader = _useRoutesForNavigati2[0],
          routesForMoreButton = _useRoutesForNavigati2[1],
          moreButtonListMenuOnLeft = function () {
        var _useState13 = Object(external_react_.useState)(!0),
            _useState14 = slicedToArray_default()(_useState13, 2),
            moreButtonListMenuOnLeft = _useState14[0],
            changeMoreMenuPosition = _useState14[1],
            moreButtonWidth = arguments.length <= 0 ? undefined : arguments[0],
            element = arguments.length <= 1 ? undefined : arguments[1],
            subHeaderNavLinksWidths = arguments.length <= 2 ? undefined : arguments[2],
            moreListNavLinksWidths = arguments.length <= 3 ? undefined : arguments[3],
            debouncedSubHeaderWidth = arguments.length <= 4 ? undefined : arguments[4];

        return Object(external_react_.useLayoutEffect)(function () {
          if (moreListNavLinksWidths.length) {
            var subHeaderPaddings = getElementPaddings(element.current, "padding-right") + getElementPaddings(element.current, "padding-left");
            debouncedSubHeaderWidth + subHeaderPaddings - reduce_default()(subHeaderNavLinksWidths).call(subHeaderNavLinksWidths, function (a, b) {
              return a + b;
            }, 0) - moreButtonWidth > Math.max.apply(Math, _toConsumableArray(moreListNavLinksWidths)) ? changeMoreMenuPosition(!1) : changeMoreMenuPosition(!0), subHeaderNavLinksWidths.length || changeMoreMenuPosition(!1);
          }
        }, [debouncedSubHeaderWidth, element, moreButtonWidth, moreListNavLinksWidths, subHeaderNavLinksWidths]), moreButtonListMenuOnLeft;
      }(moreButtonWidth, subHeaderRef, _useRoutesForNavigati2[2], _useRoutesForNavigati2[3], debouncedSubHeaderWidth),
          returnRoutes = function returnRoutes(routes) {
        return map_default()(routes).call(routes, function (route) {
          return merge_default()({}, route, {
            navLink: {
              className: themeStyles.navItem,
              activeClassName: themeStyles.activeNavItem
            }
          });
        });
      },
          navRoutes = returnRoutes(routesForSubHeader || navigationRoutes);

      return external_react_default.a.createElement("nav", {
        className: classes,
        ref: subHeaderRef
      }, external_react_default.a.createElement(TopNavigation, {
        wrap: !0,
        routes: [].concat(_toConsumableArray(navRoutes), [createMoreButton({
          themeStyles: themeStyles,
          routes: routesForMoreButton,
          setMoreButtonWidth: setMoreButtonWidth,
          moreButtonListMenuOnLeft: moreButtonListMenuOnLeft
        })])
      }));
    };

    SubApplicationHeader.propTypes = subApplicationHeaderPropTypes, SubApplicationHeader.__docgenInfo = {
      componentName: "SubApplicationHeader",
      packageName: "@jutro/router",
      description: "SubApplicationHeader is subheader for the default header for all Guidewire applications.\nIt contains navigation.",
      displayName: "SubApplicationHeader",
      methods: [],
      actualName: "SubApplicationHeader",
      metadataType: "container",
      props: {
        className: {
          type: {
            name: "string"
          },
          required: !1,
          description: "CSS class name for this component"
        },
        navigationRoutes: {
          type: {
            name: "arrayOf",
            value: {
              name: "shape",
              value: {
                title: {
                  name: "custom",
                  raw: "intlMessageShape",
                  description: "Route title",
                  required: !1
                },
                path: {
                  name: "string",
                  description: "Route path",
                  required: !1
                },
                showOnNavBar: {
                  name: "bool",
                  description: "When `true` then route will be rendered on nav bar",
                  required: !1
                },
                exact: {
                  name: "bool",
                  description: "When true, will only match if the path matches the location.pathname exactly",
                  required: !1
                },
                navLink: {
                  name: "shape",
                  value: {
                    text: {
                      name: "string",
                      description: "Text for nav link",
                      required: !1
                    },
                    icon: {
                      name: "string",
                      description: "Icon for nav link",
                      required: !1
                    },
                    className: {
                      name: "string",
                      description: "Custom CSS className for nav link",
                      required: !1
                    },
                    activeClassName: {
                      name: "string",
                      description: "Custom CSS className for nav link in active state",
                      required: !1
                    },
                    component: {
                      name: "elementType",
                      description: "React element to render nav item",
                      required: !1
                    }
                  },
                  description: "Nav link props",
                  required: !1
                }
              }
            }
          },
          required: !1,
          description: "Display nav bar defined by routing metadata object. The className and activeClassName in navLink in each element is overwritten"
        }
      }
    };

    var appSwitcherModalPropTypes = {
      isOpen: external_prop_types_default.a.bool,
      onResolve: external_prop_types_default.a.func,
      title: prop_types_.intlMessageShape,
      renderAppSwitcher: external_prop_types_default.a.func
    },
        AppSwitcherModal = function AppSwitcherModal(_ref51) {
      var isOpen = _ref51.isOpen,
          onResolve = _ref51.onResolve,
          title = _ref51.title,
          renderAppSwitcher = _ref51.renderAppSwitcher;
      var themeStyles = Object(external_react_.useContext)(theme_.ThemeContext).getStyles("AppSwitcher", AppSwitcher_module_default.a);
      return external_react_default.a.createElement("div", {
        id: "appSwitcherModal"
      }, external_react_default.a.createElement(components_.ModalNext, {
        isOpen: isOpen,
        onRequestClose: onResolve,
        className: themeStyles.appSwitcherModal
      }, external_react_default.a.createElement(components_.ModalHeader, {
        title: title,
        onClose: onResolve
      }), renderAppSwitcher(onResolve)));
    };

    AppSwitcherModal.propTypes = appSwitcherModalPropTypes, AppSwitcherModal.__docgenInfo = {
      componentName: "AppSwitcherModal",
      packageName: "@jutro/router",
      description: "Modal wrapper for AppSwitcher",
      displayName: "AppSwitcherModal",
      methods: [],
      actualName: "AppSwitcherModal",
      props: {
        isOpen: {
          type: {
            name: "bool"
          },
          required: !1,
          description: "Boolean denoting if the modal is open"
        },
        onResolve: {
          type: {
            name: "func"
          },
          required: !1,
          description: "Callback function called when the modal is closed"
        },
        title: {
          type: {
            name: "union",
            value: [{
              name: "string"
            }, {
              name: "shape",
              value: {
                id: {
                  name: "string",
                  required: !1
                },
                defaultMessage: {
                  name: "string",
                  required: !1
                }
              }
            }]
          },
          required: !1,
          description: "Title displayed in modal header"
        },
        renderAppSwitcher: {
          type: {
            name: "func"
          },
          required: !1,
          description: "Function which takes 'onRouteClick' callback and returns AppSwitcher"
        }
      }
    };

    var burgerAppSwitcherButtonPropTypes = {
      className: external_prop_types_default.a.string,
      title: prop_types_.intlMessageShape.isRequired,
      icon: external_prop_types_default.a.string,
      renderAppSwitcher: external_prop_types_default.a.func
    },
        BurgerAppSwitcherButton = function BurgerAppSwitcherButton(_ref52) {
      var title = _ref52.title,
          icon = _ref52.icon,
          className = _ref52.className,
          renderAppSwitcher = _ref52.renderAppSwitcher;
      var theme = Object(external_react_.useContext)(theme_.ThemeContext),
          translator = Object(external_react_.useContext)(locale_.TranslatorContext),
          navBarThemeStyles = theme.getStyles("NavBar", NavBarItem_module_default.a),
          burgerThemeStyles = theme.getStyles("Burger", BurgerMenu_module_default.a),
          iconComponent = icon && external_react_default.a.createElement(components_.Icon, {
        icon: icon,
        className: navBarThemeStyles.navBarItemIcon
      }),
          buttonClasses = external_classnames_default()(navBarThemeStyles.navBarItem, navBarThemeStyles.leftNavBarItem, className);
      return external_react_default.a.createElement("button", {
        className: buttonClasses,
        onClick: function onClick() {
          components_.ModalNextProvider.showModal(external_react_default.a.createElement(AppSwitcherModal, {
            title: title,
            renderAppSwitcher: renderAppSwitcher
          }));
        }
      }, external_react_default.a.createElement(components_.InlineLabel, {
        tag: "div",
        icon: iconComponent,
        className: navBarThemeStyles.titleWrapper
      }, external_react_default.a.createElement("div", {
        className: burgerThemeStyles.burgerAppSwitcherButtonTitle
      }, translator(title))));
    };

    BurgerAppSwitcherButton.propTypes = burgerAppSwitcherButtonPropTypes, BurgerAppSwitcherButton.__docgenInfo = {
      componentName: "BurgerAppSwitcherButton",
      packageName: "@jutro/router",
      description: "The `BurgerAppSwitcherButton` component is designed as a container for burgerMenu aooSwitcherAccordion",
      displayName: "BurgerAppSwitcherButton",
      methods: [],
      actualName: "BurgerAppSwitcherButton",
      props: {
        className: {
          type: {
            name: "string"
          },
          required: !1,
          description: "Additional class names for component."
        },
        title: {
          type: {
            name: "union",
            value: [{
              name: "string"
            }, {
              name: "shape",
              value: {
                id: {
                  name: "string",
                  required: !1
                },
                defaultMessage: {
                  name: "string",
                  required: !1
                }
              }
            }]
          },
          required: !0,
          description: "Button title."
        },
        icon: {
          type: {
            name: "string"
          },
          required: !1,
          description: "Icon to render to the left of the title"
        },
        renderAppSwitcher: {
          type: {
            name: "func"
          },
          required: !1,
          description: "Function which takes 'onRouteClick' callback and returns AppSwitcher"
        }
      }
    };

    var dropdownMenuLinkShape = external_prop_types_default.a.shape(_objectSpread({}, prop_types_.dropdownMenuLinkPropTypes, {
      title: external_prop_types_default.a.string
    })),
        LookupOptionShape = external_prop_types_default.a.shape(_objectSpread({}, prop_types_.availableValuesIdDisplayNameObject, {
      type: external_prop_types_default.a.string.isRequired
    })),
        ApplicationHeaderPropTypes = {
      className: external_prop_types_default.a.string,
      logoSrc: external_prop_types_default.a.string,
      logoUrl: external_prop_types_default.a.string,
      navigationRoutes: external_prop_types_default.a.arrayOf(prop_types_.routeShape),
      onSearchValueChange: external_prop_types_default.a.func,
      searchAvailableValues: external_prop_types_default.a.arrayOf(LookupOptionShape),
      showNotifications: external_prop_types_default.a.bool,
      notificationChildren: external_prop_types_default.a.node,
      showAvatar: external_prop_types_default.a.bool,
      avatarChildren: external_prop_types_default.a.node,
      avatarProps: external_prop_types_default.a.shape({
        username: external_prop_types_default.a.string,
        title: external_prop_types_default.a.string,
        subtitle: external_prop_types_default.a.string,
        imageSource: external_prop_types_default.a.string
      }),
      commonAvatarRoutes: external_prop_types_default.a.arrayOf(dropdownMenuLinkShape),
      searchFieldPlaceholder: prop_types_.intlMessageShape,
      isResponsiveOnTablet: Object(prop_types_.deprecated)(external_prop_types_default.a.bool, "5.0", "Prop is causing spacing issues when set to false"),
      showAppSwitcher: external_prop_types_default.a.bool,
      appSwitcherRoutes: Object(prop_types_.deprecated)(external_prop_types_default.a.arrayOf(prop_types_.appSwitcherRoutePropTypes), "5.0", 'Please use "appSwitcherItems" instead'),
      appSwitcherItems: external_prop_types_default.a.arrayOf(external_prop_types_default.a.oneOfType([prop_types_.appSwitcherRoutePropTypes, separatorPropType])),
      appSwitcherTitle: Object(prop_types_.deprecated)(prop_types_.intlMessageShape, "5.0", "AppSwitcher no longer displays title"),
      useAuthInfo: external_prop_types_default.a.bool,
      showHelp: external_prop_types_default.a.bool,
      helpUrl: external_prop_types_default.a.oneOfType([external_prop_types_default.a.string, prop_types_.linkShape]),
      helpPopoverItems: external_prop_types_default.a.arrayOf(prop_types_.ComponentPropTypes.oneOfChildOfComponentTypes([components_.HelpElement, components_.HelpHeading, components_.HelpParagraph, components_.HelpLink])),
      callbackMap: external_prop_types_default.a.object,
      appSwitcherFooterText: prop_types_.intlMessageShape,
      appSwitcherFooterUrl: external_prop_types_default.a.string,
      onAppSwitcherFooterClick: external_prop_types_default.a.func
    },
        ApplicationHeaderInternal = function ApplicationHeaderInternal(props) {
      var theme = Object(external_react_.useContext)(theme_.ThemeContext),
          translator = Object(external_react_.useContext)(locale_.TranslatorContext),
          _useState = Object(external_react_.useState)(null),
          _useState2 = slicedToArray_default()(_useState, 2),
          searchValue = _useState2[0],
          setSearchValue = _useState2[1],
          themeProps = theme ? theme.getProps("ApplicationHeader", props) : props,
          _useBreakpoint = Object(layout_.useBreakpoint)(themeProps),
          breakpointProps = _useBreakpoint.breakpointProps,
          breakpoint = _useBreakpoint.breakpoint,
          themeStyles = theme.getStyles("ApplicationHeader", ApplicationHeader_module_default.a),
          className = breakpointProps.className,
          logoSrc = breakpointProps.logoSrc,
          logoUrl = breakpointProps.logoUrl,
          navigationRoutes = breakpointProps.navigationRoutes,
          onSearchValueChange = breakpointProps.onSearchValueChange,
          showNotifications = breakpointProps.showNotifications,
          notificationChildren = breakpointProps.notificationChildren,
          showAvatar = breakpointProps.showAvatar,
          avatarChildren = breakpointProps.avatarChildren,
          avatarProps = breakpointProps.avatarProps,
          searchFieldPlaceholder = breakpointProps.searchFieldPlaceholder,
          isResponsiveOnTablet = breakpointProps.isResponsiveOnTablet,
          showAppSwitcher = breakpointProps.showAppSwitcher,
          appSwitcherRoutes = breakpointProps.appSwitcherRoutes,
          appSwitcherItems = breakpointProps.appSwitcherItems,
          useAuthInfo = breakpointProps.useAuthInfo,
          commonAvatarRoutes = breakpointProps.commonAvatarRoutes,
          showHelp = breakpointProps.showHelp,
          helpUrl = breakpointProps.helpUrl,
          helpPopoverItems = breakpointProps.helpPopoverItems,
          searchAvailableValues = breakpointProps.searchAvailableValues,
          callbackMap = breakpointProps.callbackMap,
          appSwitcherFooterText = breakpointProps.appSwitcherFooterText,
          appSwitcherFooterUrl = breakpointProps.appSwitcherFooterUrl,
          onAppSwitcherFooterClick = breakpointProps.onAppSwitcherFooterClick,
          classes = external_classnames_default()(themeStyles.applicationHeader, className),
          wrapperClasses = external_classnames_default()(themeStyles.applicationHeaderWrapper, className),
          onValueChange = function onValueChange(val) {
        setSearchValue(val), onSearchValueChange && onSearchValueChange(val);
      },
          headerLogo = logoSrc && external_react_default.a.createElement(external_react_router_dom_.NavLink, {
        to: logoUrl,
        className: themeStyles.applicationLogoTitleLink
      }, external_react_default.a.createElement(components_.LogoTitle, {
        src: logoSrc,
        logoClassName: themeStyles.applicationLogo,
        alt: translator(ApplicationHeader_messages_messages.logoAlt)
      })),
          headerNotifications = showNotifications && external_react_default.a.createElement("span", null, external_react_default.a.createElement(components_.NotificationAction, {
        id: "notificationAction",
        title: ApplicationHeader_messages_messages.notifications,
        isFlipEnabled: !1,
        renderTrigger: function renderTrigger(toggle, ref, hasShownPopover) {
          return external_react_default.a.createElement(components_.IconButton, {
            id: "notificationButton",
            icon: "mi-notifications",
            iconColor: "light",
            ref: ref,
            onClick: toggle,
            className: themeStyles.headerActionButton,
            "aria-label": translator(ApplicationHeader_messages_messages.notificationButton),
            "aria-haspopup": "menu",
            "aria-expanded": hasShownPopover,
            size: "large"
          });
        }
      }, notificationChildren)),
          renderTrigger = Object(external_react_.useCallback)(function (toggle, ref, hasShownPopover) {
        return external_react_default.a.createElement(components_.IconButton, {
          id: "helpButton",
          "data-testid": "help-icon",
          icon: "mi-help",
          iconColor: "light",
          ref: ref,
          onClick: toggle,
          className: themeStyles.headerActionButton,
          "aria-label": translator(ApplicationHeader_messages_messages.help),
          "aria-haspopup": "menu",
          "aria-expanded": hasShownPopover,
          size: "large"
        });
      }, [themeStyles.headerActionButton, translator]),
          helpPopoverId = Object(platform_.uniqueInnerId)("ApplicationHeader", "helpPopoverId").helpPopoverId,
          helpPopover = showHelp && external_react_default.a.createElement("span", null, external_react_default.a.createElement(components_.HelpPopover, {
        id: helpPopoverId,
        renderTrigger: renderTrigger,
        footerLink: helpUrl
      }, helpPopoverItems)),
          renderHeaderSearchField = function renderHeaderSearchField(searchColorTheme) {
        var _external_classnames_17;

        var isDarkTheme = "dark" === searchColorTheme;
        return onSearchValueChange && external_react_default.a.createElement(components_.LookupField, {
          id: "search",
          label: "search",
          labelId: "search_63202513",
          value: searchValue,
          onValueChange: onValueChange,
          layout: "full-width",
          className: external_classnames_default()((_external_classnames_17 = {}, _defineProperty(_external_classnames_17, themeStyles.darkSearchContainer, isDarkTheme), _defineProperty(_external_classnames_17, themeStyles.searchContainer, !isDarkTheme), _external_classnames_17)),
          availableValues: searchAvailableValues,
          controlClassName: external_classnames_default()(searchColorTheme, themeStyles.searchField),
          placeholder: translator(searchFieldPlaceholder) || null
        });
      },
          handleCallbackRedirect = function handleCallbackRedirect(callback, shouldRedirect) {
        return shouldRedirect ? callback : function (callback) {
          return function (evt) {
            for (var _len5 = arguments.length, args = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
              args[_key5 - 1] = arguments[_key5];
            }

            evt.preventDefault(), callback.apply(void 0, [evt].concat(args));
          };
        }(callback);
      },
          commonAvatarContent = null == commonAvatarRoutes ? void 0 : map_default()(commonAvatarRoutes).call(commonAvatarRoutes, function (_ref53, index) {
        var title = _ref53.title,
            onClick = _ref53.onClick,
            rest = _objectWithoutProperties(_ref53, ["title", "onClick"]);

        var to = rest.to,
            href = rest.href,
            shouldRedirect = !isUndefined_default()(to || href),
            callback = callbackMap[onClick],
            resolvedCallback = callback ? {
          onClick: handleCallbackRedirect(callback, shouldRedirect)
        } : {},
            dropdownProps = _objectSpread({}, rest, {}, resolvedCallback);

        return external_react_default.a.createElement(DropdownMenuLink, extends_default()({
          key: "" + index
        }, dropdownProps), title);
      }),
          getHeaderAvatar = Object(external_react_.useCallback)(function () {
        return showAvatar ? external_react_default.a.createElement(DropdownMenuAvatar, extends_default()({
          id: "dropdownavatar",
          buttonAvatarSize: "small",
          headerAvatarSize: "medium",
          icon: "user",
          dropUp: !1,
          alignRight: !0,
          useAuthInfo: useAuthInfo
        }, avatarProps), avatarChildren, commonAvatarContent) : null;
      }, [avatarChildren, avatarProps, commonAvatarContent, showAvatar, useAuthInfo]),
          mobileBurgerContent = [onSearchValueChange && external_react_default.a.createElement("div", {
        className: ApplicationHeader_module_default.a.burgerMenuSidebarStyledContent
      }, renderHeaderSearchField()), showHelp && external_react_default.a.createElement(function (_ref54) {
        var children = _ref54.children;
        var url = "string" == typeof helpUrl ? helpUrl : null == helpUrl ? void 0 : helpUrl.href,
            safeHelpUrl = Object(platform_.sanitizeUrl)(url);
        return safeHelpUrl ? external_react_default.a.createElement("a", {
          href: safeHelpUrl,
          className: ApplicationHeader_module_default.a.helpIcon,
          tabIndex: "-1",
          target: "_blank",
          rel: "noopener noreferrer"
        }, children) : null;
      }, null, external_react_default.a.createElement("div", {
        id: "helpButton",
        className: external_classnames_default()(ApplicationHeader_module_default.a.burgerMenuAvatarChildren, DropdownMenu_module_default.a.link, DropdownMenu_module_default.a.dropdownMenu),
        "data-testid": "help-link"
      }, translator(ApplicationHeader_messages_messages.help))), showAppSwitcher && external_react_default.a.createElement(BurgerAppSwitcherButton, {
        icon: "mi-apps",
        title: ApplicationHeader_messages_messages.switchApplication,
        renderAppSwitcher: function renderAppSwitcher(onRouteClick) {
          return external_react_default.a.createElement(AppSwitcher, {
            id: "appSwitcher",
            items: appSwitcherItems || appSwitcherRoutes,
            onRouteClick: onRouteClick,
            iconColor: "light",
            iconClassName: themeStyles.headerActionButton,
            iconSize: "large",
            footerText: appSwitcherFooterText,
            footerUrl: appSwitcherFooterUrl,
            footerOnClick: onAppSwitcherFooterClick,
            isDropdown: !1
          });
        }
      }), showAvatar && external_react_default.a.createElement(DropdownMenuAvatarContent, extends_default()({
        headerAvatarSize: "large",
        icon: "user",
        useAuthInfo: useAuthInfo,
        headerClassName: external_classnames_default()(ApplicationHeader_module_default.a.burgerMenuSidebarStyledContent, ApplicationHeader_module_default.a.burgerMenuAvatar),
        authLinksClassName: ApplicationHeader_module_default.a.burgerMenuAuthLinks,
        separatorClassName: ApplicationHeader_module_default.a.burgerMenuSeparator
      }, avatarProps), (avatarChildren || commonAvatarContent) && external_react_default.a.createElement("div", {
        className: ApplicationHeader_module_default.a.burgerMenuAvatarChildren
      }, avatarChildren, commonAvatarContent)) || void 0],
          appSwitcher = showAppSwitcher && external_react_default.a.createElement("span", null, external_react_default.a.createElement(AppSwitcher, {
        id: "appSwitcher",
        items: appSwitcherItems || appSwitcherRoutes,
        iconColor: "light",
        iconClassName: themeStyles.headerActionButton,
        iconSize: "large",
        footerText: appSwitcherFooterText,
        footerUrl: appSwitcherFooterUrl,
        onFooterClick: onAppSwitcherFooterClick
      })),
          subApplicationHeader = (null == navigationRoutes ? void 0 : navigationRoutes.length) && external_react_default.a.createElement(SubApplicationHeader, {
        navigationRoutes: navigationRoutes
      });

      return !breakpoint || "desktop" === breakpoint || "tablet" === breakpoint && !isResponsiveOnTablet ? external_react_default.a.createElement("section", {
        className: wrapperClasses
      }, external_react_default.a.createElement(components_.Header, {
        className: classes
      }, headerLogo, "desktop" === breakpoint ? (element = renderHeaderSearchField("dark"), onSearchValueChange && external_react_default.a.createElement("div", {
        className: themeStyles.centerWrapper
      }, element)) : renderHeaderSearchField("dark"), external_react_default.a.createElement(components_.HeaderActions, {
        className: themeStyles.headerActions
      }, helpPopover, appSwitcher, headerNotifications, getHeaderAvatar())), subApplicationHeader) : external_react_default.a.createElement("section", {
        className: wrapperClasses
      }, external_react_default.a.createElement(components_.Header, {
        className: classes,
        responsiveOnTablet: isResponsiveOnTablet
      }, external_react_default.a.createElement(BurgerMenu, {
        buttonClassName: themeStyles.headerActionButton,
        burgerContent: mobileBurgerContent,
        separatorClassName: ApplicationHeader_module_default.a.burgerMenuSeparator
      }), headerLogo, external_react_default.a.createElement(components_.HeaderActions, null, headerNotifications)), subApplicationHeader);
      var element;
    };

    ApplicationHeaderInternal.displayName = "ApplicationHeader", ApplicationHeaderInternal.propTypes = ApplicationHeaderPropTypes, ApplicationHeaderInternal.defaultProps = {
      showNotifications: !0,
      showAvatar: !0,
      showAppSwitcher: !0,
      searchFieldPlaceholder: ApplicationHeader_messages_messages.searchFieldPlaceholder,
      isResponsiveOnTablet: !0,
      useAuthInfo: !0,
      logoUrl: "/",
      callbackMap: {}
    };
    var ApplicationHeader = Object(prop_types_.withTransformedProps)(ApplicationHeaderInternal);
    ApplicationHeaderInternal.__docgenInfo = {
      componentName: "ApplicationHeader",
      packageName: "@jutro/router",
      description: "ApplicationHeader is the default header for all Guidewire applications.\nIt contains all the typical controls for Guidewire apps.\nIf you want to add other controls to the header, use the Header component instead",
      displayName: "ApplicationHeader",
      methods: [],
      actualName: "ApplicationHeaderInternal",
      metadataType: "container",
      props: {
        className: {
          type: {
            name: "string"
          },
          required: !1,
          description: "CSS class name for this component"
        },
        logoSrc: {
          type: {
            name: "string"
          },
          required: !1,
          description: "Display logo from source"
        },
        logoUrl: {
          type: {
            name: "string"
          },
          required: !1,
          description: "The link path for the logo",
          defaultValue: {
            value: "'/'",
            computed: !1
          }
        },
        navigationRoutes: {
          type: {
            name: "arrayOf",
            value: {
              name: "shape",
              value: {
                title: {
                  name: "custom",
                  raw: "intlMessageShape",
                  description: "Route title",
                  required: !1
                },
                path: {
                  name: "string",
                  description: "Route path",
                  required: !1
                },
                showOnNavBar: {
                  name: "bool",
                  description: "When `true` then route will be rendered on nav bar",
                  required: !1
                },
                exact: {
                  name: "bool",
                  description: "When true, will only match if the path matches the location.pathname exactly",
                  required: !1
                },
                navLink: {
                  name: "shape",
                  value: {
                    text: {
                      name: "string",
                      description: "Text for nav link",
                      required: !1
                    },
                    icon: {
                      name: "string",
                      description: "Icon for nav link",
                      required: !1
                    },
                    className: {
                      name: "string",
                      description: "Custom CSS className for nav link",
                      required: !1
                    },
                    activeClassName: {
                      name: "string",
                      description: "Custom CSS className for nav link in active state",
                      required: !1
                    },
                    component: {
                      name: "elementType",
                      description: "React element to render nav item",
                      required: !1
                    }
                  },
                  description: "Nav link props",
                  required: !1
                }
              }
            }
          },
          required: !1,
          description: "Display nav bar defined by routing metadata object. The className and activeClassName in navLink in each element is overwritten"
        },
        onSearchValueChange: {
          type: {
            name: "func"
          },
          required: !1,
          description: "Display search field. Callback for the search field value change"
        },
        searchAvailableValues: {
          type: {
            name: "arrayOf",
            value: {
              name: "custom",
              raw: "LookupOptionShape"
            }
          },
          required: !1,
          description: "Array of choice objects to display"
        },
        showNotifications: {
          type: {
            name: "bool"
          },
          required: !1,
          description: "Display notification icon",
          defaultValue: {
            value: "true",
            computed: !1
          }
        },
        notificationChildren: {
          type: {
            name: "node"
          },
          required: !1,
          description: "Notification content to be rendered"
        },
        showAvatar: {
          type: {
            name: "bool"
          },
          required: !1,
          description: "Display avatar",
          defaultValue: {
            value: "true",
            computed: !1
          }
        },
        avatarChildren: {
          type: {
            name: "node"
          },
          required: !1,
          description: "Avatar content to be rendered"
        },
        avatarProps: {
          type: {
            name: "shape",
            value: {
              username: {
                name: "string",
                description: "username used to render initials in Avatar",
                required: !1
              },
              title: {
                name: "string",
                description: "The main title to be displayed inside the Avatar MenuDropdown",
                required: !1
              },
              subtitle: {
                name: "string",
                description: "The main subtitle to be displayed inside the Avatar MenuDropdown",
                required: !1
              },
              imageSource: {
                name: "string",
                description: "Image source for the Avatar button",
                required: !1
              }
            }
          },
          required: !1,
          description: "Avatar props to be passed down if not using auth info (username, imageSource, title, subtitle)"
        },
        commonAvatarRoutes: {
          type: {
            name: "arrayOf",
            value: {
              name: "custom",
              raw: "dropdownMenuLinkShape"
            }
          },
          required: !1,
          description: "Array of items to be displayed as common Avatar content"
        },
        searchFieldPlaceholder: {
          type: {
            name: "union",
            value: [{
              name: "string"
            }, {
              name: "shape",
              value: {
                id: {
                  name: "string",
                  required: !1
                },
                defaultMessage: {
                  name: "string",
                  required: !1
                }
              }
            }]
          },
          required: !1,
          description: "Search field placeholder",
          defaultValue: {
            value: "messages.searchFieldPlaceholder",
            computed: !0
          }
        },
        isResponsiveOnTablet: {
          type: {
            name: "bool"
          },
          required: !1,
          description: "@deprecated Responsive burger menu breakpoint",
          defaultValue: {
            value: "true",
            computed: !1
          },
          deprecationInfo: {
            version: "5.0",
            mapTo: null
          }
        },
        showAppSwitcher: {
          type: {
            name: "bool"
          },
          required: !1,
          description: "Flag to show App Switcher when set to true",
          defaultValue: {
            value: "true",
            computed: !1
          }
        },
        appSwitcherRoutes: {
          type: {
            name: "arrayOf",
            value: {
              name: "shape",
              value: {
                title: {
                  name: "custom",
                  raw: "intlMessageShape",
                  description: "Title that will be displayed below the icon",
                  required: !1
                },
                to: {
                  name: "custom",
                  raw: "toShape",
                  description: "Internal path to the application",
                  required: !1
                },
                href: {
                  name: "string",
                  description: "External path",
                  required: !1
                },
                imageUrl: {
                  name: "string",
                  description: "Source of the image",
                  required: !1
                },
                imageAlt: {
                  name: "string",
                  description: "Alternative text of the image",
                  required: !1
                },
                exact: {
                  name: "bool",
                  description: "Flag for the exact path matching in react-router",
                  required: !1
                },
                onClick: {
                  name: "func",
                  description: "Callback on item click event handler",
                  required: !1
                },
                isFocused: {
                  name: "bool",
                  description: "Flag to indicate if the current item is focused",
                  required: !1
                }
              }
            }
          },
          required: !1,
          description: "@deprecated Array of items to be displayed in the popover menu of App Switcher",
          deprecationInfo: {
            version: "5.0",
            mapTo: "appSwitcherItems"
          }
        },
        appSwitcherItems: {
          type: {
            name: "arrayOf",
            value: {
              name: "union",
              value: [{
                name: "shape",
                value: {
                  title: {
                    name: "custom",
                    raw: "intlMessageShape",
                    description: "Title that will be displayed below the icon",
                    required: !1
                  },
                  to: {
                    name: "custom",
                    raw: "toShape",
                    description: "Internal path to the application",
                    required: !1
                  },
                  href: {
                    name: "string",
                    description: "External path",
                    required: !1
                  },
                  imageUrl: {
                    name: "string",
                    description: "Source of the image",
                    required: !1
                  },
                  imageAlt: {
                    name: "string",
                    description: "Alternative text of the image",
                    required: !1
                  },
                  exact: {
                    name: "bool",
                    description: "Flag for the exact path matching in react-router",
                    required: !1
                  },
                  onClick: {
                    name: "func",
                    description: "Callback on item click event handler",
                    required: !1
                  },
                  isFocused: {
                    name: "bool",
                    description: "Flag to indicate if the current item is focused",
                    required: !1
                  }
                }
              }, {
                name: "shape",
                value: {
                  separator: {
                    name: "bool",
                    required: !1
                  }
                }
              }]
            }
          },
          required: !1,
          description: "Array of items to be displayed in App Switcher menu"
        },
        appSwitcherTitle: {
          type: {
            name: "union",
            value: [{
              name: "string"
            }, {
              name: "shape",
              value: {
                id: {
                  name: "string",
                  required: !1
                },
                defaultMessage: {
                  name: "string",
                  required: !1
                }
              }
            }]
          },
          required: !1,
          description: "@deprecated Title of App Switcher",
          deprecationInfo: {
            version: "5.0",
            mapTo: null
          }
        },
        useAuthInfo: {
          type: {
            name: "bool"
          },
          required: !1,
          description: "Use Okta auth info",
          defaultValue: {
            value: "true",
            computed: !1
          }
        },
        showHelp: {
          type: {
            name: "bool"
          },
          required: !1,
          description: "Flag to show Help dropdown when set to true"
        },
        helpUrl: {
          type: {
            name: "union",
            value: [{
              name: "string"
            }, {
              name: "shape",
              value: {
                label: {
                  name: "custom",
                  raw: "intlMessageShape.isRequired",
                  required: !0
                },
                onClick: {
                  name: "func",
                  required: !1
                },
                href: {
                  name: "string",
                  required: !1
                }
              }
            }]
          },
          required: !1,
          description: "The link path for the help page"
        },
        helpPopoverItems: {
          type: {
            name: "arrayOf",
            value: {
              name: "custom",
              raw: "ComponentPropTypes.oneOfChildOfComponentTypes([\n    HelpElement,\n    HelpHeading,\n    HelpParagraph,\n    HelpLink,\n])"
            }
          },
          required: !1,
          description: "Help popover items"
        },
        callbackMap: {
          type: {
            name: "object"
          },
          required: !1,
          description: "map to resolve callbacks on avatar links",
          defaultValue: {
            value: "{}",
            computed: !1
          }
        },
        appSwitcherFooterText: {
          type: {
            name: "union",
            value: [{
              name: "string"
            }, {
              name: "shape",
              value: {
                id: {
                  name: "string",
                  required: !1
                },
                defaultMessage: {
                  name: "string",
                  required: !1
                }
              }
            }]
          },
          required: !1,
          description: "Text displayed on footer link in AppSwitcher"
        },
        appSwitcherFooterUrl: {
          type: {
            name: "string"
          },
          required: !1,
          description: "URL to which footer link in AppSwitcher leads"
        },
        onAppSwitcherFooterClick: {
          type: {
            name: "func"
          },
          required: !1,
          description: "Callback which will be triggered when footer link in AppSwitcher is clicked"
        }
      }
    };

    var PageHead = function PageHead(props) {
      var currentLanguage = props.currentLanguage,
          appName = props.appName,
          appDescription = props.appDescription;
      return external_react_default.a.createElement(external_react_helmet_.Helmet, {
        htmlAttributes: {
          lang: currentLanguage
        },
        titleTemplate: "%s - " + appName,
        defaultTitle: appName
      }, external_react_default.a.createElement("meta", {
        name: "description",
        content: appDescription
      }));
    };

    PageHead.propTypes = {
      currentLanguage: external_prop_types_default.a.string,
      appName: external_prop_types_default.a.string,
      appDescription: external_prop_types_default.a.string
    }, PageHead.__docgenInfo = {
      componentName: "PageHead",
      packageName: "@jutro/router",
      description: "PageHead component provides an api to configure and manipulate\nthe head tag on the page",
      displayName: "PageHead",
      methods: [],
      actualName: "PageHead",
      props: {
        currentLanguage: {
          type: {
            name: "string"
          },
          required: !1,
          description: "Page current language"
        },
        appName: {
          type: {
            name: "string"
          },
          required: !1,
          description: "Application name to display in title"
        },
        appDescription: {
          type: {
            name: "string"
          },
          required: !1,
          description: "Application description"
        }
      }
    };
  },
  "@babel/runtime-corejs3/core-js-stable/array/is-array": function babelRuntimeCorejs3CoreJsStableArrayIsArray(module, exports) {
    module.exports = require("@babel/runtime-corejs3/core-js-stable/array/is-array");
  },
  "@babel/runtime-corejs3/core-js-stable/instance/every": function babelRuntimeCorejs3CoreJsStableInstanceEvery(module, exports) {
    module.exports = require("@babel/runtime-corejs3/core-js-stable/instance/every");
  },
  "@babel/runtime-corejs3/core-js-stable/instance/filter": function babelRuntimeCorejs3CoreJsStableInstanceFilter(module, exports) {
    module.exports = require("@babel/runtime-corejs3/core-js-stable/instance/filter");
  },
  "@babel/runtime-corejs3/core-js-stable/instance/find-index": function babelRuntimeCorejs3CoreJsStableInstanceFindIndex(module, exports) {
    module.exports = require("@babel/runtime-corejs3/core-js-stable/instance/find-index");
  },
  "@babel/runtime-corejs3/core-js-stable/instance/for-each": function babelRuntimeCorejs3CoreJsStableInstanceForEach(module, exports) {
    module.exports = require("@babel/runtime-corejs3/core-js-stable/instance/for-each");
  },
  "@babel/runtime-corejs3/core-js-stable/instance/includes": function babelRuntimeCorejs3CoreJsStableInstanceIncludes(module, exports) {
    module.exports = require("@babel/runtime-corejs3/core-js-stable/instance/includes");
  },
  "@babel/runtime-corejs3/core-js-stable/instance/map": function babelRuntimeCorejs3CoreJsStableInstanceMap(module, exports) {
    module.exports = require("@babel/runtime-corejs3/core-js-stable/instance/map");
  },
  "@babel/runtime-corejs3/core-js-stable/instance/reduce": function babelRuntimeCorejs3CoreJsStableInstanceReduce(module, exports) {
    module.exports = require("@babel/runtime-corejs3/core-js-stable/instance/reduce");
  },
  "@babel/runtime-corejs3/core-js-stable/instance/slice": function babelRuntimeCorejs3CoreJsStableInstanceSlice(module, exports) {
    module.exports = require("@babel/runtime-corejs3/core-js-stable/instance/slice");
  },
  "@babel/runtime-corejs3/core-js-stable/instance/some": function babelRuntimeCorejs3CoreJsStableInstanceSome(module, exports) {
    module.exports = require("@babel/runtime-corejs3/core-js-stable/instance/some");
  },
  "@babel/runtime-corejs3/core-js-stable/object/entries": function babelRuntimeCorejs3CoreJsStableObjectEntries(module, exports) {
    module.exports = require("@babel/runtime-corejs3/core-js-stable/object/entries");
  },
  "@babel/runtime-corejs3/core-js-stable/parse-int": function babelRuntimeCorejs3CoreJsStableParseInt(module, exports) {
    module.exports = require("@babel/runtime-corejs3/core-js-stable/parse-int");
  },
  "@babel/runtime-corejs3/core-js-stable/reflect/construct": function babelRuntimeCorejs3CoreJsStableReflectConstruct(module, exports) {
    module.exports = require("@babel/runtime-corejs3/core-js-stable/reflect/construct");
  },
  "@babel/runtime-corejs3/core-js-stable/set-timeout": function babelRuntimeCorejs3CoreJsStableSetTimeout(module, exports) {
    module.exports = require("@babel/runtime-corejs3/core-js-stable/set-timeout");
  },
  "@babel/runtime-corejs3/helpers/extends": function babelRuntimeCorejs3HelpersExtends(module, exports) {
    module.exports = require("@babel/runtime-corejs3/helpers/extends");
  },
  "@babel/runtime-corejs3/helpers/inherits": function babelRuntimeCorejs3HelpersInherits(module, exports) {
    module.exports = require("@babel/runtime-corejs3/helpers/inherits");
  },
  "@jutro/auth": function jutroAuth(module, exports) {
    module.exports = require("@jutro/auth");
  },
  "@jutro/components": function jutroComponents(module, exports) {
    module.exports = require("@jutro/components");
  },
  "@jutro/events": function jutroEvents(module, exports) {
    module.exports = require("@jutro/events");
  },
  "@jutro/layout": function jutroLayout(module, exports) {
    module.exports = require("@jutro/layout");
  },
  "@jutro/locale": function jutroLocale(module, exports) {
    module.exports = require("@jutro/locale");
  },
  "@jutro/logger": function jutroLogger(module, exports) {
    module.exports = require("@jutro/logger");
  },
  "@jutro/platform": function jutroPlatform(module, exports) {
    module.exports = require("@jutro/platform");
  },
  "@jutro/prop-types": function jutroPropTypes(module, exports) {
    module.exports = require("@jutro/prop-types");
  },
  "@jutro/services": function jutroServices(module, exports) {
    module.exports = require("@jutro/services");
  },
  "@jutro/theme": function jutroTheme(module, exports) {
    module.exports = require("@jutro/theme");
  },
  "@jutro/uimetadata": function jutroUimetadata(module, exports) {
    module.exports = require("@jutro/uimetadata");
  },
  classnames: function classnames(module, exports) {
    module.exports = require("classnames");
  },
  "core-js-pure/features/array/from": function coreJsPureFeaturesArrayFrom(module, exports) {
    module.exports = require("core-js-pure/features/array/from");
  },
  "core-js-pure/features/array/is-array": function coreJsPureFeaturesArrayIsArray(module, exports) {
    module.exports = require("core-js-pure/features/array/is-array");
  },
  "core-js-pure/features/get-iterator": function coreJsPureFeaturesGetIterator(module, exports) {
    module.exports = require("core-js-pure/features/get-iterator");
  },
  "core-js-pure/features/instance/index-of": function coreJsPureFeaturesInstanceIndexOf(module, exports) {
    module.exports = require("core-js-pure/features/instance/index-of");
  },
  "core-js-pure/features/instance/slice": function coreJsPureFeaturesInstanceSlice(module, exports) {
    module.exports = require("core-js-pure/features/instance/slice");
  },
  "core-js-pure/features/is-iterable": function coreJsPureFeaturesIsIterable(module, exports) {
    module.exports = require("core-js-pure/features/is-iterable");
  },
  "core-js-pure/features/object/define-property": function coreJsPureFeaturesObjectDefineProperty(module, exports) {
    module.exports = require("core-js-pure/features/object/define-property");
  },
  "core-js-pure/features/object/get-own-property-symbols": function coreJsPureFeaturesObjectGetOwnPropertySymbols(module, exports) {
    module.exports = require("core-js-pure/features/object/get-own-property-symbols");
  },
  "core-js-pure/features/object/get-prototype-of": function coreJsPureFeaturesObjectGetPrototypeOf(module, exports) {
    module.exports = require("core-js-pure/features/object/get-prototype-of");
  },
  "core-js-pure/features/object/keys": function coreJsPureFeaturesObjectKeys(module, exports) {
    module.exports = require("core-js-pure/features/object/keys");
  },
  "core-js-pure/features/object/set-prototype-of": function coreJsPureFeaturesObjectSetPrototypeOf(module, exports) {
    module.exports = require("core-js-pure/features/object/set-prototype-of");
  },
  "core-js-pure/features/symbol": function coreJsPureFeaturesSymbol(module, exports) {
    module.exports = require("core-js-pure/features/symbol");
  },
  "core-js-pure/features/symbol/iterator": function coreJsPureFeaturesSymbolIterator(module, exports) {
    module.exports = require("core-js-pure/features/symbol/iterator");
  },
  "core-js/modules/es.string.replace": function coreJsModulesEsStringReplace(module, exports) {
    module.exports = require("core-js/modules/es.string.replace");
  },
  "core-js/modules/web.dom-collections.iterator": function coreJsModulesWebDomCollectionsIterator(module, exports) {
    module.exports = require("core-js/modules/web.dom-collections.iterator");
  },
  history: function history(module, exports) {
    module.exports = require("history");
  },
  lodash: function lodash(module, exports) {
    module.exports = require("lodash");
  },
  "lodash/get": function lodashGet(module, exports) {
    module.exports = require("lodash/get");
  },
  "lodash/merge": function lodashMerge(module, exports) {
    module.exports = require("lodash/merge");
  },
  "memoize-one": function memoizeOne(module, exports) {
    module.exports = require("memoize-one");
  },
  "prop-types": function propTypes(module, exports) {
    module.exports = require("prop-types");
  },
  react: function react(module, exports) {
    module.exports = require("react");
  },
  "react-focus-lock": function reactFocusLock(module, exports) {
    module.exports = require("react-focus-lock");
  },
  "react-helmet": function reactHelmet(module, exports) {
    module.exports = require("react-helmet");
  },
  "react-intl": function reactIntl(module, exports) {
    module.exports = require("react-intl");
  },
  "react-router": function reactRouter(module, exports) {
    module.exports = require("react-router");
  },
  "react-router-dom": function reactRouterDom(module, exports) {
    module.exports = require("react-router-dom");
  }
});